const dk = {
  language: 'dk',
  aiChat: {
    title: 'Glow Intelligence',
    close: 'Luk',
    resize: 'Ændr panelets bredde',
    move: 'Træk eller brug piletasterne for at flytte',
    send: 'Send',
    stop: 'Stop',
    placeholder: 'Spørg om, hvordan Glow fungerer…',
    empty: 'Spørg om hvad som helst om, hvordan Glow fungerer.',
    disclaimer:
      'Svarene er genereret af AI og kan være forkerte. Assistenten har ikke adgang til dine forsendelsesdata.',
    error: 'Noget gik galt under svaret.',
    retry: 'Prøv igen',
    helpful: 'Nyttigt',
    notHelpful: 'Ikke nyttigt',
    commentLabel: 'Tilføj en kommentar',
    commentOptional: 'valgfrit',
    commentPlaceholder: 'Hvad var godt eller dårligt ved svaret?',
    feedbackThanks: 'Tak for din feedback.',
    beta: 'Beta',
    thinking: 'Tænker…',
    tools: {
      glossary: {
        running: 'Slår {{detail}} op i ordlisten…',
        used: 'Slog {{detail}} op i ordlisten'
      },
      fallback: {
        running: 'Henter oplysninger…',
        used: 'Hentede oplysninger'
      }
    },
    newChat: 'Ny samtale',
    language: 'Svarsprog',
    copyAnswer: 'Kopiér svaret',
    sources: 'Kilder',
    sourceUpdated: 'Opdateret {{date}}',
    app: { 'internal-frontend': 'Glow', 'customer-frontend': 'Kundeportalen', tracking: 'Sporing' },
    copied: 'Kopieret',
    history: {
      open: 'Samtalehistorik',
      back: 'Tilbage til samtalen',
      empty: 'Ingen tidligere samtaler.',
      error: 'Kunne ikke indlæse dine samtaler.',
      loadError: 'Kunne ikke indlæse samtalen.',
      delete: 'Slet samtalen »{{title}}«',
      deleteConfirm: 'Slet samtalen »{{title}}«?',
      deleteYes: 'Slet',
      deleteCancel: 'Annuller',
      deleteError: 'Samtalen kunne ikke slettes.'
    },
    suggestions: {
      dispatch: 'Hvordan tildeler jeg forsendelser til en rute?',
      statuses: 'Hvad betyder de forskellige forsendelsesstatusser?',
      recurring: 'Hvordan opretter jeg en tilbagevendende rute?',
      deviation: 'Hvad betyder det, når en forsendelse har en afvigelse?'
    }
  },
  userRoles: {
    admin: 'Admin',
    planner: 'Normal',
    read_only_planner: 'Læs Adgang',
    plus_planner: 'Plus',
    partner: 'Partner',
    customer: 'Kunde',
    customs_agent: 'Toldagent',
    support: 'Support',
    handler: 'Behandler'
  },
  emptyStates: { notFoundTitle: 'Ingen resultater' },
  application: {
    requiredLocation: '*Lokation er påkrævet',
    save: 'Gem',
    all: 'Alle',
    assigned: 'Tildelt',
    created: 'Oprettet',
    selected: 'Valgt',
    filter: 'Filter',
    reset: 'Nulstil',
    cluster: 'Klynge',
    update: 'Opdater',
    required: '*Obligatorisk felt',
    lastUpdated: 'Sidst opdateret',
    requiredShort: '*Obligatorisk',
    endsNextDay: 'slutter næste dag',
    logOut: 'Log ud',
    search: 'Søg...',
    courier: 'Bud',
    drivers: 'Bude',
    consignments: 'Forsendelser',
    status: 'Status',
    address: 'Adresse',
    move: 'Flyt',
    estimatedDepartureTime: 'ETD',
    adjusted: 'Justeret',
    actual: 'Faktisk',
    allSelected: 'Alle valgte',
    someSelected: '{{count}} valgt',
    noneSelected: 'Ingen valgt',
    appBuild: 'App-build',
    lastLogin: 'Seneste login',
    device: 'Enhed',
    model: 'Model',
    os: 'OS',
    units: 'Enheder',
    tracking: 'Sporing',
    trackingPage: 'Modtagers sporingsside',
    phoneNumberShort: 'Tlf. nr.',
    yes: 'Ja',
    no: 'Nej',
    notSelected: 'Ikke valgt',
    sms: 'SMS',
    httpErrorToString: 'HTTP fejl: kode {{status}} {{statusText}}',
    anErrorOccurred: 'En fejl opstod!',
    noAccessTitle: 'Ingen adgang',
    noAccessMessage: 'Du har ikke adgang til at bruge denne funktionalitet',
    autoComplete: 'Søg efter adresse...',
    autoCompleteWithoutDots: 'Søg efter adresse',
    totalWeight: 'Total vægt',
    totalVolume: 'Total volumen',
    validDeviationCode: 'Indtast venligst en gyldig værdi',
    columns: 'Kolonner',
    title: {
      siteName: 'Glow',
      root: 'Velkommen',
      planner: 'Planlægning',
      admin: 'Administrator',
      settings: 'Indstillinger',
      plannerLive: ' Planlægning - Live',
      plannerLiveSlot: ' Planlægning - Live - Rute',
      plannerCouriers: ' Planlægning - Bud',
      templateRouteRules: 'Planlægning - Administrer ruteregler',
      plannerUnits: 'Planlægning - Enheder',
      plannerImport: 'Planlægning - Importere',
      plannerUnresolved: 'Planlægning - Uløste',
      plannerCoordinates: 'Planlægning - Indstil koordinater',
      plannerConsignments: 'Planlægning - Forsendelser',
      plannerSearch: 'Planlægning - Søg',
      plannerPlanning: 'Planlægning - Planlægning ',
      waybills: 'Planlægning - Fragtbreve',
      deliveryNotes: 'Planlægning - Følgesedler',
      plannerInvoicing: 'Planlægning - Fakturering',
      plannerCreateBillingOrder: 'Planlægning - Opret faktureringsordre',
      plannerEditBillingOrder: 'Planlægning - Rediger faktureringsordre',
      plannerCreateCreditNote: 'Planlægning - Opret kreditnota',
      plannerCopyToBillingOrder: 'Planlægning - Opret kopi til faktureringsordre',
      plannerVehicle: 'Planlægning - Vehicles',
      report: 'Rapporter',
      customerDepartmentLive: 'Live oversigt',
      recipient: 'Pakkesporing - Sporing - Bring',
      instant: 'Ad Hoc',
      instantBooking: 'Booking',
      h2Booking: 'H2 Booking',
      orderConfirmation: 'Ordrebekræftelse',
      customerPortal: 'Kundeportal',
      financial: 'Finansielle rettigheder',
      readAny: 'Læseadgang til alt',
      instantMap: 'Realtids kort',
      instantMap2: '$t(application.title.instantMap)',
      recurringOrder: 'Gentagne ordrer',
      corrections: 'Ordre korrektioner',
      jobs: 'Job overvågning',
      holidays: 'Helligdage',
      shipmentLabels: 'Sendingsetiketter',
      addresses: 'Adresser',
      shd: 'SHD',
      preadvice: 'Preavisering',
      apollo: 'Apollo',
      routeReceiptList: 'Kvitteringsliste',
      routesOverview: 'Ruteoversigt',
      loadList: 'Læsseliste',
      pickupOrders: 'Afhentningsordrer',
      customerBooking: 'Kundebooking',
      manageReturns: 'Administrer returneringer',
      preAdviceFollowup: 'Administrer forudanmeldelse',
      integrations: '$t(apolloAdmin.title)',
      parcelHub: '$t(parcelHubAdmin.title)',
      recurring: 'Planlægning - Tilbagevendende'
    },
    language: { en: 'Engelsk', nb: 'Norsk', sv: 'Svensk', dk: 'Dansk', fi: 'Finsk', fr: 'Fransk' },
    country: {
      AllCountry: 'Alle lande',
      Country: 'Land',
      AD: 'Andorra',
      AT: 'Østrig',
      BE: 'Belgien',
      BA: 'Bosnien-Hercegovina',
      BG: 'Bulgarien',
      HR: 'Kroatien',
      CZ: 'Tjekkiet',
      DK: 'Danmark',
      GB: 'Det Forenede Kongerige',
      EE: 'Estland',
      FO: 'Færøerne',
      FI: 'Finland',
      FR: 'Frankrig',
      DE: 'Tyskland',
      GI: 'Gibraltar',
      GR: 'Grækenland',
      HU: 'Ungarn',
      IS: 'Island',
      IE: 'Irland',
      IT: 'Italien',
      LV: 'Letland',
      LT: 'Litauen',
      LU: 'Luxembourg',
      MK: 'Nordmakedonien',
      MT: 'Malta',
      MC: 'Monaco',
      ME: 'Montenegro',
      NL: 'Holland',
      NO: 'Norge',
      PL: 'Polen',
      PT: 'Portugal',
      RO: 'Rumænien',
      RU: 'Rusland',
      SM: 'San Marino',
      RS: 'Serbien',
      SK: 'Slovakiet',
      SI: 'Slovenien',
      ES: 'Spanien',
      SE: 'Sverige',
      CH: 'Schweiz',
      UA: 'Ukraine'
    },
    timeDistance: 'Planlagt tid og afstand',
    driverReturnToAddress: 'Angiv ikke en returadresse',
    distance: 'Afstand',
    helpLink: '(Hvad er dette?)',
    none: 'Ingen',
    noOptions: 'Ingen valgmuligheder',
    groups: 'Grupper',
    departments: 'Afdelinger',
    selectAll: 'Vælg alle',
    totalCustomerPrice: 'Samlet kundepris',
    totalUnitPrice: 'Samlet enhedspris',
    notFound: 'Ikke fundet'
  },
  serviceLevel: {
    notSet: 'Ikke valgt',
    none: 'Af',
    standard: 'Standard',
    premium: 'Premium',
    label: 'Nedgradere serviceniveau',
    ingress:
      'Angiv en standard e-mailadresse, der kan modtage en notifikation ved ordreregistrering, afhentning og/eller levering.'
  },
  dropdown: {
    nrSelected: '{{count}} valgt',
    nrSelected_other: '{{count}} valgt',
    selectedCustomers: '{{count}} kunde',
    selectedCustomers_other: '{{count}} kunder',
    allCustomers: 'Alle kunder',
    filterCustomers: 'Filtrere kunder',
    selectedDepartments: '{{count}} afdeling',
    selectedDepartments_other: '{{count}} afdelinger',
    allDepartments: 'Alle afdelinger',
    filterDepartments: 'Filterafdelinger',
    selectedServiceCodes: '{{count}} tjeneste',
    selectedServiceCodes_other: '{{count}} tjenester',
    allServiceCodes: 'Alle tjenester',
    filterServiceCodes: 'Filtertjenester',
    selectedVasCodes: '{{count}} vas',
    selectedVasCodes_other: '{{count}} vases',
    allVasCodes: "Alle VAS'er",
    filterVasCodes: "Filtrér VAS'er",
    selectedDestinations: '{{count}} destination',
    selectedDestinations_other: '{{count}} destinationer',
    filterSelfBillingUnitIds: 'Filtrer selvfaktureringsenheds-id',
    allSelfBillingUnitIds: 'Alle selvfaktureringsenheds-id',
    selectedSelfBillingUnitIds: '{{count}} selvfaktureringsenheds-id',
    selectedSelfBillingUnitIds_other: '{{count}} selvfaktureringsenheds-id'
  },
  button: {
    actions: 'Handlinger',
    edit: 'Rediger',
    back: 'Tilbage',
    cancel: 'Annuller',
    confirm: 'Bekræfte',
    done: 'Færdig',
    clear: 'Ryd',
    close: 'Luk',
    save: 'Gem',
    saveAndPublish: 'Gem og udgiv',
    delete: 'Slet',
    export: 'Eksport',
    new: 'Lav ny',
    search: 'Søg',
    add: 'Tilføj',
    remove: 'Fjern',
    assign: 'Tildel',
    fullEdit: 'Fuld redigering',
    continue: 'Fortsæt',
    copy: 'Kopiér',
    continueAndSave: 'Fortsæt og gem',
    triggerRollout: 'Udløs udrulning',
    triggerRolloutAgain: 'Udrul igen',
    clearAll: 'Ryd alle',
    selectAll: 'Vælg alle'
  },
  modals: {
    preplan: {
      create: 'Forudplanlæg forsendelse',
      change: 'Ændre forudplanlagt chauffør',
      shipmentInfo: 'Forudplanlæg forsendelse {{shipmentId}} ({{pickupName}} til {{deliveryName}})',
      pickDriver: 'Vælg et bud..',
      unpreplan: 'Ophæv forudplanlægning',
      preplan: 'Forudplanlæg',
      error: 'Kunne ikke forudplanlægge forsendelsen',
      notification: {
        preplanned: 'Forudplanlagt',
        unpreplanned: 'Forudplanlæggelse ophævet',
        preplannedMessage: 'Forsendelse forudplanlagt til {{courierId}}',
        unpreplannedMessage: 'Forudplanlægningen på forsendelsen er ophævet'
      }
    },
    maps: {
      save: 'Gem',
      cancel: 'Annuller',
      delete: 'Slet',
      editMode: 'Rediger',
      mapArea: '{{routeName}} kortområde',
      saved: 'Gemt',
      deleted: 'Slettet'
    }
  },
  consignment: {
    packageType: 'Pakke type',
    palletFootprints: 'Pallplads',
    loadingMeters: 'Lastmeter',
    includePreAdvice: 'Preavisering',
    onlyFailedPreAdvice: 'Preavisering fejlet',
    onlyReturnPreAdvice: 'Retur til afsender',
    search: 'Forsendelsessøgning',
    noShipmentsFound: 'Ingen forsendelser fundet',
    clickButtonToSearch: 'Klik på søg knappen for at søge',
    consignmentsForDate: 'Forsendelser {{date}}',
    showOnlyEditable: 'Kun redigerbare',
    showOnlyNotAssigned: 'Ikke behandlet',
    withoutDate: 'Uden dato',
    extendedSearch: 'Udvidet søgning',
    showDeleted: 'Vis slettede',
    showDeviated: 'Vis afvegne',
    deletedBy: 'Slette af',
    deletionReason: 'Årsag',
    numberOfConsignments: 'Fandt {{number}} forsendelser',
    showAll: 'Alle',
    delivery: 'Leveres',
    pickup: 'Opsamling',
    pickups: '{{count}} opsamling',
    pickups_other: '{{count}} opsamlinger',
    edit: 'Rediger',
    deleteOrders: 'Slet',
    duplicateOrder: 'Kopiere',
    duplicateConfirmation: 'Er du sikker på, at du vil duplikere denne ordre?',
    orderDuplicated: 'Ordren er blevet duplikeret',
    orderDuplicatedFailed: 'Ordren kunne ikke duplikeres',
    copyOrder: 'Kopier',
    editOrder: 'Rediger',
    cantDeleteOfferedOrders: 'Du kan kun slette kommende ordrer, der endnu ikke er tilføjet til en rute',
    cantEditOfferedOrders: 'Du kan kun redigere kommende ordrer, der endnu ikke er tilføjet til en rute',
    onlyCopyOne: 'Du kan kun kopiere én ordre ad gangen',
    onlyEditOne: 'Du kan kun redigere én ordre ad gangen',
    deletedOrderNotCopyable: 'Slettet ordre kan ikke kopieres da der mangler ordredetaljer i Glow',
    restoreOrder: 'Gendan',
    deletedOrderNotRestorable: 'Slettet ordre kan ikke gendannes da der mangler ordredetaljer i Glow',
    preplan: 'Preplan',
    deleteConfirmation: 'Er du sikker på, at du vil slette denne forsendelse?',
    deleteMultipleConfirmation: 'Er du sikker på at du vil slette valgte forsendelser?',
    copyConfirmation: 'Er du sikker på, at du vil kopiere denne forsendelse?',
    editConsignment: 'Rediger forsendelsesoplysninger',
    changeDateAndTime: 'Ændr dato og tid',
    searchShipments: 'Søg i forsendelser:',
    filterBy: 'Sorter efter:',
    searchCustomers: 'Søg i kunder:',
    excelExportRemoved:
      'Det vil ikke længere være muligt at eksportere til Excel fra denne side. Brug i stedet <0>Import / Export</0>-siden eller <0>SAGA</0>. Dette er en del af en større opdatering, hvor flere funktioner vil blive fjernet over tid, før siden til sidst lukkes ned. Alt arbejde skal udføres på <1>denne side</1>.',
    limitedShipmentsShownMessage: 'Viser maksimalt {{count}} forsendelser, overvej at indsnævre din søgning',
    limitedUnresolvedAddressesShownMessage: 'Der kan højst vises {{count}} uløste adresser',
    bulkActions: 'Ændre forsendelser',
    bulkActionsMultiple: 'Ændre forsendelser ({{count}})',
    addToRecurringGroup: 'Føj til den tilbagevendende opgave',
    moveShipmentsToDifferentDepartment: 'Flyt til en anden afdeling',
    addEvents: 'Tilføj handling',
    disabledEditDeleteHelperText:
      'Denne ordre kan ikke redigeres eller slettes, kontakt venligst dit lokale Bring kontor for at ændre i ordren.',
    editPickupConsignment: 'Opdater opsamlingsoplysninger',
    editDeliveryConsignment: 'Opdater leveringsoplysninger',
    editPickupAndDeliveryTime: 'Opdater afhentnings- og leveringstider',
    editConsignmentLocation: 'Lokation',
    editConsignmentTime: ' Tid',
    editConsignmentName: ' Navn',
    editConsignmentPhone: ' Telefonnummer',
    editConsignmentInstructions: ' Instruktioner',
    earliestPickupTime: 'Tidligste opsamlingstidspunk*',
    latestPickupTime: 'Seneste opsamlingsstidspunkt *',
    earliestDeliveryTime: 'Tidligste leveringstid',
    latestDeliveryTime: 'Seneste leveringstid',
    enterPickupInstructions: 'Angiv opsamlingsinstruktioner',
    enterDeliveryInstructions: 'Angiv leveringsinstruktioner',
    enterDeliveryName: 'Angiv Leveringsnavn',
    enterPickupName: 'Angiv opsamlingsnavn',
    enterPickupPhone: 'Angiv opsamlingstelefonnummer',
    enterDeliveryPhone: 'Angiv leveringstelefonnummer',
    specificationSize: 'Specifikationsstørrelse',
    enterSpecificationSize: 'Indtast specifikationsstørrelse',
    editSpecificationSize: 'Rediger specifikationsstørrelse',
    enterSpecificationDescription: 'Indtast beskrivelse',
    editSpecificationDescription: 'Rediger beskrivelse',
    editPickupInfoDescription: 'For at kunne redigere info skal du vælge en af ovenstående muligheder',
    updateLocationFor: 'Opdater information for {{count}} forsendelser',
    updateLocationFor_other: 'Opdater opsamlingsoplysninger for {{count}} forsendelser',
    comment: 'Kommentar',
    show: 'Vis',
    filter: 'Filtrer forsendelser',
    state: 'Status',
    estimatedDelivery: 'Forventet levering',
    requestedTimePickup: 'Anmodet opsamlingstidspunkt',
    requestedTimeDelivery: 'Anmodet leveringstidspunkt',
    timeNotSet: 'Ikke indstillet',
    customerReference: 'Kundereference',
    shipmentId: 'Forsendelsesnummer',
    packageId: 'Pakkenummer',
    noCourier: 'Intet bud',
    noSlot: 'Ingen rute',
    showEvents: 'Vis hændelser →',
    hideEvents: 'Skjul hændelser ←',
    events: 'Hændelser',
    send: 'Send',
    sendMessage: 'Send besked',
    sendCommentFailed: 'Kunne ikke gemme kommentar',
    recipient: 'Modtager',
    unresolved: 'Ufærdiggjort forsendelse',
    description: 'Beskrivelse',
    pickupAddress: 'Opsamlingsadresse',
    numberOfPackages: 'Antal pakker',
    registeredPickupAddress: 'Registreret opsamlingsadresse',
    pickupZipCode: 'Postnummer',
    pickupZipArea: 'Område',
    deliveryAddress: 'Leveringsadresse',
    deliveryZipCode: 'Postnummer',
    deliveryZipArea: 'By',
    deliveryLocation: 'Lokation',
    registeredDeliveryAddress: 'Registreret leveringsadresse',
    updated: 'Forsendelsen er opdateret',
    moved: 'Forsendelsen er blevet flyttet',
    unresolvedMessage: 'Der er {{count}} forsendelse, hvor vi ikke kan finde adressen, venligst tilføj den.',
    unresolvedMessage_other: 'Der er {{count}} forsendelser, hvor vi ikke kan finde adressen, venligst tilføj dem.',
    foundUnresolvedMessage:
      'Vi har fundet følgende gyldige addresser til denne forsendelse. Hvis de er korrekte, skal du trykke på opdater. Ellers finder du den rigtige adresse på nedenstående kort.',
    remove: 'Fjern',
    optimizingNewSlot: 'Optimering af forsendelse på ny rute',
    slotSelect: 'Vælg rute',
    pickupInstructions: 'Opsamlingsinstruktioner',
    deliveryInstructions: 'Leveringsinstruktioner',
    specificationDescription: 'Beskrivelse',
    tracking: 'Sporing',
    recipientPhone: 'Modtagerens telefonnummer',
    customerRef: 'Kundereference',
    service: 'Tjeneste',
    message: {
      CREATED: 'Oprettet',
      ASSIGNED: 'Tildelt til rute',
      UNASSIGNED: 'Ikke tildelt til rute',
      COLLECTED: 'Opsamlet',
      DELIVERED: 'Leveret',
      DEVIATED: 'Afveget',
      COMMENT: 'Kommentar',
      RESOLVED: 'Løst',
      UNRESOLVED: 'Uløst',
      OFFERED: 'Tilbudt',
      REJECTED: 'Afvist',
      ACCEPTED: 'Accepteret',
      RETURNED: 'Returneret',
      DELETED: 'Slettet',
      UNCONFIRMED: 'Ubekræftet',
      REFUSED: 'Afvist'
    },
    adjustTabTitle: 'Redigere',
    bookingPanelTitle: 'Booking',
    mapPanelTitle: 'Kort',
    recipientName: 'Modtagers navn',
    receivedBy: 'Modtaget af:',
    manuallyChangeLocations: 'Skift placering manuelt',
    manualOverrideDeviationTimeConfirm: 'Bekræft manuel afvigelse for valgte forsendelse',
    manualOverrideDeliveryTimeConfirm: 'Bekræft manuel levering for valgte forsendelse',
    onManuallyChangeLocationsConfirm: 'Er du sikker på at du vil gøre forsendelsen uløst?',
    unresolveDeliveryAddress: 'Gør leveringsadressen uløst',
    unresolvePickupAddress: 'Gør opsamlingsadressen uløst',
    unresolveAddress: 'Gør adresse uløst',
    reference: 'Reference',
    shipmentIdNumber: 'Nr',
    shipmentDetails: 'Forsendelsesoplysninger',
    customer: 'Kunder',
    subcustomer: 'Kunde nr.',
    dateAndTime: 'Dato og tid',
    filterCustomer: 'Filtrer kunde',
    searchShipmentDateError: 'Indtast datointerval under 120 dage.',
    searchPhraseLength: 'Søgefraser bør være mindst {{minLength}} tegn for en udvidet søgning.',
    moveOrder: 'Flyt forsendelse',
    moveOrderTitle: 'Flyt forsendelse til en anden afdeling',
    moveOrderDefault: 'Vælg afdeling',
    label: 'Etiket',
    createLabel: 'Opret label',
    createDeliveryLabel: 'Opret leveringsetiket',
    createLabelShipment: 'Opret label (Forsendelse)',
    createMultipleLabel: 'Opret label ({{count}})',
    viewLabel: 'Se label',
    viewLabels: 'Se labels',
    generateLabelError: 'Fejl: {{error}}',
    generateLabelErrorTitle: 'Noget gik galt',
    generatingLabels: 'PDF label links vil være tilgængelige nedenfor om et øjeblik...',
    labelsGeneratedSuccessfully: 'Etiketterne blev genereret',
    generateLabelErrorDescription: 'Der kan desværre ikke genereres labels på nuværende tidspunkt',
    generateLabelErrorButton: 'Vis fejlkode',
    vas: 'Tillægstjenester (VAS)',
    price: 'Pris',
    orderSources: {
      expressit: 'ExpressIT',
      glow: 'GLOW',
      glow_customerBooking: 'GLOW Kunde booking',
      glow_excelImportV2: 'GLOW Excel',
      excel: 'GLOW Excel',
      HappyFlow: 'Happy Flow',
      '98466118503': 'Mybring',
      '98466118504': 'Mybring',
      glow_recurring: 'Gentagne',
      ShipmentAPI: 'Shipment API',
      others: 'EDI'
    },
    pickupDeviation: 'Afhentningsafvigelse',
    deliveryDeviation: 'Leveringsafvigelse',
    shipmentSyncStatus: { yes: 'Ja', no: 'Nej', partial: 'Delvis' },
    selectOtherActions: 'Vælg andre handlinger'
  },
  eventsList: { timeWindow: 'Tidsvindue', from: 'Fra', to: 'Til' },
  status: {
    started: 'Startet',
    notStarted: 'Ikke startet'
  },
  consignmentEvent: {
    message: {
      'auto-dispatch-succeeded': 'Automatisk tildeling af opgaver startet',
      'auto-dispatch-failed': 'Automatisk tildeling af opgaver mislykkedes',
      'optimizing-failed': 'Ruteoptimering fejlede',
      'order-excluded-from-invoicing': 'Udelukket fra fakturering',
      'reoptimized-with-fallback-window': 'Rute automatisk genoptimeret',
      routeName: 'Rutenavn',
      resolved: 'Adressekoordinater sat',
      unresolved: 'Adressekoordinater er ikke angivet',
      'pre-advice-status-changed': 'Preaviseringsstatus ændret',
      'reported-damaged': 'Skade meldt',
      'reported-missing-article': 'Manglende vare(r) meldt',
      comment: 'Kommentar',
      created: 'Oprettet',
      completed: 'Afsluttet',
      assigned: 'Tildelt',
      plannedOnRoute: 'Planlagt til rute',
      plannedOnRouteMoreInfo: 'Planlagt til rute {{routeName}} ({{unitName}})',
      optimizeProviderId: 'Optimerings-ID',
      noOptimizationEngine: 'Ingen optimeringsmotor',
      failedOptimizeProviderId: 'Mislykket optimerings-ID',
      retryOptimizeProviderId: 'Optimerings-ID for nyt forsøg',
      optimizationTimeWindow: 'Tidsvindue for optimering',
      extendedBy: 'Forlænget med {{minutes}} min',
      optimizingFailedOtherNotPlanned: 'En anden forsendelse på ruten kunne ikke planlægges',
      optimizingFailedError: 'Optimeringen stoppede med en fejl',
      delivered: 'Leveret',
      collected: 'Opsamlet',
      returned: 'Returneret',
      deviated: 'Afviget',
      damaged: 'Skadet',
      notification: 'Notifikation',
      slotChanged: 'Rute ændret manuelt',
      unassigned: 'Fjernet fra bud',
      rejected: 'Afvist',
      image: 'Billede',
      error: 'Fejl',
      started: 'Startet',
      stopped: 'Afsluttet',
      accepted: 'Accepteret',
      offered: 'Tilbudt',
      unitName: 'Enhed',
      nameOfUnit: 'Enhedens navn',
      driverName: 'Bud',
      'delivery-id-check': 'ID tjek',
      'deviation-sms-sent': 'Afvigelses-SMS sendt',
      'delivered-manually-overridden': 'Levering manuelt tilpasset',
      'order-released-for-invoicing': 'Fakturering frigivet',
      'order-paused-from-invoicing': 'Fakturering sat på pause',
      'manually-set-invoicing-ok-for-order-invoicing': 'Faktureret OK',
      'manually-set-not-invoiced-for-order-invoicing': 'Ikke faktureret',
      'manually-set-excluded-from-invoicing': 'Udelukket fra fakturering',
      'unit-manually-added-for-invoicing': 'Enhed tilføjet manuelt',
      'deviated-manually-overridden': 'Afvigelse manuelt tilpasset',
      'collected-manually-overridden': 'Afhentning ændret manuelt',
      'pickup-location-changed': 'Opsamlingsadresse ændret',
      'delivery-time-estimated': 'Opdateret leveringstid',
      'slot-manually-changed': 'Rute manuelt tilpasset',
      'pickup-time-changed': 'Opsamlingstidspunkt ændret',
      'manually-change-location': 'Manuel tilpasning af placering',
      'pickup-consignment-data-changed': 'Opsamlingsoplysninger ændret',
      'delivery-consignment-data-changed': 'Leveringsoplysninger ændret',
      'specification-size-data-changed': 'Størrelsesspecifikationer ændret',
      'specification-description-data-changed': 'Oplysninger ændret',
      'delivery-time-purchased': 'Mersalg: Specifikt tidsrum bestilt af modtager',
      'digital-identity-verified': 'Modtagers identitet bekræftet digitalt',
      'digital-identity-verification-failed': 'Kunne ikke verificere modtagerens identitet digitalt',
      'flex-delivery-ordered': 'Forenklet levering bestilt af modtagert',
      'flex-delivery-ordered-by-sender': 'Forenklet levering bestilt af afsender',
      'flex-delivery-changed': 'Forenklet levering ændret',
      'flex-delivery-confirmation-sms-sent': 'Flex levering bekræftelses SMS afsendt',
      'flex-delivery-confirmation-app-notification': 'Push-meddelelse for flex leveringsbekræftelse sendt',
      'return-to-pickup-point-delivery-deviated': 'Vil blive afleveret til udleveringsstedet',
      recipientName: 'Modtagers navn',
      receivedBy: 'Modtaget af',
      'reject-order-correction': 'Afvist ordrekorrektion',
      'accept-order-correction': 'Accepteret ordrekorrektion',
      'handed-over-to-other-unit': 'Overgivet til anden unit',
      'handed-over': 'Overgivet til anden unit',
      deliveredWithoutSignature: 'Leveret uden signatur',
      deliveredWithoutSignatureReason: {
        left_package_outside: 'Placeret som instrueret',
        did_not_get_signature: 'Personligt',
        DELIVER_IN_PERSON: 'Personligt'
      },
      'returned-manually-overridden': 'Manuel ændring af retur',
      'eta-sms-sent': 'ETA SMS sendt',
      calculatedEta: 'Beregnet ankomst: {{eta}}',
      etaSmsLabel: 'Beregnet ankomst',
      scanned: 'Ankommet på terminal',
      'arrived-at-terminal': 'Ankommet på distribuerende terminal',
      'order-sorted': 'Sorteret',
      'not-arrived-at-distributing-terminal': 'Ikke ankommet distribusjonsterminal',
      'pickup-eta-sms-sent': 'Opsamlings ETA SMS sendt',
      'handed-in-at-posten-terminal': 'Ankommet til sorteringsterminal',
      'pickup-sms-sent': 'Sporings SMS sendt',
      'pre-pickup-sms-sent': 'Sporings SMS forhåndssendt',
      'pickup-address-unresolved': 'Afhentningsadresse er blevet gjort uløst',
      'delivery-address-unresolved': 'Leveringsadressen er blevet gjort uløst',
      'in-transit': 'I transit',
      'upcoming-pickup-sms-sent': 'SMS for kommende levering sendt',
      'order-sorted-same-day': 'Dato er sat til i dag af terminal app',
      'signature-sms-sent': 'Underskrift SMS afsendt',
      'flex-delivery-cancelled': 'Forenklet levering afbestilt',
      'delivery-time-ordered': 'Leveringsdato ændret af modtager',
      'delivery-time-ordered-internal': 'Leveringsdato ændret',
      'delivery-time-updated-from-hf-sync': 'Leveringstid synkroniseret fra HF',
      'planned-delivery-date-ordered': 'Planlagt leveringsdato bestilt',
      'delay-sms-sent': 'SMS om forsinkelse sendt',
      'production-deviation': 'Produktionsafvigelse',
      'manual-delay-sms-sent': 'Manuel SMS for forsinkelse sendt',
      'route-planning-complete': 'Rute færdig',
      'signature-delivered': 'Underskrift fra modtager',
      showPicture: 'Vis billede',
      'external-address-wash': 'Leveringsoplysninger ændret',
      'order-note-changed': 'Notat ændret',
      'customer-details-changed': 'Kundedetaljer ændret',
      'order-data-changed': 'Ordre ændret',
      'order-moved-to-department': 'Flyttet mellem afdelinger',
      'order-moved-to-department-with-data': 'Forsendelsen er flyttet fra',
      'package-measurements-changed': 'Pakkestørrelse ændret',
      'package-data-changed': 'Pakkedata ændret',
      'driver-deviated-from-route': 'Chaufføren afveg fra ruten',
      'driver-deviated-from-route-at-pickup': 'Chaufføren afveg fra ruten ved afhentning',
      'delivered-outside-service-time-window': 'Levering eller afvigelse udenfor tjenestens tidsvindue',
      'delivered-outside-estimated-time-window': 'Levering eller afvigelse udenfor estimeret tidsvindue',
      'delivered-in-estimated-time-window': 'Levering eller afvigelse indenfor det estimerede tidsvindue.',
      'picked-up-outside-service-time-window': 'Afhentning eller afvigelse udenfor tjenestens tidsvindue',
      'picked-up-outside-estimated-time-window': 'Afhentning eller afvigelse udenfor estimeret tidsvindue',
      'picked-up-in-estimated-time-window': 'Afhentning eller afvigelse indenfor det estimerede tidsvindue.',
      'ordered-delivery-time-set-by-production-time-window': 'Produktionstidsvinduet er sat',
      'seen-by-recipient': 'Sporingsside set af modtager',
      'first-estimated-times-seen': 'Første estimerede tid set af modtager',
      'pre-advice-push-sms-sent': 'Preadvice PUSH-SMS sendt',
      'pre-advice-push-return-sms-sent': 'Preadvice PUSH-RETURN-SMS sendt',
      'pre-advice-pull-sms-sent': 'Preadvice PULL-SMS sendt',
      'pre-advice-pull-email-sent': 'Preadvice PULL-e-mail sendt',
      'pre-advice-pull-reminder-sms-sent': 'Preadvice PULL påmindelses-SMS til modtager sendt',
      'pre-advice-pull-reminder-email-sent': 'Preadvice PULL påmindelses-e-mail til modtager sendt',
      'pre-advice-pup-sms-sent': 'Preadvice PUP-SMS sendt',
      'pre-advice-return-sms-sent': 'Preadvice Return-SMS sendt',
      'pre-advice-return-email-sent': 'Preadvice Return-email sendt',
      'delivery-location-deviation': 'Levering eller afvigelse ikke på forventet sted',
      'pre-advice-pull-reminder-to-sender-email-sent': 'Preadvice PULL påmindelse til afsender epost sendt',
      'pre-advice-pup-reminder-to-sender-email-sent': 'Preadvice PUP påmindelse til afsender epost sendt',
      'pre-advice-return-return-to-sender-email-sent': 'Preadvice RETURN retur til afsender epost sendt',
      'pre-advice-pull-return-to-sender-email-sent': 'Preadvice PULL retur til afsender epost sendt',
      'pre-advice-push-return-email-sent': 'Preadvice PUSH retur til afsender epost sendt',
      'pre-advice-manual-attempt': 'Manuel preadvice-forsøg',
      'pre-advice-manual-request': 'Manual preadvice startet',
      'pre-advice-active-return-to-customer-email-sent': 'Preadvice aktiv retur til kunde, epost sendt',
      'pre-advice-active-return-not-picked-up-email-sent': 'Preadvice aktiv retur ble ikke hentet, epost sendt',
      'pre-advice-active-return-info-to-customer-email-sent':
        'Preadvice e-mail med information om aktiv retur til kunde sendt',
      'pre-advice-passive-return-to-customer-email-sent': 'Preadvice passiv retur til kunde, epost sendt',
      'notification-to-sender-failed': 'Epostvarsel til kunden mislykkedes',
      'delivery-sms-sent': 'Levering SMS sendt',
      'parcelbox-allocated': 'Der er reserveret plads i pakkeboksen',
      unconfirmed: 'Ubekræftet',
      refused: 'Afvist',
      'accepted-by-planner': 'Accepteret',
      'apartment-information-updated': 'Lejlighedsoplysninger opdateret',
      'lock-code-entered': 'Dørkode indtastet',
      'invoicing-failed': 'Fakturering mislykkedes',
      'invoiced-ok': 'Fakturering OK',
      'invoice-awaiting-acknowledgement': 'Afventer ordrebekræftelse',
      'parcel-locker-delivery-selected': 'Pakkeboks valgt',
      'cancelled-parcel-locker-delivery': 'Pakkeboks annulleret',
      'pre-advice-result': 'Preavisering',
      'order-credited': 'Ordre krediteret',
      'parcel-locker-tracking-sms-sent': 'Sporings-SMS for pakkeboks sendt',
      'time-window-cancelled-by-recipient': 'Tidsvindue annulleret af modtager',
      'hd-multileg-return-created': 'Returleveringsben oprettet',
      'hd-multileg-return-failed': 'Returleveringsben mislykkedes',
      'invoice-acknowledged-by-external-system': 'Ordre bekræftet af eksternt system',
      'invoice-created-in-external-system': 'Faktura oprettet i eksternt system',
      'invoice-sent-to-customer': 'Faktura sendt til kunde',
      'invoice-paid-by-customer': 'Faktura betalt af kunde',
      'invoice-due-date-updated': 'Fakturaens forfaldsdato opdateret',
      'invoice-paid-to-vendor': 'Faktura betalt til leverandør',
      'customer-invoiced': 'Kunde faktureret',
      'service-upgrade-purchased': 'Mersalg: Indbæring bestilt af modtager',
      serviceUpgradePurchasedDescription: 'Indbæring bestilt af modtageren',
      'claim-registered-email-sent': 'E-mail om registreret reklamation sendt',
      'preliminary-loaded': 'Foreløbigt lastet',
      selfBillingUnitId: 'Self-billing unit ID',
      selfBillingUser: 'Bruger',
      'manual-price-override': 'Pris overskrevet',
      'incomplete-price-approved': 'Ufuldstændig pris godkendt',
      'incomplete-price-unapproved': 'Godkendelse af ufuldstændig pris tilbagekaldt',
      'b2r-return-order-created': 'B2R-returordre oprettet',
      unloaded: 'Aflæsset',
      'manually-changed-measurements': 'Manuel ændret vægt og volumen',
      'internal-trade-order-created': 'Intern handelsordre oprettet',
      'load-carrier-ready-for-distribution': 'Lastebærer klar til distribution',
      'bom-articles-muted': 'BOM PU/DEL undtaget fra fakturering',
      'bom-articles-unmuted': 'BOM PU/DEL ikke undtaget fra fakturering.',
      'pickup-app-notification': 'Push-meddelelse for sporing sendt',
      'duplicate-order-created': 'Duplikeret ordre oprettet',
      'ready-for-pickup': 'Klar til afhentning (PUP på terminal)',
      'return-address-updated': 'Returadresse opdateret',
      restored: 'Gendannet',
      'manually-marked-as-handled': 'Retur markeret som håndteret',
      'recipient-phone-number-updated': 'Modtagerens telefonnummer opdateret',
      'recipient-email-address-updated': 'Modtagerens e-mailadresse opdateret'
    },
    cause: {
      plannedStop: 'Afhentningsoplysningerne er blevet opdateret, fordi ordren blev læsset på et planlagt stop',
      planToScan: 'Leveringsinformationen er blevet opdateret, fordi forsendelsen blev scannet på ruten',
      adhocHenteordre:
        'Leveringsoplysningerne er blevet opdateret, fordi ruten har en anden slutadresse end terminalen',
      sorted: 'Leveringsinformationen er blevet opdateret, fordi forsendelsen blev sorteret',
      shipmentDelayed: 'Leveringsinformationen er blevet opdateret, fordi forsendelsen er forsinket',
      movedToNextWorkingDay: 'Flyttet til næste hverdag',
      optimizedInLoadCarrier:
        'Leveringsinformationen er blevet opdateret, fordi forsendelsen blev ruteplanlagt som en del af en lastbærer'
    },
    source: 'Kilde',
    unassignedReason: 'Årsag',
    returnAddressSource: {
      OrderSource: 'Returadressen, som kunden har angivet i bookingfilen, bruges',
      CustomerAdmin: 'Returadressen, der er konfigureret i Customer Admin, bruges',
      SenderAddress: 'Der er ikke angivet nogen returadresse i kundens bookingfil, afsenderens adresse bruges'
    },
    rejectedReason: {
      reason: 'Årsag',
      private: 'Private årsager',
      notEnoughTime: 'Kan ikke nå stoppet inden for tiden',
      notEnoughSpaceOnVehicle: 'Bilen har ikke kapacitet til godset',
      other: 'Anden',
      CJ: '$t(consignmentEvent.rejectedReason.notEnoughSpaceOnVehicle)',
      CK: '$t(consignmentEvent.rejectedReason.other)',
      CL: '$t(consignmentEvent.rejectedReason.notEnoughTime)',
      OL1: 'Ikke på ruten',
      OL2: 'Ikke nok plads i bilen',
      OL3: 'Ikke nok tid',
      OL4: 'Godset blev ikke fundet',
      OL5: 'Planlagt til senere, men der er ingen terminalstop tilbage',
      comment: 'Kommentar'
    },
    idCheck: {
      idCheckFailed: 'ID control mislykkedes, men blev leveret med {{idCheckFailedResult}}',
      idCheckSummaryOther: 'Anden ({{otherType}}), fødselsdato {{birthDate}}',
      idCheckSummary: '{{idCheckType}}, fødselsdato {{birthDate}}',
      idCheckSummaryOtherLabel: 'Anden ({{otherType}})',
      idCheckValue: 'Fødselsdato {{birthDate}}'
    },
    damaged: {
      damageType: 'Type skade',
      courierInput: 'Besked fra budet',
      showPictureLink: 'Vis billede {{idx}}',
      type: { A: 'Skade på æske/emballage', D: 'Tryk/klemskade', E: 'Totalskadet' }
    },
    invoiceInitiationType: {
      automatic: 'Planlagt fakturering',
      'manual-department-level': 'Manuel afdelingsfakturering',
      'manual-order-level': 'Manuel ordrefakturering',
      'multiple-order-level': 'Manuel fakturering af flere ordrer'
    },
    autoDispatchFailedReason: {
      NO_MATCHING_ROUTE: 'Ingen matchende rute fundet',
      DISPATCH_REJECTED: 'Kunne ikke planlægge optimering',
      RETRIES_EXHAUSTED: 'Alle forsøg mislykkedes'
    },
    excludedFromInvoicingReason: {
      UNIT_NOT_SELF_BILLING_WITH_INTERNAL_TRADE:
        'Udelukket automatisk, fordi enheden ikke har både aflønning og intern handelstransaktion aktiv'
    },
    autoDispatchSucceeded: {
      matchedRange: 'Matchet postnummerinterval: {{from}}-{{to}}.',
      matchedPostalCode: 'Matchet postnummer: {{code}}.',
      viewRuleDetails: 'Se regeldetaljer <a>her</a>',
      sentForOptimization:
        'Ordren matchede en regel for automatisk tildeling af opgaver og er blevet sendt til ruteoptimering.'
    },
    invoiceCallback: {
      timeOfTransaction: 'Transaktionstidspunkt',
      transactionNumber: 'Transaktionsnummer i {{systemId}}',
      invoiceLink: 'Klik for at se faktura'
    },
    changedFrom: 'Ændret fra -',
    blankText: '(tom)',
    name: 'Navn',
    deliveryOrderedByReceiver: 'Levering til pakkeboks bestilt af modtager',
    invoiceEventReason: {
      manuallySetByUser: 'Manuelt angivet af bruger',
      manualInvoiceInfo: 'Sat automatisk på pause, fordi der er angivet manuelle fakturaoplysninger på ordren'
    },
    unresolved: {
      missingPickupCoordinates: 'Manglende afhentningskoordinater',
      missingDeliveryCoordinates: 'Manglende leveringskoordinater'
    },
    resolved: {
      source: {
        DepartmentLocation: 'koordinater på afdeling',
        GeocodingAPI: 'Google',
        DatabaseLookup: 'lagrede koordinater',
        PickupPointAPI: 'Pickup Point API',
        GlowFrontend: 'Glow',
        EDI: 'ukendt',
        CustomerSite: 'kundens placering',
        ParcelHub: 'ParcelHub',
        ParcelInMailbox: 'postkassens placering',
        Driver: 'chauffør',
        OriginalOrder: 'Original ordre',
        Google: 'Google',
        GoodsReturnAddress: 'vare returadresse'
      },
      pickup: {
        coordinatesSetBy: 'Afhentningskoordinater angivet af {{source}}',
        coordinatesManuallySet: 'Afhentningskoordinater er manuelt angivet',
        coordinatesRestored: 'Afhentningskoordinater gendannet',
        coordinatesSwapped: 'Afhentningskoordinater sat til tidligere leveringskoordinater'
      },
      delivery: {
        coordinatesSetBy: 'Leveringskoordinater angivet af {{source}}',
        coordinatesManuallySet: 'Leveringskoordinater er manuelt angivet',
        coordinatesRestored: 'Leveringskoordinater gendannet',
        coordinatesSwapped: 'Leveringskoordinater sat til tidligere afhentningskoordinater'
      }
    },
    created: {
      recurringOrder: 'Oprettet fra en tilbagevendende ordre.',
      showOriginalOrder: 'Vis originalen',
      recurringRoute: 'Oprettet fra tilbagevendende rute',
      recurringRouteLink: 'til ruteopsætning',
      showDuplicate: 'Vis duplikeret ordre',
      showOrder: 'Vis ordre',
      fromThisOrder: 'Oprettet fra denne ordre',
      fromOrder: 'Oprettet fra ordre'
    },
    outsideTimeWindow: {
      'delivered-outside-estimated-time-window': 'Anslået tidsvindue',
      'delivered-in-estimated-time-window': 'Anslået tidsvindue',
      'delivered-outside-service-time-window': 'Servicetidsvindue',
      'picked-up-outside-estimated-time-window': 'Anslået tidsvindue',
      'picked-up-in-estimated-time-window': 'Anslået tidsvindue',
      'picked-up-outside-service-time-window': 'Servicetidsvindue',
      actual: 'Faktisk levering eller afvigelse',
      actualPickup: 'Faktisk afhentning eller afvigelse'
    },
    deliveryInstructions: 'Leveringsinstruktioner'
  },
  jobs: {
    job: 'Job',
    lastStarted: 'Sidst startet',
    lastFinished: 'Sidst afsluttet',
    maxDuration: 'Maks varighed',
    timeBetweenRuns: 'Tid mellem kørsel',
    disable: 'Deaktiver',
    enable: 'Aktiver',
    disabled: 'Deaktiveret',
    disabledInConfig: 'Deaktiveret i konfiguration',
    mustBeASuperAdmin: 'Du skal være superadministrator for at deaktivere og aktivere jobs',
    showOnlyStruggling: 'Vis kun jobs med problemer',
    runningLongerThanExpected: 'Kører længere end forventet',
    notStartedForLongerThanExpected: 'Er ikke startet som forventet'
  },
  numberSeries: {
    numberSeries: 'Nummerserie',
    comparisonError: 'Maksimum skal være større end minimum',
    successfullyAdded: 'Nummerserien blev tilføjet til listen',
    successfullyDeleted: 'Nummerserien blev slettet',
    addNewNumberSeries: 'Tilføj ny nummerserie',
    addedNumberSeries: 'Tilføjede nummerserier',
    addedNumberSeriesSubHeading: 'Tilføj nummerserie (medtag ikke kontrolcifre)',
    selectType: 'Vælg type',
    shipmentNumber: 'GSIN (forsendelsesnummer)',
    packageNumber: 'SSCC (pakkenummer)',
    minimum: 'Minimum',
    maximum: 'Maksimum',
    addNumberSeriesButton: 'Tilføj nummerserie til listen',
    type: 'Type',
    currentNumber: 'Nuværende nummer',
    maxNumber: 'Maks. nummer',
    numbersLeft: 'Resterende numre',
    validMinimumValue: 'Du skal indtaste en gyldig minimumsværdi',
    validMaximumValue: 'Du skal indtaste en gyldig maksimumsværdi',
    deleteModalTitle: 'Slet nummerserie',
    deleteModalDescription: 'Denne handling kan ikke fortrydes'
  },
  preadvice: {
    preadvice: 'Preavisering',
    searchPlaceholder: 'Skriv mindst 3 tegn for at filtrere',
    selectedCustomers: 'Valgte kunder ({{count}})',
    noSelectedCustomers: 'Ingen valgte kunder',
    customerSearch: 'Søgefelt - Indtast mindst 3 tegn for at søge efter kunder',
    settingTargetDepartment:
      'Denne preaviseringsindstilling er målrettet specifikke afdelinger. Fjern alle valgte afdelinger for at kunne skifte indstillingen til afdelingsgrupper',
    settingTargetDepartmentGroups:
      'Denne preaviseringsindstilling er målrettet specifikke afdelingsgrupper. Fjern alle valgte afdelingsgrupper for at kunne skifte indstillingen til afdelinger',
    settingTargetCustomers:
      'Denne preavisering indstilling målretter specifik kunde. Fjern alle valgte kunder for at kunne skifte indstilling til kundgrupper',
    settingTargetCustomerGroups:
      'Denne preaviseringsindstilling er målrettet specifikke kundegrupper. Fjern alle valgte kundegrupper for at kunne skifte indstillingen til kunder',
    conflictHeading: 'Der er konflikter i dine preaviseringsregler',
    conflictingRules: 'Regler i konflikt',
    deletePreadviceDescription:
      'Sletning fjerner alle notifikationsindstillinger, og modtageren eller afsenderen vil ikke længere modtage nogen kommunikation. Handlingen kan ikke fortrydes.',
    rule: 'Regel',
    ruleTrigger: 'Preavisering ved',
    type: 'Type',
    trigger: 'Trigger',
    action: 'Variant',
    customers: 'Kunder',
    customerGroups: 'Kundegrupper',
    customersCount: 'Kunder',
    customerGroupsCount: 'Kundegrupper',
    showGroupMembers: 'Vis gruppemedlemmer',
    departmentsCount: 'Afdelinger',
    departmentGroupsCount: 'Afdelingsgrupper',
    lockNotification: 'Lås notifikation',
    preadviceRule: 'Preaviseringsregel',
    locked: 'Preavisering låst',
    nameOfRule: 'Regelnavn',
    updated: 'Preavisering opdateret',
    nameDescription: 'Navn og beskrivelse',
    createNewPreadvice: 'Opret ny preaviseringsregel',
    bizArea: 'Vælg forretningsområde',
    courierAndExpress: 'Courier and Express (C&E)',
    homeDelivery: 'Hjemmelevering (HD)',
    filterDepartmentAndGroups: 'Filtrer efter afdelinger eller afdelingsgrupper',
    filterCustomersAndGroups: 'Filtrer på kunder eller kundgrupper',
    tabsWithErrors: 'Ret venligst fejlene på følgende faner: {{tabs}}',
    hdDepartments: 'HD departments',
    ceDepartments: 'C&E-afdelinger',
    departmentGroups: 'Afdelingsgrupper',
    noPoliciesFound: 'Ingen preaviseringsindstillinger',
    policies: 'Preaviseringsindstillinger',
    copyText: 'Kopiér tekst',
    customerInGroupTitle: 'Kunder i {{groupName}}',
    policy: {
      servicePoliciesDescription: 'Afhængigt af hvilken type meddelelse du vælger, vises forskellige inputfelter',
      exception: 'Undtagelse',
      deleteConfirm: 'Er du sikker på, at du vil slette dette sæt preaviseringsregler?',
      name: 'Navn',
      new: 'Ny preaviseringsindstilling',
      edit: 'Rediger preaviseringsindstilling',
      description: 'Beskrivelse',
      save: 'Gem',
      saveAnyway: 'Gem alligevel',
      servicePolicies: 'Preaviseringsregler',
      targets: 'Kunde-/afdelingsindstillinger',
      servicePolicy: {
        edit: 'Rediger indstillinger',
        new: 'Tilføj preaviseringsindstillinger for tjeneste',
        cutOff: 'Cutoff',
        remove: 'Fjern valgte',
        serviceCode: 'Tjeneste',
        serviceCodeLegend: 'Add service code e.g. 3123',
        vasCode: 'VAS',
        vasCodeLegend: 'Tilføj eventuel tillægstjeneste, f.eks. SWAP',
        sameDay: 'Samme dag',
        returnToCustomer: 'Retur til kunde',
        reminderToCustomer: 'Påmindelse til kunde',
        redirectToPuP: 'Omdiriger til afhentningssted',
        sameDayTitle: 'Tillad bookinger samme dag før cutoff',
        yesRecipientShouldChange: 'Ja, modtageren skal kunne ændre',
        noRecipientShouldNotChange: 'Nej, modtageren skal ikke kunne ændre',
        recipientCanCancelBookedTimeSlot: 'Modtageren vil kunne annullere det bookede tidsvindue.',
        sameDayLegend: 'Sæt kryds her, hvis forsendelsen skal leveres med Same Day Service.',
        triggerEvent: 'Preavisering ved',
        triggerEventTitle: 'Udløs preavisering',
        triggerEventLegend:
          'Hvad der skal udløse udsendelsen af preaviseringen: når vi modtager EDI til GLOW, når pakkerne er modtaget på HUB eller modtaget på DIP. Hvis den ikke skal udløses, vælger du MANUAL.',
        cutoff: 'Cutoff',
        cutoffLegend:
          'Cutoff-tidspunktet, hvorefter vi ikke længere tilbyder modtagerne det første ledige tidsvindue i kalenderen, men i stedet tilbyder næste dag.',
        relativeCutoffMinutes: 'Cutoff-minutter',
        relativeCutoffMinutesLegend:
          'Minimum antal minutter fra preaviseringstidspunktet til næste ledige tidsvindue. Tilsidesætter cutoff-tiden.',
        calendarDays: 'Kalenderdage',
        goodsRedirectToPickupPoint: 'Varerne omdirigeres til afhentningssted efter 1 leveringsforsøg',
        dateAndTimeChangeBookingPageTitle: 'Ændringer af dato og tid på bookingsiden.',
        calenderDaysTitle: 'Angiv antallet af dage, der vises for modtageren på bookingsiden',
        calendarDaysLegend: 'Hvor mange dage skal vises for modtageren i kalenderen.',
        noServicePoliciesFound: 'Ingen indstillinger tilføjet endnu',
        returnToSenderAfterDays: 'Retur til afsender',
        returnToSenderAfterDaysLegend:
          'Efter hvor mange dage skal forsendelsen returneres til afsenderen, hvis vi ikke har kunnet få kontakt med modtageren.',
        scheme: 'Type',
        schemeLegend: 'Hvilken type preavisering skal sendes: Push, Pull, Return eller Pick up parcel.',
        searchCustomer: 'Søg kunde',
        remindAfterHours: 'Påmindelse til modtager',
        remindAfterHoursLegend:
          'Bruges til Pull- og PUP-preavisering. Efter hvor mange timer skal der sendes en påmindelse til modtageren om at booke et leveringstidspunkt.',
        preAdviceAttempts: 'Preaviseringsforsøg',
        preAdviceAttemptsLegend: 'Hvor mange påmindelser skal sendes, før forsendelsen returneres til afsenderen.',
        reminderToSenderAfterHours: 'Påmindelse til afsender',
        reminderToSenderAfterHoursLegend:
          'Dette er en påmindelse til afsenderen om, at vi ikke har kunnet få kontakt med modtageren. Forsendelsen vil blive returneret.',
        deliveryAttempts: 'Leveringsforsøg',
        deliveryAttemptsTitle: 'Når det maksimale antal leveringsforsøg er nået, returneres pakken til kunden',
        deliveryAttemptsChoiceTitle: 'Hvad skal der ske, når det maksimale antal leveringsforsøg er nået',
        deliveryAttemptsLegend:
          'Hvor mange leveringsforsøg skal foretages, før forsendelsen returneres til afsenderen.',
        pickupAttempts: 'Afhentningsforsøg',
        pickupAttemptsTitle: 'Maksimalt antal afhentningsforsøg',
        pickupAttemptsDescription:
          'Når det maksimale antal afhentningsforsøg er nået, informerer vi kunden om, at der ikke er noget at returnere på grund af afhentningsafvigelse',
        label: {
          days: 'Dage',
          hours: 'Timer',
          smss: 'stk.'
        },
        legend: {
          days: 'Dage',
          hours: 'Timer',
          smss: 'Maks. antal SMS'
        },
        returnToPup: 'Retur til pickup point',
        addNewRule: 'Tilføj ny regel',
        enableCancelBookingTimes: 'Aktivér annullering på bookingsiden',
        typeOfOrders: 'Ordretype',
        ordersWithDate: 'Ordrer med dato',
        ordersWithoutDate: 'Ordrer uden dato',
        ordersWithAndWithoutDate: 'Ordrer med og uden dato',
        emailToCustomer: 'E-mail til kunde',
        triggerEventType: {
          EDI: 'EDI',
          HUB: 'HUB',
          DIP: 'DIP',
          MANUAL: 'MANUAL'
        }
      }
    },
    tooltip: 'Låsning af ordren = der sendes ingen notifikation til modtageren',
    result: {
      NO_RULE: 'Ingen matchende regel',
      NO_DELIVERY_TIME_WINDOW: 'Intet leveringstidsvindue fundet',
      SMS_SENT: 'Forhåndsbesked-regel kontrolleret. SMS tilføjet til køen',
      EMAIL_SENT: 'Forhåndsbesked-regel kontrolleret. Email tilføjet til køen',
      SMS_AND_EMAIL_SENT: 'Forhåndsbesked-regel kontrolleret. SMS og Email tilføjet til køen',
      NO_VALID_PHONE_OR_EMAIL: 'Intet gyldigt telefonnummer eller emailadresse',
      FEATURE_OFF: 'Forhåndsbesked er slået fra',
      ALREADY_PRE_ADVICED: 'Leveringstidsvindue allerede sat. Ingen handling foretaget',
      CANCELLED: 'Forhåndsbesked annulleret',
      WAITING_FOR_PACKAGES: 'Alle pakker er ikke ankommet til terminalen',
      ALREADY_IN_PROGRESS: 'Venter på at modtager vælger leveringstid',
      ERROR: 'En fejl opstod',
      WRONG_TRIGGER: 'Udløser matcher ikke regel. Ignoreres.',
      MANUAL_ATTEMPT: 'Antal forsøg på forhåndsbesked manuelt forøget',
      PRE_ADVICE_LIMIT_REACHED: 'Grænse for forhåndsbesked nået',
      PRE_ADVICE_LOCKED: 'Forhåndsbesked er låst',
      ORDER_DELIVERED: 'Ordren er allerede leveret',
      RETURN_LAST_LEG_CREATION_SKIPPED: 'Returneringsben ikke oprettet'
    },
    error: {
      PRE_ADVICE_RULE_COLLISIONS: {
        label: 'Regelkonflikt!',
        detail:
          'Reglen for {{service}} vil tilsidesætte reglen i {{policySetNames}} gennem tilknytning til {{relations}}.',
        department: 'afdeling',
        department_group: 'afdelingsgruppe',
        customer: 'kunde',
        customer_group: 'kundegruppe'
      }
    },
    customerCode: 'Kundekode'
  },
  holidays: {
    holidays: 'Helligdage',
    holiday: 'Helligdag',
    dayBeforeHoliday: 'Dag før helligdag',
    addHoliday: 'Tilføj ny helligdag',
    country: 'Land',
    type: 'Type',
    date: 'Dato',
    successfullyAdded: 'Helligdagen er føjet til listen',
    successfullyDeleted: 'Helligdagen er slettet',
    filterOnCountry: 'Filtrer efter land',
    selectHolidayType: 'Vælg type helligdag',
    addHolidayToList: 'Tilføj helligdag til listen',
    selectCountry: 'Vælg land',
    addedHolidays: 'Tilføjede helligdage',
    deleteModalTitle: 'Slet helligdag',
    deleteModalDescription: 'Denne handling kan ikke fortrydes'
  },
  distributionMapping: {
    title: 'Distributionskobling',
    addDips: 'Tilføj DIP',
    addedDips: 'Tilføjet DIP-lokation ({{count}})',
    addedDips_other: 'Tilføjede DIP-lokationer ({{count}})',
    connectedToPickupPoints: 'Koblet til {{count}} hentepunkt',
    connectedToPickupPoints_other: 'Koblet til {{count}} hentepunkter',
    emptyTitle: 'Ingen tilkoblede distributionspunkter (DIP)',
    emptyDescription:
      'Du skal først vælge en DIP for at kunne tilføje hentepunkter.\nKlik på knappen øverst til højre for at komme i gang.',
    addDipModalTitle: 'Tilføj distributionskobling',
    addDipModalDescription: 'Vælg den DIP, du vil tilføje hentepunkter til',
    selectDipLabel: 'Søg efter distributionspunkt (DIP)',
    searchPlaceholder: 'PUP ID, navn eller adresse',
    selectButton: 'Vælg',
    editDip: 'Rediger {{name}}',
    selectPickupPointHeading: 'Vælg det hentepunkt, du vil tilføje til DIP',
    selectPickupPointLabel: 'Søg efter hentepunkt (PUP)',
    addedPickupPoints: 'Tilføjede hentepunkter til DIP',
    removePickupPoint: 'Fjern {{name}}',
    editPickupPoint: 'Rediger {{name}}',
    editPickupPointDescription: 'Vælg de dage, hvor hentepunktet kan modtage leveringer',
    deliveryDays: 'Leveringsdage',
    deliveryDaysHint: 'Vælg de dage, hvor hentepunkterne kan modtage leveringer',
    addPickupPoint: 'Tilføj hentepunkt',
    saveToast: 'Distributionskobling for {{name}} er gemt',
    addLocations: 'Tilføj lokationer',
    removeDip: 'Fjern {{name}}',
    removeDipQuestion: 'Fjern {{name}} fra distributionskoblingen?',
    removeDipDescription: 'De tilkoblede hentepunkter mister deres DIP.',
    removeConnectionQuestion: 'Fjern koblingen til {{name}}?',
    removeConnectionDescription: 'Hentepunktet har ingen DIP, indtil det kobles til igen.',
    alreadyAdded: 'Dette hentepunkt er allerede på denne DIP. Tilføjer du det igen, erstattes leveringsdagene.',
    alreadyMappedToOtherDip:
      'Dette hentepunkt er allerede koblet til {{dip}}. Fjern det fra den DIP, før du tilføjer det her.',
    loadFailed: 'Kunne ikke hente distributionskoblingerne. Prøv igen, eller genindlæs siden.',
    errorSelectPickupPoint: 'Du skal vælge et hentepunkt',
    errorSelectDeliveryDay: 'Du skal vælge mindst én leveringsdag',
    errorSelectDip: 'Du skal vælge en DIP',
    deleteToast: '{{name}} blev slettet'
  },
  department: {
    region: 'Region',
    general: 'Generelt',
    plannedStopLocations: 'Planlagte stoplokationer',
    plannedStopLocationsDescription:
      'Her kan du tilføje alle planlagte stoplokationer til optimering af ruteplanlægningen.',
    plannedStopLocationName: 'Navn på planlagt stoplokation',
    plannedStopLocationIsTerminal: 'Tæller som terminaladresse for denne afdeling',
    plannedStopLocationIsTerminalTooltip:
      'Kun relevant for afdelinger med mere end én terminaladresse. Adressen bruges så i tillæg til afdelingens standardadresse.',
    addPlannedStopLocation: 'Tilføj planlagt stoplokation',
    searchDepartmentByNameOrId: 'Filtrer på afdelingsnavn eller afdelings-ID',
    searchDepartmentGroups: 'Søg efter gruppenavn eller beskrivelse',
    createNewDepartment: 'Opret ny afdeling',
    addressAndContact: 'Adresse og kontaktinformation',
    searchAddressError: 'Manglende værdier for adresse. Du skal bruge søgefeltet for at få den korrekte adresse.',
    addressContactIngress:
      'For at få den korrekte adresse, brug søgefeltet. Adressen, postnummer og by vil blive udfyldt automatisk.',
    settingsInGlow: 'Indstillinger på modtagers sporingssiden',
    settingsBodyText: 'Afhængigt af dit valg vil forskelligt indhold og kommunikation blive vist/send til modtagerne.',
    tooltipNPSID:
      'NPS ID = Glow kan udsende NPS-målinger af modtagertilfredshed. Her udfyldes den unikke identifikator for hver afdeling',
    tooltipTerminal: 'Udfyld disse oplysninger, hvis afhentnings- og afdelingsnavn er forskellige',
    removeRow: 'Fjern række',
    cutoff: 'Cutoff',
    regular: 'Almindelig',
    sameDay: 'Samme dag',
    weekdays: 'Hverdage',
    saturdays: 'Lørdage',
    sundays: 'Søndage',
    setTimeWindow: 'Indstil tidsvindue',
    setTimeWindowToDepartment: 'Indstil tidsvindue for afdeling',
    updateTimeWindow: 'Opdater tidsvindue',
    timeWindowTitle: 'Logik for leveringsdage',
    timeWindowIngress: 'Hvilke dage skal denne afdeling levere? Udfyld for hver dag enten alle værdier eller ingen.',
    emailAddress: 'E-mailadresse',
    npsId: 'NPS ID',
    defaultAlystraUnitId: 'Selfbilling unit ID',
    timeWindow: 'Tidsvindue',
    pickupEarliest: 'Tidligste afhentning',
    pickupLatest: 'Seneste afhentning',
    deliveryEarliest: 'Tidligste levering',
    deliveryLatest: 'Seneste levering',
    routePlanning: 'Ruteplanlægning',
    autoRouteCreationTime: 'Automatisk ruteoprettelse',
    autoRouteOptimizationTime: 'Automatisk ruteoptimering',
    clearTime: 'Fjern tiden',
    delegatedDepartment: 'Delegeret afdeling',
    disableSms: 'Deaktiver sporings- og ETA-SMS på rute',
    smsShouldNotBeSent:
      'Sporings- og ETA-SMS skal ikke sendes til modtagere på ruter, der produceres i denne afdeling.',
    manageDepartment: 'Administrer afdeling',
    listAllDepartments: 'Vis alle afdelinger',
    listAllGroups: 'Liste alle afdelingsgrupper',
    successUpdate: '{{name}} blev opdateret',
    editDepartment: 'Rediger {{name}}',
    departmentTitle: 'Afdeling',
    departmentsLabel: 'afdelinger',
    departmentWithCount: '{{count}} afdeling',
    departmentWithCount_other: '{{count}} afdelinger',
    departmentGroups: 'Afdelingsgrupper',
    numberOfDepartmentGroups: 'Antal afdelingsgrupper',
    numberOfDepartments: 'Antal afdelinger',
    search: 'Søg efter afdelinger',
    searchGroups: 'Søg efter afdelingsgrupper',
    noDepartmentsFound: 'Ingen afdelinger fundet',
    noDepartmentGroupsFound: 'Ingen afdelingsgrupper fundet',
    noDepartmentName: 'Navn mangler',
    noDepartmentId: 'Id mangler',
    noCouriers: 'Ingen bude',
    courierCount_other: '{{count}} bude',
    courierCount: '{{count}} bud',
    noCourier: 'Intet bud',
    couriers: 'Antal bude',
    plannerCount_other: '{{count}} planlæggere',
    plannerCount: '{{count}} planlægger',
    noPlanner: 'Ingen planlægger',
    planners: 'Antal planlæggere',
    choose: 'Vælg afdeling',
    new: 'Ny afdeling',
    description: 'Beskrivelse',
    name: 'Navn',
    created: 'Afdeling oprettet',
    updated: 'Afdeling opdateret',
    departmentType: 'Afdelingstype',
    notSet: 'Ikke valgt',
    courier: 'Bud',
    express: 'Ekspres',
    hd: 'Hjemmelevering',
    h2: 'H2',
    parcel: 'Parcel',
    posten: 'Posten',
    other: 'Andre',
    all: 'Alle',
    deliveryDisplayType: 'Visning af leveringstid',
    terminalName: 'Terminalnavn',
    terminalNameTooltip: 'Hvis afhetnings- og afdelingsnavn ikke er det samme, så udfyld følgende',
    selectArea: 'Vælg område...',
    address: 'Adresse',
    zipCode: 'Postnummer',
    zipArea: 'Område',
    autoRecurrentTime: 'Automatisk tilbagevendende tid',
    orderBillingType: {
      title: 'Ordrefaktureringstype',
      selectBillingType: 'Vælg faktureringstype',
      apollo: 'Apollo',
      h2: 'H2',
      pickup: 'Afhentning',
      customerBillingNumber: 'Kundens faktureringsnummer',
      addMoreOrderBillingInfo: 'Tilføj ny ordrefaktureringstype',
      internalTrade: 'Intern handel'
    },
    departmentId: 'Afdelings-ID',
    autoInvoiceTitle: 'Automatisk fakturering',
    autoInvoiceEnable: 'Sett automatisk fakturering',
    autoInvoiceTime: 'Tid',
    autoInvoiceOffset: {
      legend: 'Hvilke ordrer der skal faktureres',
      oneDayEarlier: 'Leveret 1 dag siden',
      twoDaysEarlier: 'Leveret 2 dage siden',
      threeDaysEarlier: 'Leveret 3 dage siden',
      fourDaysEarlier: 'Leveret 4 dage siden',
      fiveDaysEarlier: 'Leveret 5 dage siden'
    },
    autoDispatchSettings: {
      title: 'Automatisk tildeling af afhentningsordrer',
      enable: 'Sæt automatisk tildeling af afhentningsordrer',
      minutesAfterOrderArrival: 'Minutter efter ordren er modtaget',
      startTime: 'Starttidspunkt'
    },
    unitNumber: 'Enhedsnummer',
    labels: 'Etiketter',
    labelsDescription:
      'Opret labels for at opbygge filtreringsregler for denne afdeling. Labels inden for samme kategori matches ved hjælp af <bold>OR</bold>-logik, mens forskellige kategorier kombineres med <bold>AND</bold>-logik. Husk at tildele labels til dine ruter, for at filtreringen træder i kraft.\n' +
      '\n' +
      'Hvis der er oprettet labels for en afdeling, bliver brugerne bedt om at vælge, hvilke labels de vil vise, første gang de åbner siden <bold>Ruteoversigt</bold>. De kan til enhver tid ændre deres valg ved hjælp af det almindelige filterpanel på siden <bold>Ruteoversigt</bold>. Deres valg gemmes i browseren. Læs mere her (eller i “Hvad er dette”-vinduet): <supportLink>Labels (Only for Parcel Norway departments) – GLOW Support</supportLink>',
    labelsCategory: 'Kategori',
    labelsCategoryHint: 'Brug et eksisterende kategorinavn for at tilføje flere etiketter til samme gruppe.',
    labelName: 'Etiketnavn',
    existingLabels: 'Eksisterende etiketter',
    labelsEmpty: 'Der er endnu ikke oprettet nogen etiketter.',
    labelsPreview: 'Forhåndsvisning',
    labelsPreviewEmpty: 'Vælg etiketter for at se, hvordan filterlogikken bliver bygget op.',
    labelsDuplicate: 'Denne etiket findes allerede i den valgte kategori.',
    labelsNotAdded: 'Klik på Tilføj for at tilføje etiketten, før du gemmer.',
    nameRequired: 'Navn er påkrævet',
    addressRequired: 'Adresse er påkrævet',
    zipCodeRequired: 'Postnummer er påkrævet',
    zipAreaRequired: 'Område er påkrævet',
    labelsCategoryRequired: 'Kategori er påkrævet',
    labelNameRequired: 'Etiketnavn er påkrævet',
    departmentTypeRequired: 'Afdelingstype er påkrævet',
    departmentIdRequired: 'Afdelings-ID er påkrævet',
    descriptionRequired: 'Beskrivelse er påkrævet',
    regionRequired: 'Region er påkrævet',
    minutesAfterOrderArrivalRequired: 'Minutter efter ordren er modtaget er påkrævet',
    createLabels: 'Opret etiketter'
  },
  departmentGroup: {
    departmentGroupDeleted: '{{name}} blev slettet',
    selectedCountries: '{{count}} valgt land',
    selectedCountries_other: '{{count}} valgte lande',
    countries: 'Lande',
    allDepartmentTypes: 'Alle afdelingstyper',
    selectedDepartmentTypes: '{{count}} valgt afdelingstype',
    selectedDepartmentTypes_other: '{{count}} valgte afdelingstyper',
    departmentTypes: 'Afdelings typer',
    youMustSelectDepartment: 'Du skal vælge en afdeling',
    manageDepartments: 'Administrer afdelinger i gruppe',
    createDepartmentGroup: 'Opret ny afdelingsgruppe',
    noSelectedDepartments: 'Ingen valgte afdelinger',
    selectedDepartments: 'Valgte afdelinger ({{count}})',
    selectAllFor: 'Vælg alle for {{name}}',
    departmentGroup: 'Afdelingsgruppe',
    name: 'Navn',
    deleteConfirm: 'Er du sikker på at du vil slette denne afdelingsgruppe?',
    edit: 'Rediger afdelingsgruppe',
    type: 'Type',
    types: {
      DEFAULT: 'Standard',
      FOLLOW_UP: 'Opfølgning',
      INVOICING: 'Fakturering',
      PLANNING: 'Planlægning',
      PREADVICE: 'Avisering',
      REGION: 'Region',
      SEARCH: 'Søg'
    }
  },
  deliveryDisplayType: { instant: 'Ad Hoc', customized: 'Tilpasset' },
  templateRouteRules: {
    title: 'Administrer ruteregler',
    ruleName: 'Regelnavn',
    type: 'Type',
    POSTAL_CODE: 'Postnummer',
    searchPlaceholder: 'Søg efter navn eller type',
    createNew: 'Opret ny regel',
    createNewRule: 'Opret ny ruteregel',
    edit: 'Rediger',
    settings: 'Indstillinger',
    assignToTemplateRoutes: 'Skabelonruter',
    connectedToRule: 'tilknyttet "{{name}}"',
    noTemplateRoutesInDepartment: 'Ingen skabelonruter tilgængelige i denne afdeling',
    templateHasNoRoutes: 'Den valgte skabelon har ingen ruter',
    noRecurringRoutesInDepartment: 'Ingen tilbagevendende ruter tilgængelige i denne afdeling',
    template: 'Skabelon',
    selectTemplate: 'Vælg skabelon',
    templateRoute: 'Skabelonrute',
    selectTemplateRoutes: 'Vælg skabelonruter',
    assignedTemplateRoutes: 'Tildelte skabelonruter ({{count}})',
    noAssignedTemplateRoutes: 'Ingen skabelonruter tildelt endnu',
    assignToRecurringRoutes: 'Tilbagevendende ruter',
    recurringRoute: 'Tilbagevendende rute',
    selectRecurringRoutes: 'Vælg tilbagevendende ruter',
    assignedRecurringRoutes: 'Tildelte tilbagevendende ruter ({{count}})',
    noAssignedRecurringRoutes: 'Ingen tilbagevendende ruter tildelt endnu',
    atLeastOneRule: 'Tilføj mindst én postnummerregel',
    successfullyAdded: '{{name}} blev tilføjet',
    successfullyUpdated: '{{name}} blev opdateret',
    successfullyDeleted: 'Ruteregel blev slettet',
    deleteRule: 'Slet ruteregel',
    deleteRuleDescription: 'Er du sikker på, at du vil slette denne ruteregel?',
    serviceExclusion: 'Serviceekskludering',
    serviceExclusionDescription: 'Ordrer med en af disse servicekoder tildeles aldrig ruter af denne regel.',
    serviceCode: 'Servicekode',
    addServiceCode: 'Tilføj servicekode',
    excludedServices: 'Ekskluderede services',
    noExcludedServices: 'Ingen services ekskluderet',
    serviceCodeRequired: 'Indtast en servicekode',
    serviceCodeAlreadyExcluded: '{{code}} er allerede ekskluderet',
    removeServiceCode: 'Fjern {{code}}'
  },
  menu: {
    distributionMapping: 'DIP-kobling',
    manageRouteRules: 'Administrer ruteregler',
    defaultDisabled: 'Vælg en kunde for at aktivere dette menupunkt',
    home: 'Hjem',
    planner: 'Planlægning',
    volumeReport: 'Volumenrapporter',
    openSearch: 'Åbn søgning',
    report: 'Rapporter',
    customer: 'Kunder',
    apiOrder: 'Find API ordre',
    support: 'Support',
    priceMotor: 'Prismotor',
    departments: 'Afdelinger',
    users: 'Brugere',
    customers: 'Kunde',
    customerGroups: 'Kundegrupper',
    numberSeries: 'Nummerserie',
    jobsMonitoring: 'Job overvågning',
    holidays: 'Helligdage',
    shd: 'SHD',
    settings: 'Indstillinger',
    preadvice: 'Preavisering',
    cms: 'CMS',
    userRoles: 'Brugerroller',
    integrations: 'Integrationer',
    live: 'Live',
    routePlanning: 'Rute planlægning',
    dispatching: 'Disponering',
    booking: 'Booking',
    h2Booking: 'H2 Booking',
    setCoordinates: 'Indstil koordinater',
    pickupOrders: 'Afhentningsordrer',
    billingOrder: 'Faktureringsordre',
    shipments: 'Forsendelser',
    corrections: 'Rettelser',
    units: 'Enheder',
    couriers: 'Bud',
    vehicles: 'Køretøjer',
    recurring: 'Tilbagevendende',
    importExport: 'Import / Eksport',
    addresses: 'Adresser',
    invoicing: 'Fakturering',
    manageReturns: 'Administrer returneringer',
    preAdviceFollowup: 'Administrer forudanmeldelse',
    optimizing: 'Optimering',
    services: 'Tjenester',
    matrix: 'Matrix',
    vendors: 'Leverandører',
    backToOldShipmentsPage: 'Tilbage til den gamle side.',
    mainNavigation: 'Hovedmenuen',
    closePanel: 'Luk panelet',
    expandPanel: 'Udvid panel',
    goToHomepage: 'Gå til forsiden',
    admin: 'Administration',
    productionTimeWindow: 'Produktionstidsvindue',
    routesOverview: 'Ruteoversigt'
  },
  planner: {
    colorPicker: 'Farvevælger',
    canLogIn: 'Kan logge ind',
    chooseYourDepartment: 'Vælg din afdeling',
    unassignedShipments: 'Uanviste forsendelser',
    filterCustomers: 'Filtrer kunder',
    filterServices: 'Filtrer tjenester',
    autoRoute: 'Automatisk rute',
    saved: 'Gemt',
    allUserRoles: 'Alle brugerroller',
    userRolesCount_other: '{{count}} brugerroller',
    createNewUser: 'Opret ny bruger',
    userRolesCount: '{{count}} brugerrolle',
    role: 'Rolle',
    searchForNameOrNumber: 'Søg efter navn eller telefonnummer',
    noPlannersFound: 'Ingen planlæggere fundet',
    typeOfRole: 'Type af brugerrolle',
    selectUserRole: 'Vælg brugerrolle',
    secondTab: 'Anden fane',
    users: 'Brugere',
    connectDepartment: 'Forbind afdeling til bruger',
    autoRouteModal: {
      selectRoutes: 'Vælg ruter',
      selectRoutesText:
        'Vælg ruter, der skal medtages i automatisk ruteplanlægning. Kun ruter med status Oprettet eller Behandlet er tilgængelige. For ruter, der allerede er i gang, skal du bruge Føj til rute for at dispatche forsendelser.',
      routesStartedRemoved: '{{routes}} er startet og blev fjernet fra udvalget',
      routesStartedRemoved_other: '{{routes}} er startet og blev fjernet fra udvalget',
      lockAllToSlot: 'Lås alle tildelte forsendelser til ruten',
      useMapAreaRestrictions: 'Brug kortområdebegrænsninger',
      usePostalCodeRestrictions: 'Brug postnummerbegrænsninger',
      useGraphHopper: 'Brug GraphHopper',
      usePtv: 'Brug PTV',
      usePtvPilot: 'Premiumoptimering',
      useKardinal: 'Brug Kardinal',
      useHere: 'Brug HERE',
      useHexaly: 'Brug Hexaly',
      useHexalyCloud: 'Brug Hexaly Cloud',
      timeLimitInSeconds: 'Tidsgrænse i sekunder',
      timeLimitByStops: 'Tom: baseret på planens størrelse',
      timeLimitAsMinutes: '= {{minutes}} min {{seconds}} s',
      timeLimitOutOfRange: 'Angiv hele sekunder mellem 10 og 2700 (45 minutter)',
      timeLimitExample: 'f.eks. 60',
      useNoEngine: 'Brug ingen optimeringsmotor til denne specifikke rute',
      optimizeOn: 'Optimer efter',
      noRelevantRoutes: 'Ingen relevante ruter fundet',
      startAutomaticRouting: 'Start automatisk ruteplanlægning',
      selectOptimizingEngine: 'Vælg optimeringsmotor',
      useFlexAndForceFromPrevious: 'Brug fleksibilitet og tvungen rækkefølge fra tidligere optimeringer'
    },
    wait: 'Vent',
    trips: 'Ture',
    searchSlotCourierName: 'Søg efter rute-/budnavn',
    banner: {
      tryNewRoutePlanner:
        'Fra den 1. maj vil <0>ruteplanlægger 2.0</0> være den eneste tilgængelige ruteplanlægger. Hvis du ikke har brugt ruteplanlæggeren før, opfordrer vi dig til at begynde at bruge den nu. <1>Læs mere på Zendesk</1> og andre relaterede artikler for at få et overblik over, hvordan den fungerer.'
    },
    createdBy: 'Oprettet af',
    totalTitle: 'Pakker',
    pickList: 'Plukliste',
    export: 'Eksport til fakturering',
    deleteSlot: 'Slet',
    editSlot: 'Rediger',
    deleteSlotConfirmDialogText: 'Er du sikker på at du vil slette denne rute?',
    deleteFilteredSlots: 'Slet alle ruter',
    deleteAllSlotsConfirmDialogText: 'Er du sikker på, at du vil slette alle ruter?',
    created: 'Planlægger oprettet',
    removeDepartment: 'Fjern afdeling {{name}}',
    youMustProvideName: 'Du skal angive brugerens navn',
    youMustProvidePhonenumber: 'Du skal angive telefonnummer',
    showInGoogleMaps: 'Vis rute i Google Maps',
    detailedAccessRights: 'Detaljerede adgangsrettigheder for {{name}}',
    updated: 'Planlægger opdateret',
    deleted: 'Planlæggeren er slettet',
    confirmDelete: 'Er du sikker på, at du vil slette denne bruger?',
    live: 'Live',
    routePlanning: 'Rute planlægning',
    vehicles: 'Køretøjer',
    routePlanningConsignmentsAssigned: 'tildelt',
    routePlanningRangeDescription: 'Filtrer forsendelser efter leveringstid',
    unresolvedConsignments: 'Uløst',
    consignments: 'Forsendelser',
    couriers: 'Bud',
    units: 'Enheder',
    invoicing: 'Fakturering',
    planner: 'Planlægger',
    planners: 'Planlæggere',
    noPlanners: 'Ingen planlæggere',
    missingId: 'Id mangler',
    missingName: 'Navn mangler',
    search: 'Søg',
    searchForPlanner: 'Søg efter planlægger',
    name: 'Navn',
    phoneNumber: 'Telefonnummer',
    selectDepartments: 'Vælg afdeling',
    createSlot: 'Opret rute',
    editSlotForm: 'Rediger rute',
    routeUpdated: 'Rute oplysninger opdateret',
    createSlotFormName: 'Rute navn',
    createSlotFormUnit: 'Enhed',
    createSlotFormCourier: 'Bud',
    createSlotFormSlotMode: 'Rute mode',
    createSlotFormSlotModePickup: 'Tegn afhentningsområde på kort',
    createSlotFormSlotModeDelivery: 'Tegn leveringsområde på kort',
    createSlotFormSlotModeManual: 'Vælg forsendelse manuelt',
    createSlotFormSlotModeSelected: 'Vælg forsendelser',
    createSlotFormTimeRange: 'Tidsinterval',
    createSlotFormStartLocation: 'Start lokation',
    createSlotFormEndTime: 'Sluttid',
    createSlotFormEndLocation: 'Stop lokation',
    createSlotFormSlotColor: 'Rutefarve',
    createSlotFormTimeRangeTooBig: 'Tidsintervallet er for stort. Maks er {{hours}} timer.',
    createSlotFormFilterCustomers: 'Filtrer kunder (ingen markeret betyder alle)',
    createSlotFormFilterServices: 'Filtrer service (ingen markeret betyder alle)',
    slotFilterInfo:
      'Ruten er filtreret, hvilket betyder at kun forsendelser, der tilhører den/de valgte kunde(r) og den/de valgte service(s), kan tilknyttes ruten.',
    slotFilteredCustomer: 'Ruten indeholder kun forsendelser fra følgende kunder',
    slotFilteredService: 'Ruten indeholder kun forsendelser med følgende services',
    onlyShowApplicable: 'Vis kun ordrer der er anvendelige for denne rute, baseret på kunde/service filtreringen',
    optimizeButtonLabel: 'Optimer og tildel ruter',
    optimizeSlotButtonLabel: 'Genoptimer rute',
    reversedOptimizeSlotButtonLabel: 'omvendt leveringsrækkefølge',
    optimizingSince: 'Optimering i gang, startede kl. {{startTime}}',
    addToRoute: 'Føj til rute...',
    pickup: 'Opsamling',
    delivery: 'Levering',
    depot_call: 'Planlagt stop',
    slot: 'Rute',
    notAssigned: 'Ikke behandlet',
    readOnly: 'Kun læsetilladelse',
    normal: 'Normal',
    plus: 'Ekstra rettigheder',
    partner: 'Partner',
    readOnlyAccessPlannersWithCount: '{{count}} planlæggere med læsetilladelse',
    plusPlannersWithCount: '{{count}} planlæggere med ekstra rettigheder',
    normalPlannersWithCount: '{{count}} planlæggere med standard rettigheder',
    saveTemplate: 'Gem skabelon',
    loadTemplate: 'Hent fra skabelon',
    routeListForFilteredSlots: 'Kvitteringsliste (Print alt)',
    loadListForFilteredSlots: 'Læsseliste (Print alt)',
    sendPrePickupSmsesToAll: 'Forhåndssend sporings SMS',
    alertBeforeSendingPrePickupSms: 'Er du sikker på at du vil forhåndssende sporings SMS for alle slots for i dag?',
    newTemplate: 'Opret en ny skabelon',
    selectTemplate: 'Vælg skabelon',
    deleteTemplate: 'Slet',
    templateDeleteConfirm: 'Er du sikker på, du vil slette denne skabelon?',
    missingDeliveryMarker: 'Ikke en gyldig leveringsadresse eller lokation',
    missingPickupMarker: 'Ikke en gyldig afhentningsadresse eller lokation',
    assignConsignmentFromSlot: 'Tildel forsendelse til {{routeName}}?',
    unassignConsignmentFromSlot: 'Fjern {{count}} forsendelse fra rute?',
    unassignConsignmentFromSlot_other: 'Fjern {{count}} forsendelser fra rute?',
    unassignBulkConsignmentsFromSlotsAlert: 'Fjern forsendelser fra deres respektive ruter?',
    unassignedFromSlot: 'Forsendelsen er nu blevet fjernet fra ruten',
    unassignBulkConsignmentsFromSlots: 'Forsendelserne er nu blevet fjernet fra deres respektive ruter',
    unassignButton: 'Fjern fra rute',
    forceUnassignButton: 'Tving fjern fra rute',
    driverName: 'Chauffør',
    deliveries: 'Leveringer',
    returns: 'Returneringer',
    installations: 'Installationer',
    curbside: 'Levering til kantsten',
    label: 'Label',
    filters: { assigned: 'Behandlet', unassigned: 'Ikke behandlet', pickups: 'Opsamlinger', deliveries: 'Leveringer' },
    saveSelected: 'Gem valgte ({{count}})',
    showSaved: 'Vis gemte ({{count}})',
    showAll: 'Vis alt',
    clearSaved: 'Slet gemte',
    sendPrePickupSms: 'Forhåndssend sporings SMS til modtager',
    sendSms: 'Send SMS',
    sendingSmsText: 'Sender {{count}} sporings SMS',
    prePickupSmsSent: '{{sentCount}} af {{totalCount}} sporings SMS afsendt',
    manualDelaySms: {
      smsSent: '{{count}} manuel SMS for forsinkelse sendt',
      heading: 'Manuel SMS for forsinkelse',
      sendingSmsText: 'Sender {{count}} manuel SMS for forsinkelse',
      selectSmsDescription:
        'SMS vil starte med "Hej! Din levering fra Sender er desværre forsinket.". Vælg SMS afslutning nedenfor.',
      selectSmsEnding: "Vælg hvordan SMS'en skal afsluttes",
      selectSmsBeginning: "Vælg hvordan SMS'en skal begynde",
      previewLabel: 'SMS-forhåndsvisning',
      buttonTitle: 'Send',
      beginningType: {
        hi: '"Hej!"',
        none: 'Ingen',
        fromSender: '"Din levering fra afsender er desværre forsinket."',
        highDemand: '"På grund af høj belastning kan dit gods desværre ikke leveres som planlagt."'
      },
      endingType: {
        none: 'Ingen',
        soon: '"Vi vil forsøge at levere så hurtigt som muligt."',
        tomorrow: '"Vi vil forsøge at levere næste hverdag."',
        whenShipmentHasArrived:
          '"En ny leveringsdato og et nyt tidspunkt bliver sendt, når forsendelsen når terminalen."',
        newDeliveryTime: '"Vi leverer dette til dig på næste tilgængelige leveringsdag."',
        newDeliveryTimeFullEnding:
          '"Ny levering er booket [DATE] [TIMESLOT]. Du kan ændre leveringstid via [TRACKINGLINK]. Venlig hilsen Bring"'
      },
      disabledTooltip: 'Ordrer kan ikke være i tilstand Leveret'
    },
    delayedShipmentNotification: {
      description:
        'Modtageren får en SMS om, at forsendelsen er forsinket, og at en ny leveringsdato og et nyt tidspunkt bliver sendt, når forsendelsen når terminalen.',
      resetDescription:
        'Når du bekræfter, bliver de valgte forsendelser nulstillet og fjernet fra ruten, hvis de er tildelt.',
      gScanDescription:
        'Når terminalankomst er registreret, bliver modtageren varslet igen i henhold til preadvice-reglerne.',
      successMessage: 'Workflowet for forsinkede forsendelser blev startet'
    },
    rescheduledShipmentNotification: {
      description: 'Leveringen vil blive flyttet til en ny dato og et nyt tidspunkt.',
      autoUpdateDescription:
        'Modtageren vil få en SMS om, at leveringen ikke ankommer i dag som planlagt. Beskeden indeholder også den nye dato og det nye tidspunkt samt et link, hvor de kan ændre leveringen, hvis det er nødvendigt.'
    },
    h2: {
      booking: 'H2-booking',
      vasHelperText: 'Brug VAS 1158 til MBH'
    },
    loadList: {
      address: 'Adresse',
      customerRef: 'Kundereference',
      date: 'Dato',
      deliveries: 'Leveringer',
      distance: 'Afstand',
      estimatedLoadTime: 'ELT',
      estimatedTotalTime: 'Est. tid',
      header: 'Ruteoversigt',
      instructions: 'Leveringsinstruktioner,\ntelefon,\nmodtagerref.',
      instructionsPhone: 'Tlf.:',
      instructionsRef: 'Modtagerref.:',
      listName: 'Læsseliste',
      name: 'Navn',
      qty: 'Antal',
      routeName: 'Rute',
      service: 'Tjeneste\n(VAS)',
      stopOrder: 'Stopnr.',
      summary: 'Opsummering',
      time: 'Tid',
      timeWindow: 'Tidsvindue (ETA-ETD)',
      tripNumber: 'Tur',
      totalDistance: 'Samlet afstand',
      totalTime: 'Samlet tid',
      unit: 'Enhed',
      volume: 'Vol\nm³',
      weight: 'Vægt\nkg',
      zipArea: 'Område',
      zipCode: 'Postnummer',
      unknownRouteName: 'Ukendt rutenavn',
      unknownUnitName: 'Ukendt enhedsnavn',
      noDataText: 'Ikke noget at se her',
      utilization: 'Udnyttelse'
    },
    locationList: { listName: 'Lokationsliste' },
    assignedUnits: 'Tildelte enheder',
    unassignedUnits: 'Ikke-tildelte enheder',
    noUnitSelected: 'Ingen enhed valgt',
    unitAssignmentCount: 'Enhed tildelt til {{count}} ruter',
    breakDeletedFromRoute: 'Pausetiden blev fjernet fra ruten',
    favouriteDepartments: 'Favoritter',
    addFavouriteDepartment: 'Tilføj favorit: {{department}}',
    removeFavouriteDepartment: 'Fjern favorit: {{department}}',
    largeDepartmentGuard: {
      validationMessage:
        'Den valgte afdelingsgruppe {{departmentGroup}} har for mange ruter og kan ikke bruges på {{page}}. Vælg en anden afdelingsgruppe eller afdeling.'
    }
  },

  updateServiceLevel: {
    menuItem: 'Ret serviceniveau',
    selectOption: 'Vælg serviceniveau',
    heading: 'Ret servicenivea',
    confirmation: 'Service niveau opdateret',
    subtext: 'Ret serviceniveau for {{count}} forsendelse',
    subtext_other: 'Ret serviceniveau for {{count}} forsendelser',
    failed: {
      title: 'Serviceniveau kunne ikke ændres',
      message: 'Serviceniveau for {{count}} forsendelse kunne ikke ændres',
      message_other: 'Serviceniveau for {{count}} forsendelser kunne ikke ændres'
    }
  },
  manualPreAdvice: {
    menuItem: 'Manuel preavisering',
    selectOption: 'Vælg type preavisering',
    heading: 'Manuel preavisering',
    confirmation: 'Preavisering(er) igangsat',
    subtext: 'Igangsæt preavisering av {{count}} forsendelse',
    subtext_other: 'Igangsæt preavisering av {{count}} forsendelse',
    failed: {
      title: 'Preavisering kunne ikke igansættes',
      message: 'Kunne ikke igangsætte preavisering av {{count}} shipment',
      message_other: 'Kunne ikke igangsætte preavisering av {{count}} shipments'
    }
  },
  setPickupDeliveryDuration: {
    menuItem: 'Indstil afhentnings- / leveringstider',
    heading: 'Indstil afhentnings- og leveringstider',
    subtext: 'Indstil afhentnings- og leveringstider for {{count}} forsendelse',
    subtext_other: 'Indstil afhentnings- og leveringstider for {{count}} forsendelser',
    pickupPreparation: 'Forberedelse afhentning',
    pickupDuration: 'Afhentningsvarighed',
    deliveryPreparation: 'Forberedelse levering',
    deliveryDuration: 'Leveringsvarighed',
    confirmation: 'Afhentnings- og leveringstider opdateret',
    validationError: 'Ugyldigt tidspunkt. Maksimalt antal minutter og sekunder er 59',
    description:
      'Angiv forberedelse og varighed for afhentning og levering for de valgte ordrer. Det maksimale antal minutter og sekunder er 59.'
  },
  importExportOrders: {
    importOrdersHeading: 'Importordre',
    importStatus: 'Der er i øjeblikket {{imports}} importer i kø med et samlet antal på {{orders}} ordrer',
    exportForInvoice: 'Eksport til fakturering',
    fileTemplateLink: 'Download Excel-skabelon',
    uploadFile: 'Importordre',
    uploadingMessage: 'Uploader fil og importerer ordrer ...',
    testDataWarning: 'Brug ikke personlige oplysninger i testmiljø',
    testDataInfo:
      'Dette er et qa/testmiljø, og du må ikke bruge produktionsdata i test uden udtrykkeligt samtykke fra berørte brugere.',
    fromDate: 'Fra dato',
    toDate: 'Til dato',
    fromDateNotAfterToDate: "Kan ikke være senere end 'To date'",
    toDateNotBeforeFromDate: "Kan ikke være tidligere end 'From date'",
    removeControlColumns: 'Fjern kontrollkolonner',
    importResults: 'Importer resultater',
    fileName: 'Importeret fil',
    processedAt: 'Behandlet',
    createdShipmentId: 'Created Shipping ID',
    date: 'Dato',
    exportShipments: 'Eksportskibe',
    createLabels: 'Opret etiketter',
    selectSlot: 'Vælg rute',
    selectExportLabel: 'Vælg hvad du vil eksportere',
    allOrders: 'Alle Ordrer',
    deviatedOrders: 'Ordre med afvigelse',
    all: 'Alle',
    selectFile: 'Vælg fil',
    exportFailed: 'Kunne ikke eksportere data',
    jobList: {
      title: 'Tidligere eksporter',
      content: 'Indhold',
      created: 'Oprettet',
      user: 'Bruger',
      dates: 'Dato',
      download: 'Downloadet',
      exporting: 'Eksporterer...',
      downloading: 'Downloader...',
      inQueue: 'I eksportkø',
      exportFailed: 'Eksporten mislykkedes',
      updated: 'Opdateret',
      previousImports: 'Tidligere import',
      fileName: 'Filnavn',
      numberOfOrders: 'Antal ordrer',
      imported: 'Importeret',
      viewOrders: 'Vis ordrer',
      lastImports: 'Viser de sidste {{count}} importer'
    },
    exportStartedNotification: 'Eksporten startede',
    exportStartedNotificationMessage: 'Din rapport vil være tilgængelig, så snart den er behandlet.',
    exportFailedNotification: 'Eksporten mislykkedes. Prøv igen senere',
    refreshData: 'Opdater data i eksisterende rapport',
    refreshDataDescription:
      'Vælg denne mulighed, hvis du allerede har oprettet en eksisterende rapport for de specifikke datoer',
    types: {
      SHIPMENT_EXPORT: 'Forsendelser',
      COURIER_WORK_REPORT: 'Chaufførarbejdsrapport',
      COURIER_WORK_REPORT_EXTENDED: 'Udvidet arbejdsrapport for bude',
      END_OF_DAY_REPORT: 'Dagsafslutningsrapport',
      SOCIAL_CONTROL: 'Social kontrol',
      LOCATION_LIST: 'Placeringsliste',
      ORDER_EXPORT: 'Eksport af ordre',
      ORDER_DEVIATION_EXPORT: 'Ordre (Afvigelse)',
      ORDER_EXPORT_ANONYMOUS: 'Ordre (Anonyme Data)',
      ORDER_PARTNER_EXPORT: 'Ordre (For Partnere)',
      DEVIATION_EVENTS: 'Afvigelseshændelser',
      OPTIMIZATION_RESULTS: 'Optimeringsresultater',
      FINANCIAL_REPORT: 'Økonomisk rapport'
    },
    exportTitles: {
      SHIPMENT_EXPORT: 'Eksporter forsendelser',
      COURIER_WORK_REPORT: 'Chaufførarbejdsrapport',
      COURIER_WORK_REPORT_EXTENDED: 'Udvidet arbejdsrapport for bude',
      END_OF_DAY_REPORT: 'Dagsafslutningsrapport',
      SOCIAL_CONTROL: 'Eksporter Social kontrol',
      LOCATION_LIST: 'Eksporter placeringsliste',
      ORDER_EXPORT: 'Eksportordre',
      ORDER_DEVIATION_EXPORT: 'Eksportordre med afvigelse',
      ORDER_EXPORT_ANONYMOUS: 'Eksportordre Anonymiseret',
      ORDER_PARTNER_EXPORT: 'Eksportpartnerordre',
      DEVIATION_EVENTS: 'Eksport afvigelseshændelser',
      OPTIMIZATION_RESULTS: 'Eksport optimeringsresultater',
      FINANCIAL_REPORT: 'Eksport økonomisk rapport'
    },
    exportDescriptions: {
      SHIPMENT_EXPORT: '',
      COURIER_WORK_REPORT: '',
      COURIER_WORK_REPORT_EXTENDED: '',
      END_OF_DAY_REPORT:
        'Brug denne rapport til at se daglig rutestatistik, herunder driftsomkostninger og indtjening.',
      SOCIAL_CONTROL: '',
      LOCATION_LIST: '',
      ORDER_EXPORT:
        'Hvis du ønsker at bruge data i testmiljøer, anbefaler vi at bruge "Bestil (anonymiserede data)" mulighed',
      ORDER_DEVIATION_EXPORT:
        'Hvis du ønsker at bruge data i testmiljøer, anbefaler vi at bruge "Bestil (anonymiserede data)" mulighed',
      ORDER_EXPORT_ANONYMOUS: 'Kan bruges, hvis data skal importeres til et testmiljø',
      ORDER_PARTNER_EXPORT: 'Tilpasset Excel-fil, der kan bruges til at importere i Opter',
      DEVIATION_EVENTS: '',
      OPTIMIZATION_RESULTS: 'Tilpasset Excel-fil med optimeringsresultater',
      FINANCIAL_REPORT: 'Indeholder yderligere ark med ordrer opdelt efter debetlinjer, hvor det er relevant'
    }
  },
  unit: {
    unitWithCount: '{{count}} enhed',
    unitWithCount_other: '{{count}} enheder',
    new: 'Ny enhed',
    edit: 'Rediger enhed',
    addCourier: 'Tilføj bud',
    hideAddCourier: 'Skjul tilføj bud',
    requiresCourierUsers: 'Skal have mindst et bud',
    created: 'Enheden er blevet oprettet',
    updated: 'Enheden er blevet opdateret',
    search: 'Søg efter enheder fra andre afdelinger...',
    unitsInCurrentDepartment: 'Enheder i nuværende afdeling',
    unitsInOtherDepartments: 'Enheder i andre afdelinger',
    saveUnit: 'Gem enhed',
    addCourierToUnit: 'Tilføj bud til enhed',
    clearSearch: 'Ryd søgning',
    noCouriersFound: 'Ingen kurerer fundet',
    addCourierToUnitSearch: 'Du kan kun søge efter kurerer i afdelinger, du har adgang til',
    addedCouriers: 'Tilføjede kurerer ({{count}})',
    newCourier: 'Opret ny kurer',
    name: 'Navn',
    unitId: 'Enheds-ID',
    couriers: 'Kurerer',
    active: 'Aktiv',
    vehicle: 'Køretøj',
    deleteQuestion: 'Fjern enheden fra den nuværende afdeling',
    deleteDescription: 'Enheden kan tilsluttes igen senere, hvis den stadig er forbundet til andre afdelinger',
    unassigned: 'Enheden blev fjernet fra afdelingen',
    setDefaultVehicle: {
      add: 'Tilføj køretøj',
      change: 'Skift køretøj',
      title: 'Tilføj køretøj til {{unit}}',
      selectVehicle: 'Vælg køretøj',
      addSuccess: 'Køretøjet blev tilføjet til {{unit}}',
      changeSuccess: 'Køretøjet blev ændret på {{unit}}'
    }
  },
  courier: {
    isActive: 'Aktiv',
    canLogIn: 'Kan logge ind',
    recipientName: 'Modtagers navn',
    created: 'Buddet er blevet oprettet',
    updated: 'Buddet er blevet opdateret',
    courier: 'Bud',
    couriers: 'Bude',
    noCouriers: 'Ingen bude',
    courierWithCount: '{{count}} bud',
    courierWithCount_other: '{{count}} bude',
    numberOfCouriers: 'Fundet {{number}} bude',
    multipleDrivers: 'Flere bude',
    missingId: 'Id mangler',
    missingName: 'Navn mangler',
    search: 'Søg efter bud',
    new: 'Nyt bud',
    edit: 'Rediger bud {{name}}',
    name: 'Navn',
    phoneNumber: 'Telefonnummer',
    driverId: 'Bud-ID',
    capacity: 'Kapacitet',
    capacityLabel: 'Kapacitet (antal)',
    weightCapacity: 'Vægtkapacitet (kg)',
    volumeCapacity: 'Volumenkapacitet (m³)',
    maxRangeKm: 'Rækkevidde (km)',
    color: 'Farve',
    resetColor: 'nulstil farve',
    speedFactor: 'Hastighedsfaktor',
    speedFactorExplanation: 'lavere = langsommere',
    serviceTimeFactor: 'Service tidsfaktor',
    serviceTimeFactorExplanation: 'lavere = hurtigere',
    defaultStopLocation: 'Standard stop lokation',
    defaultStartLocation: 'Standard start lokation',
    slotNumDeliveries: '{{count}} levering',
    slotNumDeliveries_other: '{{count}} leveringer',
    slotNumPickups: '{{count}} opsamling',
    slotNumPickups_other: '{{count}} opsamlinger',
    deliverPerformButtonLabel: 'aflever',
    handoverPerformButtonLabel: 'Overlevere',
    deviationPerformButtonLabel: 'Afvigelse',
    deliverWithoutSignatureButtonLabel: 'Uden underskrift',
    deliverWithSignatureButtonLabel: 'Underskrift',
    deviateNotAtHomeButtonLabel: 'Ikke hjemme',
    deviateLocNotFoundButtonLabel: 'Kunne ikke finde lokationen',
    deviateRecipientDeclinedButtonLabel: 'Modtageren ønskede det ikke',
    deviateTimeWindow: 'Kan ikke levere indenfor tidsvinduet',
    addressNotFound: 'Adresse ikke fundet',
    deliverySpotUnavailable: 'Aftalt leveringssted utilgængeligt',
    deliveryAttemptNotPickedUp: 'Leveringsforsøg - Ikke afhentet',
    deviation: {
      'H-12': 'Der blev gjort et forsøg på at levere forsendelsen, men modtageren var ikke til stede',
      'H-11': 'Der er gjort forsøg på at levere pakken, men modtageren blev ikke fundet på adressen',
      'H-10': 'Der er forsøgt at levere pakken, men adressen blev ikke fundet',
      'H-13': 'Levering af sendingen er forsøgt, men forsendelsen blev afvist',
      '7-10': 'Varer kunne ikke afhentes på grund af ufuldstændig adresse',
      '7-12': 'Afsenderen var ikke tilgængelig. Varerne er ikke afhentet',
      '7-82': 'Varerne var ikke klar til afhentning',
      'OFU-10': 'Ufuldstændig adresse',
      'OFU-12': 'Modtager er ikke tilgængelig',
      'OFU-82': 'Godset er ikke klar til afhentning',
      'OFU-DI': 'Ingen varer til afhentning',
      'OFU-87': 'Force majeure',
      'OFU-OCB': 'Nedbrud på bilen',
      'OFU-OL2': 'Ikke nok plads i bilen',
      'OFU-OS1': 'Godset beskadiget før afhentning',
      'V-41-K': 'Forsendelsen er forsinket, videresendes så hurtigt som muligt',
      'V-OL2': 'Ikke nok plads i køretøjet',
      'V-OL4': 'Godset blev ikke fundet',
      'V-OL5': 'Planlagt senere på samme rute',
      '9-91': 'Annulleret af kunden',
      'H-07-R': 'Mislykket social kontrol',
      'H-07-Z': 'Mislykket social kontrol',
      'H-08-Z': 'Mislykket alderskontrol',
      'H-09-Z': 'Mislykket ID kontrol',
      'VI-16-X': 'Kan ikke levere indenfor tidsvinduet',
      'H-11-Z': 'Adresse ikke fundet',
      'H-BL-A': 'Aftalt leveringssted utilgængeligt',
      'A-10': '$t(courier.deviation.7-10)',
      'A-12': '$t(courier.deviation.7-12)',
      'A-82': '$t(courier.deviation.7-82)',
      'V-100-CA': 'Ingen pakkeboks tilgængelig. Pakken leveres som hjemmelevering',
      'V-100-CI': 'Ingen tilgængelig luge',
      'V-80-CI': 'Pakken overskrider de tilladte dimensioner/vægt',
      'V-99-CI': 'Andet ukendt',
      'V-AO-CI': 'Maskinen er ude af drift',
      'H-49-Q': '$t(courier.deliveryAttemptNotPickedUp)',
      'V-X-Y': 'Ordre indlæst af en anden chauffør'
    },
    completionProgressCounter: '{{numCompleted}}/{{numTotal}} gennemført',
    lockCode: 'Dørkode',
    flexDelivery: 'Simpel levering',
    fuelType: 'Brændstoftype',
    fuelTypes: {
      gasoline: 'Benzin',
      natural_gas: 'Naturgas',
      electric: 'Elektricitet',
      bicycle: 'Cykel',
      diesel: 'Diesel',
      rme: 'RME',
      hvo: 'HVO',
      ethanol: 'Ethanol',
      bio_gas: 'Biogas',
      hydrogen: 'Brint'
    },
    fuelCategory: 'Brændstofkategori',
    fuelCategories: { fossil: 'Fossilt brændstof ', fossil_free: 'Fossilfri', zero_emissions: 'Nul-udledning' },
    latestLogin: 'Seneste login',
    latestVersion: 'Seneste version',
    failedSocialControl: 'Mislykket social kontrol',
    failedIdControl: 'Mislykket ID kontrol',
    failedAgeControl: 'Mislykket alderskontrol',
    incompletePickupAddress: 'Ufuldstændig afhentningsadresse',
    custNotAvailableAtPickupAddress: 'Kunden var ikke tilgængelig på afhentningsadressen',
    goodsNotReadyAtPickupForCust: 'Varerne var ikke klar til afhentning hos kunden',
    shipmentNotAvailableAtTerminal: 'Forsendelsen var ikke tilgængelig på terminalen',
    registrationNumber: 'Registreringsnummer',
    commercialTrafficEligibility: 'Kommerciel trafikberettigelse',
    vehicleBrand: 'Køretøjsmærke',
    vehicleModel: 'Køretøjsmodel',
    vehicleControl: 'Køretøjskontrol',
    vehicleControlComment: 'Køretøjskontrol kommentar',
    alcoholDeliveryEducation: 'Uddannelse for levering af alkohol',
    alcoholDeliveryEducationDate: 'Gennemført uddannelse',
    alcoholDeliveryEducationDateMissing: 'Dato mangler',
    alcoholDeliveryEducationDateRequired: 'Angiv datoen hvor alkoholleveringsuddannelsen blev gennemført',
    alcoholDeliveryEducationValidToDate: 'Gyldig til {{date}}',
    alcoholDeliveryEducationExpiresDate: 'Udløber {{date}}',
    alcoholDeliveryEducationExpiredDate: 'Udløbet {{date}}',
    alcoholDeliveryEducationValidTo: 'Gyldig til',
    alcoholDeliveryEducationValidToRequired: 'Angiv datoen uddannelsen er gyldig til',
    alcoholDeliveryEducationValidToAfterEducationDate: 'Gyldig til skal være efter datoen for gennemført uddannelse',
    approved: 'Godkendt',
    notApproved: 'Ikke godkendt',
    couriersInCurrentDepartment: 'Bude i nuværende afdeling',
    editCourier: 'Ret bud:',
    courierUserUpdated: 'Bud er blevet opdateret.',
    secureLoginEnabled: 'BankID-login',
    noCouriersExplain: 'Vi kunne ikke finde nogen resultater. Prøv at søge med et andet udtryk',
    unitId: 'Enheds-ID',
    minShipmentWeightKg: 'Minimum forsendelsesvægt på dette køretøj (kg)',
    maxShipmentWeightKg: 'Maksimal forsendelsesvægt på dette køretøj (kg)',
    canCarryPallets: 'Kan transportere paller',
    noAvailableHatchInParcelBoxMachine: 'Ingen tilgængelig luge',
    packageDoesNotFitInParcelBox: 'Pakken overskrider de tilladte dimensioner/vægt',
    unknownErrorForParcelBoxDelivery: 'Andet ukendt',
    errorInParcelBoxMachine: 'Maskinen er ude af drift',
    euroClass: 'Euroklasse',
    euroClassTypes: { euroEL: 'Euro EL', euro5: 'Euro 5', euro6: 'Euro 6' },
    co2: 'CO2',
    inCurrentDepartment: 'Nuværende afdeling',
    couriersInOtherDepartments: 'Kurerer i andre afdelinger',
    inOtherDepartments: 'Forskellige afdelinger',
    confirmConnect: 'Forbind kurer til nuværende afdeling',
    confirmModalDescription: '',
    searchForCouriers: 'Søg efter kurerer',
    dateOfBirth: 'Fødselsdato',
    dateNotValid: 'Ugyldig dato',
    dateOfBirthWithFormat: 'Fødselsdato (åååå-mm-dd)',
    occupationalInjuryInsurance: 'Arbejdsskadeforsikring',
    courierScanEnabled: 'Scan',
    breakTime: 'Pause',
    breakDuration: 'Pauses varighed (min)',
    timeWindow: 'Start på pause (tidligste og seneste)',
    breakTimeDescription:
      'I inputfelterne <i>Start på pause (tidligste og seneste)</i> angiver du det tidligste og seneste tidspunkt for pause. For eksempel betyder 11:00 - 17:00, at chaufføren senest kan starte pausen kl. 17:00.',
    breakOptimizingSupportDescription:
      'Bemærk, at pauser kun understøttes ved optimering af ruter med GraphHopper. Denne funktion er ikke tilgængelig ved brug af PTV.',
    between: 'Mellem',
    editBreakTime: 'Rediger pausetid',
    updateBreakTime: 'Opdater pausetid',
    latestBreakStart: 'Seneste start på pause',
    radioButtons: { noBreakTime: 'Ingen pause', timeWindow: 'Tidsvindue', workingTime: 'Arbejdstid' },
    workingTimeDescription:
      'Du angiver den maksimale arbejdstid, før chaufføren skal tage en pause. For eksempel, efter 8 timer skal chaufføren tage en 30-minutters pause.',
    maxWorkingTime: 'Maksimal arbejdstid',
    selectMaxWorkingTime: 'Vælg maksimal arbejdstid',
    hours: '{{hours}} timer',
    breakTooltip: 'Du kan kun have én pausetype pr. enhed'
  },
  slot: {
    minutesDelay: 'minutter forsinket',
    minutesAhead: 'minutter foran',
    minutes: 'minutter',
    time: 'Tid',
    created: 'Oprettet',
    assigned: 'Behandlet',
    lock: 'Lås',
    lockDescription:
      'Når en rute er låst, vil den ikke være en del af fremtidige ruteoptimeringer og kan ikke redigeres.',
    toggleVisibleSlotDescription: 'Skjul rute.',
    inProgress: 'I gang',
    onHold: 'Afventer',
    complete: 'Gennemført',
    unknownState: 'Ukendt tilstand',
    courierSelect: 'Vælg bud',
    unitSelect: 'Vælg enhed',
    printableSlotList: 'Printbar ruteliste',
    followsRoute: 'Følger',
    doesNotFollowRoute: 'Afviger',
    hasLocation: 'Synlig',
    hasNoLocation: 'Ikke synlig',
    showActiveSlots: 'Igangværende',
    showSlotNotStarted: 'Ikke startet',
    showLoggedInRoutes: 'Logget ind - ikke startet',
    showCompletedSlot: 'Gennemførte',
    showPerfectSlot: 'Perfekte',
    filterSlots: 'Filtrer ruter',
    planningCompleted: 'Færdig',
    completeWithLastSent: '{{label}} (sidst sendt: {{time}})',
    addMapArea: 'Vælg område på kort',
    editMapArea: 'Rediger område på kort'
  },
  login: {
    phone: 'Indtast dit Glow-registrerede telefonnummer med landekode (f.eks. +45 …), så sender vi en SMS-kode.',
    code: 'Koden er sendt, hvis du har registreret en bruger med dette nummer. Den er gyldig i 5 minutter. Indtast koden.',
    requestNewCode: 'Anmod om en ny kode',
    verifyFailed:
      'Kode eller telefonnummer er forkert, eller for mange forsøg på login er brukt, prøv igen eller anmod om en ny kode',
    requestFailed: 'Kunne ikke sende kode, prøv igen.',
    verifyTokenButton: 'Bekræft kode',
    requestTokenButton: 'Anmod om kode',
    privacyLink: 'Fortrolighedspolitik',
    passwordWrong: 'Forkert password',
    customer: 'Jeg er en kunde',
    forgotPassword: 'Glemt password?',
    tryApp: 'Prøv den nye App!',
    appDownload: 'Download chauffør-appen her og få adgang til endnu flere funktioner!',
    appInfo:
      'Er du en chauffør med en Android- telefon? Download chauffør-appen <1>her</1> og få adgang til endnu flere funktioner!',
    webApp: 'Webapp',
    note: 'Bemærk! Brug kun webversionen af Bud-Appen, hvis du af en eller anden grund ikke kan bruge apps til iOS og Android',
    resendToken: 'Gensend kode',
    heading: 'Log ind',
    submitPassword: 'Indsend adgangskode',
    forgotPasswordDescription:
      'For at fortsætte skal du angive en adgangskode. Vi sender dig en e-mail med et link til at angive denne. Hvis din e-mail er ændret, må du kontakte en administrator for at ændre den.',
    sendEmailDescription:
      'For at fortsætte har vi brug for din e-mail. Vi sender dig et bekræftelseslink til den angivne adresse. Med dette link kan du sætte din totrins adgangskode.',
    loginAsCustomer: 'Log ind som kunde',
    loginAsPlanner: 'Log ind som planlægger',
    loginAsPartnerOrPhoneNumber: 'Log ind som partner',
    loginWithPhoneNumber: 'Log ind med telefonnummer',
    loginUsingSSO: 'Log ind med Posten-konto',
    partnerLoginTitle: 'Login med telefonnummer er for partnere',
    partnerLoginBody:
      'Kun partnerbrugere kan logge ind med telefonnummer. Som Glow- og Bring-medarbejder, brug <pageLink>denne side</pageLink>.',
    ssoLoginFailed: 'Du kunne ikke logges ind. Kontakt Posten og Bring servicedesk, hvis problemet fortsætter.',
    token: 'Kode',
    password: 'Adgangskode',
    tokenRequired: 'Kode er påkrævet',
    emailFormatValidation: 'E-mail skal være i gyldigt format',
    sendEmailSuccess: 'E-mailen burde komme snart',
    setYourPassword: 'Angiv din adgangskode',
    sendEmail: 'Send e-mail',
    passwordsDontMatch: 'Adgangskoderne stemmer ikke overens',
    passwordNotMeetRequirements: 'Adgangskoden opfylder ikke kravene',
    passwordRequired: 'Adgangskode er påkrævet',
    newPassword: 'Ny adgangskode',
    repeatPassword: 'Gentag din adgangskode',
    lowercaseLetter: 'Et lille bogstav',
    uppercaseLetter: 'Et stort bogstav',
    numberCharacter: 'Et tal',
    minimumCharacters: 'Minimum 15 tegn',
    passwordDescription: 'Du kan nu angive din adgangskode. Den skal indeholde følgende',
    sendEmailFailed: 'Afsendelse af e-mail mislykkedes, prøv igen'
  },
  error: {
    '404Title': 'Side ikke fundet',
    '404Message': 'Vi kan ikke finde siden du leder efter',
    '500Message': '{{error}} – Beklager, vi kan ikke finde dine data… Vi forsøger igen om et minut…',
    title: 'Noget gik galt!',
    dateRequiredWhenSecureLogin: '*Obligatorisk felt for BankID er aktiveret',
    dateNotValid: 'Ugyldig dato',
    dateCannotBeInFuture: 'Datoen kan ikke være i fremtiden',
    dateCannotBeInThePast: 'Datoen kan ikke være i fortiden',
    dateCannotBeOlderThanMonths: 'Datoen kan ikke være mere end {{months}} måneder gammel',
    dateOutsideRange: 'Dato uden for gyldigt interval',
    errorMessage: 'Vi beklager! Det virkede ikke som planlagt, men udviklerne er blevet underrettet om fejlen.',
    errorClickToReload: 'Klik her for at genindlæse siden',
    phoneNumber: 'Du skal angive en gyldigt telefonnummer, f.eks. +45 12345678',
    phoneNumberPrefix: 'Du skal angive en landekode, f.eks. +45 ...',
    somethingWentWrong: 'Noget gik galt.',
    andMoreErrors_one: 'og {{count}} fejl mere',
    andMoreErrors_other: 'og {{count}} fejl mere',
    notAValidNumber: 'Ikke et gyldigt nummer',
    notAValidAlphaNumeric: 'Skal være tall og/eller bogstaver',
    notAValidDate: 'Skal være en gyldig dato (åååå-mm-dd)',
    notAValidTime: 'Skal være et gyldigt tidspunk (tt:mm)',
    notAValidDuration: 'Skal være en gyldig varighed (mm:ss)',
    notAValidZipCode: 'Skal være et gyldigt postnummer',
    notAValidPostalCodeRange: "'Fra postnummer' skal være mindre end eller lig med 'Til postnummer'",
    notAValidTimezone: 'Skal være en gyldig tidssone. Prøv "Europe/Copenhagen" eller noget som ligner',
    somethingWentWrongOnTheServer: 'Noget gik galt på serveren...',
    somethingWentWrongWithTheRequest: 'Der var noget galt med anmodningen...',
    somethingWentWrongWithTheResponse: 'Der var noget galt med svaret...',
    selectAtLeastOne: 'Du må vælge mindst et af valgene',
    timeInWrongFormat: 'Tiden er ikke gyldig',
    invalidEmail: 'Du skal angive en gyldig e-mailadresse, f.eks. name@gmail.com',
    requiredBreakDuration: 'Du skal angive pauselængde',
    notAValidTimeWindow: 'Den tidligste pause skal starte før den seneste',
    requiredEarliestStartBreak: 'Du skal angive tidligste pause',
    requiredLatestStartBreak: 'Du skal angive seneste pause',
    requiredIfWorkingTimeDuration: 'Du skal angive maksimale arbejdstid',
    invalidUrlParameterCombination: 'Denne kombination af URL-parametre er ugyldig, og siden kan ikke vises',
    numberCannotContainDecimals: 'Tallet må ikke indeholde decimaler',
    selectAtLeastOneItem: 'Mindst ét element skal vælges',
    mustSelectDepartment: 'Du skal vælge en afdeling',
    mustSelectRoute: 'Du skal vælge en rute',
    mustProvideLabel: 'Du skal angive {{label}}',
    sizeMustBeAnIntegerGreaterThanZero: 'Størrelsen skal være et tal uden decimaler, der er større end eller lig med 1'
  },
  loading: 'Vi henter dine data...',
  newAppVersion: 'Glow blev lige en smule bedre, vi henter ny version nu.',
  loadingReceiptList: 'Kvitteringslister genereres...',
  invoicing: { departmentInvoicingInProgress: 'Fakturering i gang...' },
  months: {
    january: 'Januar',
    february: 'Februar',
    march: 'Marts',
    april: 'April',
    may: 'Maj',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'December'
  },
  weekdays: {
    monday: 'Mandag',
    tuesday: 'Tirsdag',
    wednesday: 'Onsdag',
    thursday: 'Torsdag',
    friday: 'Fredag',
    saturday: 'Lørdag',
    sunday: 'Søndag'
  },
  weekdaysShort: {
    sunday: 'Søn',
    monday: 'Man',
    tuesday: 'Tir',
    wednesday: 'Ons',
    thursday: 'Tor',
    friday: 'Fre',
    saturday: 'Lør'
  },
  notifications: {
    dismiss: 'Afvis',
    dismissAll: 'Afvis alle',
    dismissAllNotifications: 'Afvis alle notifikationer?',
    error: 'Fejl',
    reload: 'Opdater',
    reloadCourier: 'Tryk her for at genindlæse',
    navigate: 'Naviger til side',
    networkError: 'Det ser ud til, at der er netværksproblemer, det kan være midlertidigt. Men siden skal genindlæses.',
    networkErrorCourier: 'Du har været offline, vær venlig at genindlæse.',
    liveUpdatesPaused: 'Liveopdateringer er sat på pause',
    liveUpdatesDescription:
      'Liveopdateringer blev sat på pause, mens fanen var inaktiv. Klik for at genindlæse og anvende de nyeste opdateringer.'
  },
  grid: {
    columns: {
      addressWashRecipientId: 'Modtager ID',
      addressWashAddressId: 'Adresse ID',
      department: 'Afdeling',
      deadline: 'Frist',
      failedReason: 'Fejlmeddelelse',
      exceptions: 'Undtagelser',
      dispatchAsGroup: 'Dispatch som gruppe',
      name: 'Navn',
      senderName: 'Afsendernavn',
      puearly: 'PU',
      pulate: 'AF',
      delearly: 'LEV',
      dellate: 'LEV',
      vas: 'VAS',
      zip: 'Postnr.',
      type: 'Type',
      estimated: 'Estimeret tid',
      estimatedDepartureTime: 'ETD',
      adjusted: 'Justeret',
      timeWindow: 'Tidsvindue',
      onCar: 'På bil',
      frequency: 'Hyppighed',
      startDate: 'Start dato',
      endDate: 'Slut dato (valgfrit)',
      from: 'Fra',
      to: 'Til',
      days: 'Dage',
      holidays: 'Helligdage',
      startdate: 'Start dato',
      enddate: 'Slut dato',
      orders: 'ordrer',
      id: 'ID',
      shipmentId: 'Forsendelsesnummer',
      packageId: 'Pakkenummer',
      errorMessage: 'Fejl',
      customer: 'Kunde',
      pickup: 'Opsamling',
      delivery: 'Levering',
      service: 'Tjeneste',
      address: 'Adresse',
      zipcode: 'Postnummer',
      area: 'Område',
      weight: 'Vægt',
      volume: 'Volumen{{unit}}',
      bookedWeight: 'Booked vægt{{unit}}',
      bookedVolume: 'Booked volumen{{unit}}',
      qty: 'Antal',
      preplanned: 'Forudplanlagte',
      preplannedRouteTemplate: 'Rute',
      group: 'Gruppe',
      totalOrders: 'Samlet antal ordrer',
      ordersFailed: 'Ordrer mislykkedes',
      date: 'Dato',
      finished: 'Afsluttede',
      failed: 'Mislykkedes',
      ordersInvoiced: 'Fakturerede ordrer',
      start: 'Start',
      stop: 'Stop',
      pickupContactPerson: 'Opsamling Kontaktperson',
      pickupPhone: 'Opsamling telefon',
      deliveryContactPerson: 'Levering kontaktperson',
      deliveryPhone: 'Levering telefon',
      deliveryAddress: 'Leveringsadresse',
      deliveryTime: 'Leveringstid',
      contactPerson: 'Kontaktperson',
      phone: 'Telefon',
      email: 'E-mail',
      deliveryReferencePlaceholder: 'Modtagers reference',
      specificationDescriptionPlaceholder: 'Vareoplysninger',
      multileg: 'Multileg',
      groupName: 'Gruppenavn',
      customerNumber: 'Kundenummer',
      orderNote: 'Intern note',
      returned: 'Returneret',
      price: 'Pris',
      slotName: 'Rute',
      estimatedArrivalTime: 'ETA',
      waitingTime: 'Ventetid',
      timeOfDelivery: 'ToD',
      timeOfPickup: 'AT',
      deliveryEtaSmsSentAt: 'Leverings ETA SMS sendt',
      trip: 'Rejse',
      addresses: {
        title: 'Adresser',
        search: 'Adressesøgning',
        searchAddresses: 'Søg adresser',
        filterAddresses: 'Filtrer adresser',
        deleteConfirmation: 'Er du sikker på du vil slette denne adresse?',
        deleteMultipleConfirmation: 'Er du sikker på du vil slette alle valgte adresser?',
        deleteSuccess: 'Adresse slettet',
        deleteMultipleSuccess: 'Adresser slettet',
        delete: 'Slet',
        name: 'Navn',
        phone: 'Telefonnummer',
        address: 'Adresse',
        zipArea: 'Område',
        zipCode: 'Postnummer',
        country: 'Land',
        contactPerson: 'Kontaktperson',
        instructions: 'Instruktioner',
        deleteAddress: 'Slet adresse',
        deleteMultipleAddresses: 'Slet adresser ({{count}})',
        loc: 'Lok',
        locTitle: 'Lokation'
      },
      orderGrid: { vehicleType: 'Køretøj', extraInfo: 'Ekstra info' },
      dispatch: {
        adjusted: 'Justeret',
        customerName: 'Kundenavn',
        estimatedDepartureTime: 'ETD',
        service: 'Tjeneste'
      },
      goodsType: 'Godstype',
      orderSource: 'Ordrekilde',
      postalCodes: '# postnumre',
      displayEndCustomerPriceShd: 'Vis kundepris',
      courier: 'Bud',
      createdBy: 'Lavet af',
      createdAt: 'Lavet',
      plannedDeliveryDate: 'Planlagt dato',
      orderedDeliveryDate: 'Bestilt dato',
      lastUpdatedAt: 'Sidst opdateret til',
      route: 'Rute',
      instructions: 'Instruktioner',
      pickupDuration: 'PU varighed',
      deliveryDuration: 'DEL varighed',
      pickupPreparation: 'PU forberedelse',
      deliveryPreparation: 'DEL forberedelse',
      originalPickupAddress: 'Oprindelig afsenderadresse',
      originalPickupZipCode: 'Oprindelig afsenderpostnummer',
      originalPickupZipArea: 'Oprindelig afsenderby',
      originalPickupCountry: 'Oprindelig afsenderland',
      originalDeliveryAddress: 'Oprindelig modtageradresse',
      originalDeliveryZipCode: 'Oprindelig modtagerpostnummer',
      originalDeliveryZipArea: 'Oprindelig modtagerby',
      originalDeliveryCountry: 'Oprindelig modtagerland',
      packagesArrivedAtDip: 'Ankommet',
      packagesCollected: 'Afhentning',
      packagesDelivered: 'Levering',
      originalDeliveryEarliest: 'Oprindelig DEL',
      originalDeliveryEarliest1: 'Oprindelig LEV 1',
      originalDeliveryLatest: 'Oprindelig DEL',
      originalDeliveryLatest2: 'Oprindelig LEV 2',
      preAdvices: 'Preaviseringsforsøg',
      preAdviceScheduledDate: 'Første preaviseringsdato',
      hasPreAdviceSettings: 'Aviseringsregler',
      arrivedAtHub: 'Ankommet HUB',
      returnToSender: 'Retur til afsendre',
      preAdviceFailed: 'Mislykkedes',
      deliveryAttempts: 'Leveringsforsøg',
      shipmentCreationDate: 'Oprettelsesdato for forsendelse',
      preAdviceResult: 'Resultat af preavisering',
      failedPreAdviceDate: 'Dato for mislykket preavisering',
      loadCarrierId: 'Lastbærer-ID',
      deliveryPupUnitId: 'PUP ID',
      loadCarrier: 'Lastbærer',
      pickupZipCode: 'Afhentningspostnummer',
      pickupArea: 'Afhentningsområde',
      deliveryZipCode: 'Leveringspostnummer',
      deliveryArea: 'Leveringsområde',
      plannedStops: 'Planlagte stop'
    },
    columnSettings: {
      header: 'Tilføj kolonner i datatabellen',
      description: 'Når du vælger en etiket, vises disse oplysninger i datatabellen'
    }
  },
  openBooking: {
    error: {
      pickupTimeNotWithinServiceTimeWindow: 'Afhentningstiden er ikke inden for tjenestens tidsvindue',
      pickupTimeBeforeEarliestServicePickupTime:
        'Afhentningstiden kan ikke være før tjenestens tidligste afhentningstid',
      pickupNotAvailableForWeekend: 'Afhentning er ikke tilgængelig i weekenden',
      invalidOrganisationNumber: 'Ugyldigt organisationsnummer'
    }
  },
  instant: {
    title: 'Disponering',
    openMap: 'Åben kort',
    group: 'Gruppe valgt',
    editGroup: 'Rediger gruppe',
    groupName: 'Gruppe navn',
    groupOrders: 'Ordregruppe',
    viewGroup: 'Vis gruppe',
    ordersToGroup: 'Ordrer til gruppe',
    fixedOrder: 'Fast leveringsrækkefølge',
    saveFixedOrder: 'Gem ændringer i rækkefølge',
    paidTogether: 'Betalt sammen',
    saveGroup: 'Gem gruppe',
    ungroup: 'Ophæv gruppering',
    removeSelected: 'Fjern valgte',
    split: 'Opdel valgte',
    noCourierSelected: 'Intet bud valgt',
    noOrderSelected: 'Ingen ordre valgt',
    workingHours: 'Arbejdstimer',
    chatButton: 'Chat med chauffør',
    offeredShipments: 'Tilbudte forsendelser',
    rejectedShipments: 'Afviste forsendelser',
    rejectedShipmentsSnackbar: '{{count}} afvist forsendelse af "{{name}}"',
    rejectedShipmentsSnackbar_other: '{{count}} afviste forsendelser af "{{name}}"',
    toBeDone: 'Opsamlinger og leveringer der skal udføres',
    finishedRoutePoints: 'Færdige opsamlinger og leveringer',
    suggestedRouteApplied: 'Den foreslåede rute er anvendt',
    suggestedRouteCancelled: 'Den foreslåede rute er blevet annulleret',
    reorderValidationError: 'Den foreslåede rækkefølge er ugyldig',
    planSlot: 'Ruteplan',
    createRoute: {
      vehiclePlaceholder: 'Intet køretøj valgt',
      title: 'Vælg køretøj for at oprette ny rute',
      description:
        'Denne enhed er endnu ikke tilknyttet en rute. Når de valgte forsendelser tilføjes til denne enhed, oprettes en ny rute. Vælg et køretøj til ruten.'
    },
    columnSettings: {
      reset: 'Nulstil',
      settings: 'Indstillinger',
      hideColumns: 'Vis kolonner',
      saveAndClose: 'Gem og luk'
    },
    routePoint: { pickup: 'A', delivery: 'L', depot_call: 'PS', start: 'S', end: 'E' },
    confirmation: {
      heading: 'Ordrebekræftelse',
      from: 'Fra',
      to: 'Til',
      service: 'Tjeneste',
      pickup: 'Opsamling',
      delivery: 'Levering',
      shipmentNumber: 'Forsendelsesnummer',
      printLabel: 'Udskriv label',
      copyOrder: 'Kopier ordre',
      editOrder: 'Rediger ordre'
    },
    goods: {
      custom: 'Brugerdefineret',
      letter: 'Brev',
      bag: 'Pose',
      smallbox: 'Lille kasse',
      mediumbox: 'Medium kasse',
      largebox: 'Stor kasse',
      tube: 'Rør',
      quarterpallet: 'Kvart palle',
      halfpallet: 'Halv palle',
      fullpallet: 'Palle',
      suitcase: 'Kuffert',
      movingbox: 'Flyttekasse',
      trolley: 'Vogn',
      parcel: 'Kolli',
      expressbox: 'Express boks',
      '9A': 'Rullebur pakker, gods',
      '9C': 'Rullebur tom',
      '9F': 'Halvpalle  breve',
      '9J': 'Palle breve',
      PX: 'Palle',
      PA: 'Pakke',
      AF: 'Halvpalle',
      SA: 'Sæk',
      CS: 'Kassette',
      '9N': 'Monsterbur, pakker',
      '9O': 'Monsterbur, tomt',
      '9B': 'Rullebur breve',
      '9D': 'Rullebur diverse',
      '9E': 'Halvpalle  pakker, gods',
      '9G': 'Halvpalle  tom',
      '9H': 'Halvpalle  diverse',
      '9I': 'Palle pakker, gods',
      '9K': 'Palle tom',
      '9L': 'Palle diverse',
      '9M': 'Brev stk.',
      '9P': 'IKEA TU lang',
      '9Q': 'IKEA TU kort',
      '9Z': 'Ukendt volumen',
      BE: 'Bundt',
      BG: 'Pose',
      BX: 'Kasse',
      CD: 'Kande',
      CL: 'Rulle',
      CN: 'Container',
      CR: 'Tremmekasse',
      CT: 'Karton',
      CW: 'Rullebur',
      DR: 'Tønde',
      ED: 'Pallekasse',
      LT: 'Parti',
      OA: 'Kvartpalle',
      OC: 'Søpalle',
      OT: 'Bulkboks',
      PB: 'Palleboks',
      PC: 'Pakke',
      PE: 'Palle modulær',
      PI: 'Rør',
      PK: 'Kolli',
      PP: 'Stykke',
      PV: 'Rørbundt',
      RK: 'Reol',
      RO: 'Rulle',
      RV: 'Rek. værdi',
      SE: 'Sættevogn',
      TY: 'Tank, cylindrisk',
      VB: 'Veksellad',
      Z1: 'Bisonpalle',
      Z2: 'Blomsterbur',
      Z3: 'Bananpalle',
      Z4: 'Frugtbur',
      Z5: 'Palle lav',
      Z6: 'Palle Rema',
      Z8: 'Mælkebur',
      ZZ: 'Ukendt'
    },
    instantGrid: {
      editColumnTooltip: 'Klik for at redigere',
      deleteColumnTooltip: 'Klik for at slette',
      unassignColumnTooltip: 'Klik for at fjerne tildelingen af forsendelsen',
      dragColumnTooltip: 'Klik og træk for at tildele forsendelsen til et bud',
      filtersActive: 'Filtre er aktive',
      clearFilters: 'Fjern alle filtre',
      filterPlaceholder: 'filtrer <enter>',
      assignColumnTooltip: 'Klik for at tildele forsendelsen'
    },
    booking: {
      numberOfCopies: 'Antal kopier',
      numberOfCopiesPlaceholder: 'Indtast et tal mellem {{min}} og {{max}}',
      numberOfCopiesError: 'Du skal indtaste et tal mellem {{min}} og {{max}}',
      afterCutoffWarning:
        'Levering ikke mulig - cut-off tid {{cutoffTime}} i dag er overskredet. Vælg en anden service eller leveringsdag.',
      standaloneInvoiceCheckbox: 'Marker som separat faktura',
      standaloneInvoiceDescription:
        'Ved at vælge denne mulighed behandles denne ordre individuelt og vil ikke blive grupperet med andre ordrer til fakturering.',
      addPackage: 'Tilføj ny pakke',
      removePackageRow: 'Fjern pakke',
      cannotRemoveLastPackageRow: 'Den sidste pakke kunne ikke fjernes',
      copyPackageRow: 'Kopiér pakke',
      title: 'Booking',
      header: 'Booking',
      headerCreate: 'Ny booking',
      headerEdit: 'Rediger booking',
      headerCopy: 'Kopier booking',
      headerRestore: 'Gendan ordre',
      customer: 'Kunder',
      customerPlaceholder: 'Kunde id',
      subcustomerPlaceholder: 'Underkunde',
      invoiceSplitPlaceholder: 'Faktura split',
      invoiceSplitPlaceholderLegend: 'Velg faktura split',
      invalidSubcustomer: 'Subcustomer-navn er ugyldigt',
      shipmentOrPackageId: 'Forsendelses ID eller Pakke ID',
      creditBlockedCustomer: 'Kreditspærret kunde',
      sender: 'Afsender',
      setAsDefaultAddress: 'Indstil som standardadresse',
      setAsDefaultDisabledText: 'Manglende koordinater. Angiv adressen ved hjælp af adressesøgefeltet',
      defaultAddressUpdated: 'Standardadresse opdateret',
      priceDetails: 'Prisdetaljer',
      recipient: 'Modtager',
      pickupNamePlaceholder: 'Navn',
      pickupAddressPlaceholder: 'Adresse',
      pickupZipCodePlaceholder: 'Postnummer',
      pickupZipAreaPlaceholder: 'By',
      pickupCountryPlaceholder: '-- Vælg land --',
      pickupPhoneNumberPlaceholder: 'Telefon',
      pickupContactPerson: 'Kontaktperson',
      customerReference: 'Kundereference',
      pickupReferencePlaceholder: 'Kundereference',
      pickupInformationPlaceholder: 'Afhentningsinformation',
      pickupEmailPlaceHolder: 'E-mail',
      customerContact: 'Kontaktperson hos kunden',
      customerContactPlaceholder: '$t(instant.booking.customerContact) – Dette felt vises på fakturaen',
      customerInfoPlaceholder: 'General kundespecifik information',
      customerInfoHelper:
        'Denne information er forbundet til en kunde. Ændringer foretaget vil blive synlig på alle ordrer forbundet til kunden.<br><br>Brug ”note” feltet nedenfor, for at tilføje ordrespecifik information.',
      deliveryNamePlaceholder: 'Navn',
      letterBoxPrefix: 'Postkasse',
      letterBoxAlt: '{{operator}} postkasse',
      deliveryAddressPlaceholder: 'Adresse',
      deliveryZipCodePlaceholder: 'Postnummer',
      deliveryZipAreaPlaceholder: 'By',
      deliveryCountryPlaceholder: '-- Vælg land --',
      deliveryPhoneNumberPlaceholder: 'Telefon',
      deliverySecondPhoneNumberPlaceholder: 'Andet telefonnummer',
      deliveryEmailPlaceHolderPlaceholder: 'E-mail',
      deliveryReferencePlaceholder: 'Modtagers reference',
      deliveryInformationPlaceholder: 'Leveringsinformation',
      orderNote: 'Intern note',
      dimensions: 'Gods',
      invalidInvoiceSplit: 'Ugyldig fakturaopdelingstekst',
      clearData: 'Ryd data',
      weightPlaceholder: 'Vægt (kg)',
      lengthPlaceholder: 'Længde (cm)',
      widthPlaceholder: 'Bredde (cm)',
      heightPlaceholder: 'Højde (cm)',
      service: 'Tjeneste',
      serviceCode: 'Servicekode',
      servicePlaceholder: 'Servicekode',
      serviceSelect: 'Vælg service',
      serviceSelectDisabled: 'Ændring af tjenester på HD -ordrer udføres i HappyFlow',
      deliveryOrderService: {
        description: 'Leveringsordre'
      },
      goodsEditDisabled: 'Ændringer af gods på HD -ordrer udføres i HappyFlow',
      standardServices: '-- STANDARDTJENESTER --',
      customizedServices: '-- KUNDESPECIFIKKE SERVICES --',
      specificationDescription: 'Gods',
      specificationDescriptionPlaceholder: 'Vareoplysninger',
      invoiceInfo: 'Fakturaoplysninger',
      invoiceInfoPlaceholder: 'Fakturainformation – Dette felt er synligt på kundefakturaen',
      manualInvoiceInfo: 'Manuel fakturahåndtering',
      manualInvoiceInfoPlaceholder:
        'Manuel fakturahåndtering (Hvis dette felt er udfyldt med faktureringsinstruktioner, faktureres ordren ikke automatisk)',
      pickup: 'Afhentning',
      delivery: 'Levering',
      pickupDatePlaceholder: 'Afhentningsdato',
      pickupTimePlaceholder: 'Afhentningstid',
      deliveryDatePlaceholder: 'Leveringsdato',
      deliveryTimePlaceholder: 'Leveringstid',
      deliveryContactPerson: 'Kontaktperson',
      restoreButton: 'Gendan',
      orderButton: 'Bestil',
      editButton: 'Opdater',
      copyButton: 'Bestil',
      created: 'Ordren er registreret',
      edited: 'Ordren er opdateret',
      quickSelect: 'Hurtig valg',
      volume: 'Volumen',
      points: 'Punkter',
      totalVolume: 'Total volumen {{volume}}',
      totalWeight: 'Total vægt {{weight}}',
      removeItem: 'Fjern',
      copyItem: 'Kopiere',
      addItem: 'Tilføj',
      calculatePrice: 'Beregn pris',
      priceExplanations: {
        header: 'Prisforklaring',
        article: 'Artikel: {{article}}',
        priceListName: 'Prisliste:: {{pricelist}}',
        explanations: 'Forklaringer',
        noInfo: 'Ingen prisoplysninger tilgængelige',
        details: 'Detaljer',
        notFound: 'Ingen prisforklaringer tilgængelige.'
      },
      approveIncompletePrice: 'Jeg godkender alle rækker med nul pris',
      muteBomArticles: 'Udeluk {{bomArticle}} fra fakturering',
      prePlan: 'Planlæg',
      prePlannedToCourier: 'Vælg bud',
      prePlannedToRouteTemplate: 'Vælg rute',
      prePlannedToRouteText:
        'Tilgængelige ruter afhænger af de skabeloner, der er gemt på afdelingen. For at automatisk ruteplanlægning skal fungere korrekt, skal du konfigurere ruteindstillinger <0>på afdelingsniveau</0> på administrationssiderne.',
      automaticDepartment: 'Automatisk',
      departmentLabel: 'Afdeling',
      notifications: 'Notifikationer',
      emailNotifications: 'E-mail notifikationer',
      eventRegistered: 'Registreret',
      eventPickup: 'Afhentning',
      eventDelivery: 'Levering',
      emailAddress: 'E-mailadresse',
      emailRecipientText: 'Følgende e-mailadresser modtager notifikationer:',
      invalidEmail: 'Ugyldig e-mailadresse',
      editIndicator: 'Rediger',
      updateIndicator: 'Opdater',
      copyIndicator: 'Kopier',
      quantity: 'Mængde',
      additionalServices: 'Ekstra services',
      paymentInformation: 'Betalingsoplysninger',
      paidTogetherLabel: 'Betalt sammen?',
      groupingLabel: 'Forsendelsesgruppering',
      groupIdPlaceholder: 'Unik gruppe id',
      groupOrderPlaceholder: 'Grupperet forsendelsesrækkefølge',
      addRecipient: 'Tilføj flere modtagere',
      addPickup: 'Tilføj flere afsendere',
      vehicleType: 'Køretøjstype',
      vehicleTypeUpdated: 'Køretøjstype er opdateret',
      selectVehicleType: 'Vælg køretøjstype',
      customerPrice: 'Kundepris',
      resourcePrice: 'Unitpris',
      priceList: 'Prisliste',
      manualPrice: 'Manuel',
      total: 'Total',
      vehicleTypes: {
        car: 'Bil',
        bicycle: 'Cykel',
        truck: 'Lastbil',
        van: 'Varebil',
        motorcycle: 'Motorcykel',
        cargobike: 'Lastcykel'
      },
      date: 'Dato',
      unNumber: 'UN-nummer',
      hazardous: 'Klasse',
      class: 'Klasse',
      group: 'Gruppe',
      netWeight: 'Nettovægt',
      name: 'Navn',
      restrictions: 'Restriktioner',
      totalPoints: 'Samlet antal point',
      unacceptableMeasurementsError:
        'Målene er ikke korrekte. Angiv enten alle dimensioner korrekt, eller alle pakker skal have volumen.',
      serviceMessage: 'Husk at tilføje kunde for at se tilgængelige tjenester',
      pickupTimeEarliest: 'Tidligste afhentningstid',
      pickupTimeLatest: 'Seneste afhentningstid',
      deliveryTimeEarliest: 'Tidligste leveringstid',
      deliveryTimeLatest: 'Seneste leveringstid',
      henteordre: {
        availableTimeSlots: 'Tilgængelige tidsvinduer',
        setCustomTimes: 'Angiv brugerdefinerede tider',
        selectAvailableTimes: 'Vælg tilgængelige tider',
        enterPickupZipCode: 'Indtast afhentningspostnummer for at se tilgængelige tidsvinduer'
      },
      hazardousGoods: 'Farligt gods'
    },
    courierSorting: { title: 'Sorter efter', alystraId: 'Unit id', empty: 'Tom', full: 'Fuld' },
    courierFilter: {
      title: 'Filtrer bude efter',
      all: 'Vis alle',
      inactive: 'Skjul inaktive',
      offline: 'Skjul offline',
      both: 'Skjul inaktive og offline'
    },
    invoicingFilter: {
      ALL: 'Vis alle',
      INVOICED_OK: 'Allerede faktureret',
      TO_BE_INVOICED: 'Klar til fakturering',
      ORDER_CORRECTION: 'Med ordrekorrektion',
      INVOICED_FAILED: 'Fakturering mislykkedes'
    },
    shipmentFilter: {
      title: 'Filtrer forsendelser',
      showAll: 'Vis alle',
      notCollected: 'Ikke afhentet',
      hideAll: 'Skjul alle'
    },
    offer: {
      carEmpty: 'Bilen er på nuværende tidspunkt tom',
      suggestedDelivery: 'Foreslået leveringsrækkefølge',
      newShipments: 'Ny forsendelse',
      manualRoute: 'Tvungen rute',
      confirmRoute: 'Bekræft rute',
      assigning: 'Tildeling',
      replanning: 'Omplanlægger rute for',
      shipmentsTo: 'forsendelser til',
      shipmentTo: 'forsendelse til'
    },
    useFlexible: 'Brug fleksible tider',
    forceOptimizing: 'Tving optimering af rækkefølge',
    replanRoute: 'Omplanlæg rute',
    recurring: {
      exceptionsUpdated: 'Undtagelser opdateret',
      dispatchAsGroup: 'Dispatch som gruppe',
      recurringOrderSaved: 'Tilbagevendende ordre gemt',
      executeDate: 'Udførelsesdato',
      confirmExecuteOrders: 'Er du sikker på, at du vil udføre alle tilbagevendende ordrer for {{date}}?',
      editRecurringOrder: 'Rediger tilbagevendende ordre',
      createRecurringOrder: 'Opret tilbagevendende ordre',
      title: 'Tilbagevendende',
      successMessage: '{{number}} forsendelse(r) blev tilføjet til valgte gentagelsesgrupper',
      recurringOrders: 'Tilbagevendende ordrer',
      includedOrders: 'Ordrer indgår i tidsplanen',
      details: 'Detaljer',
      editOriginal: 'Rediger original',
      copyOriginal: 'Kopier original',
      notStarted: 'Ikke startet',
      executing: 'Kører...',
      ended: 'Færdigt',
      status: 'Status',
      pending: 'Resterne',
      ok: 'OK',
      total: 'Samlet',
      failedOrders: 'Mislykkede ordre',
      exceptionsHeading: 'Undtagelser for ordrer',
      addExceptionHeading: 'Ny undtagelsesperiode',
      exceptionStart: 'Start',
      exceptionEnd: 'Slut',
      editExceptions: 'Rediger undtagelser',
      addRecurring: 'Tilbagevendende',
      addToGroup: 'Vælg tilbagevendende gruppe',
      exceptions: 'Undtagelser',
      recurringOrderAddedConfirmation: 'Ordre tilføjet til tilbagevendende gruppe',
      name: 'Navn',
      frequency: 'Hyppighed',
      frequencies: {
        weekly: 'Hver uge',
        second_week: 'Hver anden uge',
        third_week: 'Hver tredje uge',
        monthly: 'Hver måned'
      },
      daysOfWeek: 'Dage om ugen',
      includeHolidays: 'Inkluder helligdage',
      endsNextDay: 'Slutter næste dag',
      endsNextDayExplanation:
        'Kun for ruter, der går over midnat. Starttiden er på første dag og sluttiden dagen efter.',
      endsNextDayRequiredByShipments:
        'Fjern afhentning eller levering næste dag på forsendelserne, før du fjerner denne',
      pickupNextDay: 'Afhentning næste dag',
      deliveryNextDay: 'Levering næste dag',
      nextDayExplanation: 'Vinduet starter på rutens første dag. Kun seneste tid flyttes til næste dag.',
      createBillingOrder: 'Opret faktureringsordre',
      customerForBillingOrder: 'Kunde til faktureringsordre',
      errorBeforeToday: 'Kan ikke være før i dag',
      errorEndBeforeStart: 'Kan ikke være før startdato',
      excludedDateRanges: {
        title: 'Ekskluderede datoer',
        add: 'Tilføj til listen',
        savedWithRoute: 'Ekskluderede datoer gemmes, når du gemmer ruten',
        ongoing: 'i gang'
      },
      startDate: 'Start dato',
      endDate: 'Slut dato (valgfrit)',
      save: 'Gem',
      fromDate: 'Fra dato',
      confirmDelete: 'Er du sikker på, at du vil slette de/den valgte ordre(r)?',
      numSelectedRoutes: '{{count}} valgt',
      deleteTemplateRoute: {
        title: 'Slet skabelonrute',
        description: 'Denne handling kan ikke fortrydes.'
      },
      deleteTemplateRoutes: {
        title: 'Er du sikker på, at du vil slette {{count}} ruter?',
        description: 'Denne handling kan ikke fortrydes.'
      },
      rolloutTemplateRoutes: {
        title: 'Er du sikker på, at du vil udrulle {{count}} ruter?',
        description: 'Ruterne udrulles for {{date}}.',
        alreadyRolledOut: '{{count}} af ruterne er allerede udrullet for {{date}}:',
        replaceWarning: 'Deres ruter og ordrer slettes og udrulles igen. Ordrerne får nye forsendelsesnumre.'
      },
      from: 'Fra',
      createOrders: 'Opret ordrer',
      showResult: 'Vis resultat',
      showRolloutResult: 'Vis udrulningsresultat',
      rolloutProblems: 'Problemer med udrulning',
      rolloutProblemsFrom: 'Fra forrige udrulning, {{date}}',
      rolloutProblemsHandled: 'Håndterede udrulningsproblemer',
      noRolloutProblems: 'Ingen udrulningsproblemer i denne periode',
      noOutstandingRolloutProblems: 'Alle udrulningsproblemer er håndteret',
      dealtWith: 'Håndteret',
      problems: 'Problemer',
      problemType: 'Problem',
      severityCritical: 'Kritisk',
      severityWarning: 'Advarsel',
      rangeReversed: 'Fra-datoen må ikke være efter til-datoen',
      rangeTooLong: 'Perioden kan ikke være længere end {{days}} dage',
      rangeNeedsEnd: 'For at se længere tilbage end {{days}} dage skal du også angive en til-dato',
      problemRolloutFailed: 'Udrulningen mislykkedes',
      problemOrderNotCreated: 'Ordren blev ikke oprettet',
      problemOrderNotOnRoute: 'Ordren er ikke på ruten',
      problemStopNotOnRoute: 'Planlagt stop er ikke på ruten',
      startdate: 'Start dato',
      enddate: 'Slut dato',
      orders: 'ordrer',
      executionSummary: 'Udførelsesopsummering',
      executions: 'Udførelser',
      executionStatus: 'Udførelsesstatus',
      executionId: 'Udførelse',
      templateShipment: 'Skabelonforsendelse',
      createdOrderId: 'Oprettet ordre-id',
      packageIds: "Pakke-id'er",
      sentAt: 'Sendt',
      lastAttemptAt: 'Sidste forsøg',
      routeConnected: 'Knyttet til rute',
      optimizationRequestId: 'Optimeringsanmodnings-id',
      failedOptimizationRequestIds: "Mislykkede optimeringsanmodnings-id'er",
      routeConnectedSummary: 'Knyttet til rute',
      onlyWithErrors: 'Kun med fejl',
      rolloutResult: {
        newView: 'Ny visning',
        oldViewNotice:
          'Denne visning fjernes snart. Den nye visning viser problemerne fra denne dato og frem, grupperet efter årsag.',
        switchToNewView: 'Skift til den nye visning',
        earlierProblems_one: 'Der er {{count}} ubehandlet problem fra udrulningen {{date}}.',
        earlierProblems_other: 'Der er {{count}} ubehandlede problemer fra udrulningen {{date}} og frem.',
        showEarlierProblems: 'Vis dem',
        crumb: 'Udrulningsresultat',
        title: 'Udrulningsresultat - {{date}}',
        nothingRolledOut: 'Intet er rullet ud fra denne dato',
        progress: 'Udrulningsstatus',
        showProgress: 'Vis udrulningsstatus',
        processing: 'Udrulning i gang',
        processingCount: 'Fremdrift · {{processed}} af {{total}} ruter',
        done: 'Udrulning færdig',
        doneCount: '{{processed}} af {{total}} ruter',
        routes: 'Oprettede ruter',
        createdOrders: 'Oprettede ordrer',
        stops: 'Stop',
        failedStops: 'Fejlede stop',
        orderStatus: {
          PENDING: 'Venter',
          SENT: 'Sendt',
          CREATED: 'Oprettet',
          FAILED: 'Fejlet',
          MISSING: 'Mangler'
        },
        plannedStopStatus: {
          PENDING: 'Venter',
          CONNECTED: 'Forbundet',
          FAILED: 'Fejlet'
        },
        unhandled: 'Ubehandlede',
        handled: 'Håndterede',
        handledToggle: 'Vis ubehandlede eller håndterede problemer',
        unhandledCount: 'Ubehandlede problemer ({{count}})',
        handledCount: 'Håndterede problemer ({{count}})',
        unhandledDescription: 'Ret fejlene, så næste udrulning ikke får de samme.',
        handledDescription: 'Problemer markeret som håndteret. Markér et som ikke håndteret for at få det tilbage.',
        unhandledEmpty: 'Ingen problemer skal håndteres',
        handledEmpty: 'Ingen problemer er markeret som håndteret',
        groupDescription:
          'Når du har rettet oplysningerne, markér problemet som håndteret, så forsvinder det fra listen.',
        cause: {
          MISSING_CUSTOMER: {
            title: 'Manglende kundenummer',
            description: 'Kunden blev ikke fundet. Den kan være slettet eller ændret.'
          },
          ORDER_NOT_CREATED: {
            description: 'Ordren kunne ikke oprettes. Se fejlårsagen.'
          },
          TIME_WINDOW: {
            title: 'Tidsvindue',
            description: 'Ordren blev ikke tilføjet ruten på grund af tidsvinduet.'
          },
          MISSING_COORDINATES: {
            title: 'Manglende koordinater',
            description: 'Adressen mangler koordinater.'
          },
          CAPACITY: {
            title: 'Ikke nok kapacitet på køretøjet',
            description: 'Ordren var der ikke plads til på grund af kapacitet.'
          },
          OPTIMIZATION_FAILED: {
            title: 'Optimering fejlede',
            description: 'Ruteoptimeringen fejlede efter flere forsøg.'
          },
          ORDER_NOT_ON_ROUTE: {
            description: 'Ordren blev oprettet, men ikke tilføjet ruten. Årsagen kendes endnu ikke.'
          },
          STOP_NOT_ON_ROUTE: {
            description:
              'Stoppet kunne ikke tilføjes ruten, som regel på grund af tidsvinduet eller placeringen. Ret det på skabelonruten.'
          }
        },
        filterRoutes: 'Filtrér ruter',
        allRoutes: 'Alle ruter',
        routeName: 'Rutenavn',
        templateRoute: 'Skabelonrute',
        rolledOutAt: 'Rullet ud',
        handledBy: 'Markeret som håndteret af',
        selectRow: 'Vælg {{route}} {{id}}',
        markAsHandled: 'Markér som håndteret',
        markAsHandledHint: 'Det forsvinder fra listen',
        markAsUnhandled: 'Markér som ikke håndteret'
      },
      rolloutView: {
        label: 'Udrulninger',
        current: 'Gældende',
        all: 'Alle, inklusive erstattede',
        replaced: 'Kun erstattede'
      },
      replaced: 'erstattet',
      replacedAt: 'Erstattet',
      replacedBy: 'Erstattet af',
      replacesExecution: 'Erstatter udrulning',
      templateRouteId: 'Skabelonrute-id',
      templateRouteName: 'Skabelonrutenavn',
      createdAt: 'Oprettet',
      updatedAt: 'Opdateret',
      date: 'Dato',
      createdSlotId: 'Oprettet rute-id',
      createdBy: 'Oprettet af',
      failed: 'Mislykkedes',
      by: 'Af',
      on: 'den',
      reset: 'nulstil',
      confirmReset: 'Vil du nulstille gentagne ordrer for {{date}}?',
      startDateExplanation: 'Ordre vil blive oprettet samme dag som startdatoen',
      noOrderSelected: 'Ingen ordre valgt',
      noOrdersFound: 'Ingen ordrer fundet',
      groups: 'Grupper',
      routes: 'Ruter',
      newRoute: 'Opret ny tilbagevendende rute',
      recurringRoute: 'Tilbagevendende rute',
      tabFrequency: 'Frekvens',
      tabRoute: 'Rute',
      tabTemplateShipments: 'Skabelonforsendelser',
      timeQuestion: 'Hvilket tidspunkt skal ruten starte og slutte?',
      frequencyQuestion: 'Hvor ofte vil du have, at ruterne rulles ud?',
      holidayRollout: 'Udrulning på helligdage',
      holidayRolloutDescription:
        'Ruter rulles som standard ikke ud på helligdage. Vælg dette for at tage helligdage med i udrulningen.',
      weekdaysQuestion: 'Hvilke ugedage vil du have, at ruten skal levere?',
      periodQuestion: 'Hvornår vil du have, at ruten skal starte og slutte?',
      routeDetails: 'Rutedetaljer',
      searchShipments: 'Søg forsendelser',
      editShipment: 'Rediger skabelonforsendelse',
      newTemplateShipment: 'Ny skabelonforsendelse',
      addShipments: 'Tilføj forsendelser',
      saveShipment: 'Gem forsendelse',
      onRoute: 'På ruten',
      findYourShipmentsDescription: 'Indtast det du leder efter i søgefeltet ovenfor',
      saveFrequency: 'Gem frekvensindstillinger',
      saveRoute: 'Gem ruteindstillinger',
      saveShipments: 'Gem forsendelser på rute',
      shipmentsAddedToRoute: 'Forsendelser tilføjet til ruten',
      shipmentCopied: 'Skabelonforsendelse kopieret',
      routeCreated: 'Tilbagevendende rute oprettet',
      routeUpdated: 'Tilbagevendende rute opdateret',
      editRoute: 'Rediger {{route}}',
      recurringRoutes: 'Tilbagevendende ruter',
      selectRouteWithId: 'Vælg rute med id {{id}}',
      rolloutInfoConfigured:
        'Automatisk udrulning bruger afdelingens automatiske tilbagevendende tid {{time}} og udruller ruter for den følgende dato.',
      rolloutInfoMissing:
        'Automatisk udrulning er ikke konfigureret for denne afdeling, fordi automatisk tilbagevendende tid er tom. Bed en administrator om at konfigurere dette.',
      addStop: 'Tilføj stop',
      days: 'Dage',
      dates: 'Datoer',
      addException: 'Tilføj undtagelse',
      addedExceptions: 'Tilføjede undtagelser',
      selectedOrders: 'Valgte forsendelser',
      moveShipment: 'Flyt forsendelse',
      moveShipmentModal: {
        errorMessage: 'Forsendelser: {{shipmentIds}}, fejlmeddelelse: {{error}}',
        shipmentsMovedText: 'Forsendelser {{shipmentIds}}, {{stopIds}} er blevet flyttet til rute {{route}}',
        partialSuccessMessage: '{{count}} af {{fullCount}} forsendelser blev flyttet',
        title: 'Flyt valgte forsendelse(r) til en anden rute'
      },
      changeRoute: 'Skift rute',
      viewRoute: 'Til rute',
      plannedStops: 'Planlagte stop',
      templatePlannedStopId: 'Skabelon planlagt stop',
      createdPlannedStopId: 'Oprettet planlagt stop',
      notRouteConnected: 'Ikke på rute'
    },
    corrections: {
      title: 'Rettelser',
      headline: 'Ordrerettelser for {{date}}',
      accepted: 'Ordrerettelser accepteret',
      rejected: 'Ordrerettelser afvist',
      approve: 'Godkend',
      decline: 'AFVIS',
      shipmentId: 'Forsendelses Id',
      courier: 'Bud',
      from: 'Fra',
      to: 'Til',
      details: 'Detaljer',
      pickupWaitingTime: 'Ventetid ved opsamling (min)',
      deliveryWaitingTime: 'Ventetid ved levering (min)',
      pickupLoadingTime: 'Læssetid afhentning (min)',
      deliveryLoadingTime: 'Læssetid levering (min)',
      comment: 'Kommentar',
      weight: 'Vægt',
      volume: 'Volumen',
      packages: 'Pakker',
      serviceCode: 'Servicekode',
      noOrderCorrections: 'Ingen ordrekorrektioner',
      minutesOutOfRangeError: 'Du skal udfylde et tal mellem {{min}} og {{max}}',
      timeInMinutesWarning: 'Ugyldig tidsværdi, kontroller om den er korrekt'
    },
    dispatch: {
      assigningMultilegDelivery: 'Tildeler {{count}} multileg-levering',
      assigningMultilegDelivery_other: 'Tildeler {{count}} multileg-leveringer',
      turningThisOnExplanation: '(Når dette slås til, kan du tilsidesætte ruteplanen)'
    },
    suggestedUnits: {
      unitName: 'Enhedsnavn',
      driverName: 'Førerens navn',
      slotName: 'Rute',
      timeAtLocation: 'Tid på placering',
      distanceFromLocation: 'Afstand fra lokation',
      shipmentInformation: 'Forsendelsesinformation',
      suggestedVehicles: 'Foreslåede køretøjer',
      suggestedVehiclesOnPickup: 'Foreslåede køretøjer ved afhentning',
      suggestedVehiclesOnDelivery: 'Foreslåede køretøjer ved levering',
      suggestedUnits: 'Foreslåede enheder',
      noSuggestionsAvailable: 'Ingen tilgængelige forslag',
      pickupTime: 'Afhentningstid',
      deliveryTime: 'Leveringstid',
      filterBy: 'Sorter efter'
    },
    shipmentSummary: {
      unPrePlan: 'Ophæv forudplanlægning',
      prePlanTo: 'Forudplanlæg til'
    }
  },
  errors: {
    DIP_DESTINATION_ALREADY_MAPPED:
      'Dette hentepunkt er allerede koblet til en anden DIP. Genindlæs siden for at se de aktuelle koblinger.',
    ALREADY_ENQUEUED_FOR_INVOICING: 'Allerede i kø til fakturering',
    DEPARTMENT_INVALID_ALYSTRA_ID: 'Ugyldigt afdelings-ID',
    EXPORT_DEPARTMENT_GROUP_TOO_LARGE: 'Vælg en mindre afdelingsgruppe eller et kortere eksportdatointerval',
    ENTITY_DOES_NOT_EXIST: 'Enhed findes ikke',
    RECURRING_ROUTE_REROLL_OUT_DATE_NOT_IN_FUTURE: 'Faste ruter kan kun udrulles igen for en dato efter i dag',
    RECURRING_ROUTE_NOT_ROLLED_OUT: 'En valgt rute er ikke udrullet for denne dato. Genindlæs siden og prøv igen',
    RECURRING_ROUTE_ROLLOUT_IN_PROGRESS: 'En valgt rute udrulles stadig. Vent et par minutter og prøv igen',
    ROUTE_ALREADY_CONNECTED_TO_ANOTHER_RULE:
      'Ruten er allerede tilknyttet en anden ruteregel, opdater siden og prøv igen',
    INVALID_DATE_RANGE: 'Ugyldigt datointerval',
    INVALID_DELIVERY_LATITUDE: 'Ugyldig leveringsbreddegrad',
    INVALID_DELIVERY_LONGITUDE: 'Ugyldig leveringslængdegrad',
    INVALID_LATITUDE: 'Ugyldig breddegrad',
    INVALID_LONGITUDE: 'Ugyldig længdegrad',
    INVALID_OR_MISSING_TIME: 'Ugyldig eller manglende tid',
    INVALID_PHONE_NUMBER: 'Ugyldigt telefonnummer',
    DUPLICATE_PHONE_NUMBER: 'Duplikeret telefonnummer!',
    DUPLICATE_PHONE_NUMBER_COURIER: 'En chauffør er allerede registreret med dette telefonnummer',
    INVALID_PICKUP_LATITUDE: 'Ugyldig afhentningsbreddegrad',
    INVALID_PICKUP_LONGITUDE: 'Ugyldig afhentningslængdegrad',
    INVALID_SLOT_TYPE: 'Ugyldig rutetype',
    MISSING_ADDRESS: 'Manglende adresse',
    MISSING_ALYSTRA_ID: 'Manglende id',
    MISSING_AREA: 'Manglende område',
    MISSING_CAPACITY: 'Manglende kapacitet',
    MISSING_COLOR: 'Manglende farve',
    MISSING_CONSIGNMENT_INPUTS: 'Manglende forsendelsesindlæsning',
    MISSING_CONSIGNMENT: 'Manglende forsendelse',
    MISSING_CONSIGNMENTS: 'Manglende forsendelser',
    MISSING_COURIER_ID: 'Manglende bud id',
    MISSING_COURIER: 'Du skal vælge et bud',
    MISSING_CREATED_AT: 'Manglende oprettelsestid',
    MISSING_CUSTOMER_ID: 'Manglende kunde id',
    MISSING_CUSTOMER_REF: 'Manglende kundereference',
    MISSING_DATE: 'Manglende dato',
    MISSING_DAYS: 'Manglende dage',
    MISSING_DEPARTMENT: 'Manglende afdeling',
    MISSING_DESCRIPTION: 'Manglende instruktioner',
    MISSING_DEVIATION_TEXT: 'Manglende afvigelsestekst',
    MISSING_END_LOCATION_LATITUDE: 'Manglende slut lokationsbreddegrad',
    MISSING_END_LOCATION_LONGITUDE: 'Manglende slut lokationslængdegrad',
    MISSING_EVENT_DATA: 'Manglende event data',
    MISSING_EVENT_TYPE: 'Manglende event type',
    MISSING_FILE_NAME: 'Filnavn mangler',
    MISSING_FROM_DATE: 'Mangler fra dato',
    MISSING_ID: 'Manglende id',
    MISSING_LOCATION_LATITUDE: 'Manglende lokationsbreddegrad',
    MISSING_LOCATION_LONGITUDE: 'Manglende lokationslængdegrad',
    MISSING_LOCATION_POSITION: 'Manglende lokations position',
    MISSING_LOCATION_TIME: 'Manglende lokations tid',
    MISSING_NAME: 'Manglende navn',
    MISSING_GROUP: 'Manglende gruppering',
    MISSING_PACKAGE_ID: 'Manglende pakkeid',
    MISSING_PHONE: 'Manglende telefon',
    MISSING_PLANNER_ID: 'Manglende planlæggerid',
    MISSING_SERVICE_CODE: 'Manglende servicekode',
    MISSING_SHIPMENT_ID: 'Manglende shipment id',
    MISSING_SLOT_ID: 'Manglende rute id',
    MISSING_SLOT_TYPE: 'Manglende rute type',
    MISSING_SMS_TOKEN: 'Manglende sms kode',
    MISSING_START_LOCATION_LATITUDE: 'Manglende breddegrad på start lokation',
    MISSING_START_LOCATION_LONGITUDE: 'Manglende længdegrad på start lokation',
    MISSING_TO_DATE: 'Manglende til dato',
    MISSING_ZIP_AREA: 'Manglende postområde',
    MISSING_ZIP_CODE: 'Manglende postnummer',
    MISSING_COUNTRY_CODE: 'Manglende landekode',
    NO_SUCH_USER: 'Bruger findes ikke',
    BILLING_ORDER_AMOUNT_OUT_OF_VALID_RANGE: 'Maksimalt tilladte prissummer ({{limit, number}}) er overskredet',
    PARAM_NOT_OF_EXPECTED_TYPE: 'Parameter er ikke af forventet type',
    PARAM_NULL_NOT_ALLOWED: 'Parameter nul er ikke tilladt',
    PTW_ALREADY_EXISTS: 'Et produktionstidsvindue findes allerede for modtager-ID {{recipientId}}.',
    QUERY_NAME_MISSING: 'Query navn mangler',
    QUERY_PARAMS_MISSING: 'Query parameter mangler',
    USER_NOT_EXIST_OR_INCORRECT_ROLE: 'Brugeren findes ikke eller har forkert rolle',
    USER_EXIST_BUT_INCOMPATIBLE_ROLE: 'Brugeren findes allerede og har en anden rolle',
    SLOT_CANNOT_BE_STARTED: 'Ruten kan ikke startes',
    SLOT_CANNOT_BE_DELETED: 'Ruten kan ikke slettes',
    COURIER_NOT_PART_OF_DEPARTMENT: 'Buddet er ikke en del af afdelingen',
    CONSIGNMENT_IN_INCORRECT_STATE_CANNOT_UPDATE: 'Forsendelser med forkert status kan ikke oprettes',
    ORDER_DOES_NOT_EXISTS: 'Ordren findes ikke',
    OPTIMIZE_ALREADY_RUNNING: 'Optimeringen kører allerede',
    CANNOT_CHANGE_ORDER: 'ordren kan ikke ændres',
    NO_ACCESS: 'Ingen adgang',
    NO_RELEVANT_CONSIGNMENTS_OR_SLOTS: 'Ingen relevante forsendelser til den givne rute',
    NO_RELEVANT_CONSIGNMENTS: 'Ingen relevante forsendelser til den givne rute',
    NO_RELEVANT_SLOTS: 'Kun ruter, der ikke er startet eller er sat på pause, kan bruges til denne optimering',
    NOT_EQUAL_PICKUP_ADDRESSES:
      'Alle afhentningsadresser skal være ens for at begrænse alle forsendelser til én chauffør',
    NO_SUCH_QUERY: 'Ingen sådan forespørgsel',
    EXCEL_MISSING_SHIPMENT_ID: 'Manglende forsendelses-id i celle {{col}} på række {{row}}',
    EXCEL_MISSING_CUSTOMER_REF: 'Manglende kundereference i celle {{col}} på række {{row}}',
    EXCEL_MISSING_CUSTOMER_ID: 'Manglende kunde-id i celle {{col}} på række {{row}}',
    EXCEL_MISSING_DEPARTMENT: 'Manglende afdeling i celle {{col}} på række {{row}}',
    EXCEL_MISSING_PACKAGE_ID: 'Manglende pakke-id i celle {{col}} på række {{row}}',
    EXCEL_MISSING_NAME: 'Manglende navn i celle {{col}} på række {{row}}',
    EXCEL_INVALID_PHONE: 'Ugyldigt telefonnummer i celle {{col}} på række {{row}}',
    EXCEL_MISSING_ADDRESS: 'Manglende adresse i celle {{col}} på række {{row}}',
    EXCEL_MISSING_ZIP_AREA: 'Manglende postnummer i celle {{col}} på række {{row}}',
    EXCEL_MISSING_ZIP_CODE: 'Manglende by i celle {{col}} på række {{row}}',
    EXCEL_MISSING_FROM_DATE: 'Manglende fra dato i celle {{col}} på række {{row}}',
    EXCEL_MISSING_TO_DATE: 'Manglende til dato i celle {{col}} på række {{row}}',
    EXCEL_INVALID_FROM_DATE: 'Fra datoen kan ikke være før i dag. Fundet i celle {{col}} på række {{row}}',
    EXCEL_INVALID_TO_DATE: 'Til datoen kan ikke være før i dag. Fundet i celle {{col}} på række {{row}}',
    EXCEL_MISSING_NOTIFICATION_SMS: 'Manglende adviserings SMS i celle {{col}} på række {{row}}',
    EXCEL_MISSING_SIZE: 'Manglende størrelse i celle {{col}} på række {{row}}',
    EXCEL_MISSING_ORDERS: 'Ingen ordre er fundet i regnearket.',
    EXCEL_MISSING_COUNTRY: 'Manglende landekode eller navn i celle {{col}} på række {{row}}',
    EXCEL_NO_ACCESS_DEPARTMENT: 'Ingen adgang til afdeling"{{dept_ref}}" some r fundet i række {{row}}',
    EXCEL_MISSING_DESCRIPTION: 'Manglende beskrivelse i "{{cell}}" på række {{row}}',
    EXCEL_MISSING_PICKUP_INSTRUCTIONS: 'Manglende afhentningsbeskrivelse i "{{cell}}" på række {{row}}',
    EXCEL_MISSING_DELIVERY_INSTRUCTIONS: 'Manglende leveringsbeskrivelse i "{{cell}}" på række {{row}}',
    EXCEL_TOO_MUCH_DATA:
      'Rapporten er for stor. Overvej at eksportere til et smallere datointerval eller færre afdelinger.',
    MISSING_PICKUP_LOCATION_AND_TIME: 'Manglende opsamlingslokation og tid',
    MISSING_EARLIEST_PICKUP_DATE: 'Tidligste afhentningsdato mangler',
    MISSING_LATEST_PICKUP_DATE: 'Seneste afhentningsdato mangler',
    MISSING_EARLIEST_DELIVERY_DATE: 'Tidligste leveringsdato mangler',
    MISSING_LATEST_DELIVERY_DATE: 'Seneste afhentnings dato mangler',
    INVALID_EARLIEST_PICKUP_DATE: 'Ugyldig afhentningsdato',
    INVALID_LATEST_PICKUP_DATE: 'Ugyldig afhentningsdato',
    INVALID_EARLIEST_DELIVERY_DATE: 'Ugyldig leveringssdato',
    INVALID_LATEST_DELIVERY_DATE: 'Ugyldig leveringssdato',
    CANNOT_MODIFY_ORDERS_FROM_DIFFERENT_SOURCE: 'Kan ikke ændre API-ordrer fra Excel',
    PICKUP_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST: 'Opsamlingstiden skal være før leveringstiden',
    DELIVERY_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST:
      'Tidligste leveringstidspunkt skal være før seneste leveringtidspunkt',
    CANNOT_DELIVER_ON_A_HOLIDAY: 'Kan ikke levere på helligdage',
    MISSING_TEMPLATE_ID: 'Manglende skabelon-id',
    TEMPLATE_DOES_NOT_EXIST: 'Skabelonen findes ikke',
    TEMPLATE_CANNOT_BE_DELETED: 'Skabelonen kan ikke slettes',
    MISSING_TEMPLATE_SLOTS: 'Skabelonen mangler ruter',
    TEMPLATE_NAME_ALREADY_EXISTS: 'En skabelon med dette navn findes allerede',
    COURIER_ALREADY_EXISTS: 'Der findes allerede et bud med dette telefonnummer',
    ORDER_EXIST_FOR_SERVICE: 'Kan ikke slette service, da der findes ordre med denne service',
    NO_SERVICE_FOUND: 'Tilføj en service, før du tilføjer en kunde',
    CANNOT_DELETE_AS_SERVICE_EXIST: 'Fjern tilknytningen til kunden, før du sletter servicen',
    SLOT_IN_INCORRECT_STATE_CANNOT_UPDATE: 'Ruten har ikke en gyldig status til denne ændring',
    GRAPHHOPPER_UNASSIGNED:
      'Kunne ikke tildele alle forsendelser (pga. tid, kapacitet eller andre faktorer), detaljer: {{details}}',
    GRAPHHOPPER_REQUEST_FAILED: 'Anmodningen om optimering af ruten mislykkedes',
    GRAPHHOPPER_LATEST_ARRIVAL_AT_DELIVERY_AFTER_EARLIEST_DEPARTURE:
      'Seneste ankomst for levering kan ikke være efter tidligste afgang – Er tidsvinduet passeret?',
    GRAPHHOPPER_EARLIEST_GREATER_THAN_LATEST:
      'Tidligste tid kan ikke være senere end seneste tid – Er nogle af tiderne i fortiden?',
    GRAPHHOPPER_PICKUP_EARLIEST_AFTER_LATEST:
      'Afhentnings tidsvindue for forsendelse {{shipmentId}} kan ikke være i fortiden ({{pickupEarliest}} - {{pickupLatest}})',
    GRAPHHOPPER_DELIVERY_EARLIEST_AFTER_LATEST:
      'Leverings tidsvindue for forsendelse {{shipmentId}} kan ikke være i fortiden ({{deliveryEarliest}} - {{deliveryLatest}}',
    GRAPHHOPPER_INVALID_PICKUP_LOCATION:
      "Manglende afhentningskoordinater for forsendelse {{shipmentId}}. Løs venligst adressen via siden 'Angiv koordinater'.",
    GRAPHHOPPER_INVALID_DELIVERY_LOCATION:
      "Manglende leveringskoordinater for forsendelse {{shipmentId}}. Løs venligst adressen via siden 'Angiv koordinater'.",
    GRAPHHOPPER_REQUEST_LIMIT_VIOLATED:
      'Grænsen for antallet af forespørgsler til Graphhopper er nået, prøv igen om et minut',
    SLOT_CANNOT_BE_EDITED: 'Ruten er ikke i en gyldig status for opdateringen',
    INVALID_POSTCODE_AND_COUNTRY_CODE_CANNOT_BE_HANDLED: 'Ugyldig postnummer og landekode',
    INVALID_BASIC_SERVICE_CODE: 'Ugyldig basis servicekode',
    INVALID_PICKUP_DATE_EARLIEST_FORMAT: 'Ugyldig format af tidligste afhentningsdato',
    INVALID_PICKUP_DATE_LATEST_FORMAT: 'Ugyldig format af seneste opsamlingsdato',
    INVALID_DELIVERY_DATE_LATEST_FORMAT: 'Ugyldig format af seneste leveringsdato',
    INVALID_DELIVERY_DATE_EARLIEST_FORMAT: 'Ugyldig format af tidligste leveringsdato',
    INVALID_POSTAL_CODE: 'Ugyldig postnummer',
    INVALID_MEASUREMENT_UNIT: 'Ugyldig måleenhed',
    MISSING_CONSIGNMENT_SET: 'Manglende forsendelses sæt',
    MISSING_UPDATE_INDICATOR: 'Manglende opdateringsindikator',
    MISSING_CONSIGNMENT_ID: 'Manglende forsendelses-id',
    MISSING_REFERENCE_NO: 'Manglende reference-id',
    MISSING_PACKAGE: 'Manglende pakke',
    MISSING_DELIVERY_DATE_EARLIEST: 'Tidligste leveringsdato mangler',
    MISSING_DELIVERY_DATE_LATEST: 'Seneste leveringsdato mangler',
    MISSING_CONSIGNEE: 'Manglende modtager',
    MISSING_CONSIGNOR: 'Manglende afsender',
    MISSING_POSTAL_CODE: 'Manglende postnummer',
    MISSING_CITY: 'Manglende by',
    MISSING_PICKUP_DATE_LATEST: 'Seneste opsamlingssdato mangler',
    MISSING_PICKUP_DATE_EARLIEST: 'Tidligste opsamlingsdato mangler',
    MISSING_CONSIGNOR_PARTY_ID: 'Mangler afsender-ID',
    INVALID_CUSTOMER_NO_MAPPING: 'Ugyldig kundenummer mapping',
    INVALID_ROUTING: 'Ugyldig rute',
    NO_SERVICE_MATCHING_SERVICE_CODE: 'Ingen service matcher servicekoden',
    NO_SERVICE_MATCHING_DAY_OF_WEEK: 'Ingen service matcher ugedagen',
    NO_SERVICE_MATCHING_PICKUP_AND_DELIVERY_TIMES: 'Ingen service matcher afhentning og leveringstider ',
    ORDER_WAS_AFTER_CUTOFF_TIME: 'Ordrer er efter deadline',
    OPTIMUS_SERVICE_MUST_HAVE_PICKUP_AND_DELIVERY_TIMES: 'Skal have opsamlings og leveringstid',
    ORDER_CANNOT_BE_MOVED: 'Forsendelsen kan ikke flyttes, den må ikke tildeles en rute',
    MISSING_DESTINATION_DEPARTMENT_ID: 'Manglende destinationsafdeling',
    SHIPMENT_NOT_FOUND: 'Fandt ikke forsendelsen',
    SHIPMENT_IN_INCORRECT_STATE: 'Forsendelsen er allerede tildelt en rute',
    DUPLICATE_EXCEL_IMPORT:
      'Det samme filnavn er allerede importeret til denne afdeling i dag. Du kan se resultaterne af denne import <0>her</0>. Skift filnavn, hvis du vil importere igen.',
    SHIPMENT_INVALID_QUERY:
      'I peak perioden vil søgning være begrænset for at sikre god ydeevne. Du kan søge alle ordrer for en dag, eller tilføje søgeparameter.',
    DURATION_IS_MORE: 'Du skal begrænse din søgning til {{maxDuration}} dage.',
    ADDRESS_CANNOT_BE_DELETED: 'Adressen bruges som standardadresse og kan ikke slettes.',
    UNKOWN_ERROR: 'Ændringer kunne ikke gemmes',
    INCORRECT_STATES_OR_ASSIGNED_TO_SLOT: 'Forkert status eller tildelt til rute',
    CANNOT_MOVE_ORDERS: 'Kan ikke flytte ordrer',
    DESTINATION_DEPARTMENT_INELIGIBLE: 'Destination afdeling ikke berettiget',
    DEPARTMENT_MISSING_ADDRESS_DETAILS: 'Afdeling mangler adresseoplysninger',
    MISSING_DELIVERY_PHONE_NUMBER: 'Telefonnummer mangler for',
    INVALID_DELIVERY_PHONE_NUMBER: 'Telefonnummeret er ikke gyldigt for',
    ROLE_IN_USE: 'Rollen kan ikke fjernes, da rollen er i brug.',
    INVALID_NAME: 'Rollenavnet skal være unikt. En rolle med dette navn findes allerede.',
    BANNER_ALREADY_EXISTS: 'Bannernavn skal være unikt. Et banner med dette navn findes allerede.',
    BANNER_NAME_TOO_BIG: 'Bannernavn er for langt. Det må højst være 200 tegn.',
    CMS_NEWS_ALREADY_EXISTS: 'Opdateringens navn skal være unikt. Der findes allerede en opdatering med dette navn.',
    CMS_NEWS_NAME_TOO_BIG: 'Opdateringens navn er for langt. Det må højst være 200 tegn',
    INVALID_CMS_NEWS_NAME: 'Ugyldigt navn på opdatering',
    TEXT_CANNOT_BE_DELETED:
      'Teksten bruges på en tjeneste og kan ikke slettes. Afbryd teksten fra tjenesten for at slette den.',
    INVALID_INVOICING_STATUS: 'Ordren har en status, der ikke er gyldig til fakturering',
    ORDER_NOT_READY_FOR_INVOICING: 'Ordren er ikke klar til fakturering',
    ORDER_IS_PAUSED_FROM_INVOICING: 'Ordren er sat på pause fra fakturering',
    ORDER_IS_EXCLUDED_FROM_INVOICING: 'Ordren er udelukket fra fakturering',
    MISSING_ORDER_CORRECTION: 'Ordren mangler en korrektion',
    INVALID_MULTILEG_STATE_FOR_INVOICING: 'Der er ordrer i multileg-gruppen, der ikke er klar til fakturering',
    DUPLICATE: 'Duplikerede data',
    MISSING_DEPARTMENT_DETAILS:
      'Afdelingen har ikke område- og postnummeroplysninger. Tilføj enligst dette, før du fortsætter.',
    INVALID_BANNER_NAME: 'Ugyldigt bannernavn.',
    INVALID_WHATS_THIS_NAME: 'Ugyldigt Hvad er dette-modalnavn.',
    INVALID_CREDIT_ORDER: 'Kan ikke kreditere en ordre, der ikke er faktureret eller allerede er krediteret.',
    OVERLAPPING_BANNERS: 'URL overlapper med en eksisterende banner.',
    OVERLAPPING_WHATS_THIS_MODALS: 'URL overlapper med en eksisterende Hvad er dette-modal.',
    NO_SUGGESTIONS_FOUND_FOR_ORDERS: 'Ingen chauffører er kvalificerede til ordrerne.',
    noOrdersForDateAndCourier: 'Ingen ordrer til den valgte dato og enhed.',
    INVALID_ORDER_BILLING_CUSTOMER_NUMBER:
      '{{locale}}Faktureringskundenummer for typen {{orderBillingType}} er ugyldigt',
    MISSING_ORDER_BILLING_TYPE: 'Manglende ordre faktureringstype.',
    INVALID_ORDER_BILLING_TYPE:
      'Ordrefaktureringstype skal være en af {{orderBillingTypes}}, men var - {{orderBillingType}}.',
    INVALID_ORDER_BILLING_INFO: 'Ugyldig ordrefaktureringsoplysninger.',
    SMS_SERVICE_NOT_ORDERED: 'SMS-tjeneste er ikke bestilt til.',
    CANNOT_SEND_SMS_FOR_MESTER_GRONN_FUNERAL: 'Mester Grønn-begravelse er bestilt til.',
    SLOT_ROUTED_IN_HAPPY_FLOW: 'Slot er dirigeret i Happy Flow for.',
    SERVICE_LEVEL_SHOULD_NOT_BE_NONE: 'Serviceniveauet er ingen for.',
    SLOT_NAME_ALREADY_CREATED: 'Rutenavn eksisterer allerede.',
    ORDER_IN_INCORRECT_STATE: 'Ordren er i en forkert tilstand.',
    ORDER_IN_INCORRECT_STATE_other: 'Ordren er i en forkert tilstand.',
    INVALID_PARAMETERS: 'Ugyldige parametre, {{description}}.',
    FAILED_DELETING_WEBHOOK_SUBSCRIPTION: 'Webhook-abonnement kunne ikke slettes. Prøv igen senere.',
    DEFAULT_ROLE_ALREADY_EXISTS: 'En anden rolle {{name}} er allerede standard for den samme brugertype.',
    VEHICLE_IN_USE:
      'Køretøjet er tilknyttet enhed {{units}} og kan ikke slettes. Fjern køretøjet fra enheden og prøv igen.',
    DEPARTMENT_MATRIX_ALREADY_EXISTS: 'Kun én afdelingsmatrix understøttes',
    CUTOFF_MATRIX_ALREADY_EXISTS: 'Kun én cutoff-matrix understøttes',
    MISSING_ACCESS_TO_DEPARTMENTS: 'Du mangler adgang til afdelinger {{missingDepartments}}',
    DUPLICATE_PLANNED_STOP_LOCATION_NAME:
      'Vi kan ikke have flere planlagte stopplaceringer med samme navn i en afdeling. Brug unikke navne for hver planlagt stopplacering.',
    AREA_PINS_TOO_CLOSE:
      'Kortpunkterne på ruten skal være mindst {{minDistanceInMeters}} meter fra hinanden. Flyt dem længere fra hinanden.',
    DUPLICATE_TEMPLATE_ROUTE_NAME:
      'En anden tilbagevendende rute i denne afdeling har samme navn. Ruter med samme navn slås sammen til én rute, når de rulles ud, så vælg et andet navn.',
    PLANNED_STOP_LOCATION_IN_USE:
      'Kan ikke redigere eller slette planlagte stopplaceringer - [{{locations}}] som allerede er i brug.',
    TEMPLATE_IS_DEFAULT_FOR_DEPARTMENT:
      'Skabelonen kan ikke slettes, da den er angivet som standard for en afdeling. Skift venligst standardskabelonen for afdelingen, før du sletter denne skabelon.'
  },
  customer: {
    useTerminalAddressModalHeading: 'Brug terminaladresse',
    useTerminalAddressModalDescription:
      'Valg af "Ja" betyder, at afdelingens terminaladresse bruges ved oprettelse af ordrer. "Nej" betyder, at logikken for brug af terminaladresse springes over.',
    settings: {
      webhook: {
        overviewTitle: 'Webhook-konfiguration',
        count: '{{count}} abonnement',
        count_other: '{{count}} abonnementer',
        noSubscriptions: 'Du har ingen abonnementer i øjeblikket',
        events: {
          prefix: 'Abonnerer på ',
          all: 'alle',
          suffix: ' hændelser'
        },
        state: {
          running: 'Kører',
          paused: 'Sat på pause'
        },
        event: {
          CREATED: 'ordren er registreret',
          ROUTE_PLANNING_COMPLETE: 'leveringsruten er færdiggjort',
          COLLECTED: 'buddet har afhentet godset',
          DELIVERED: 'buddet har leveret godset',
          DEVIATED: 'buddet har tilføjet en afvigelse til ordren',
          SCANNED: 'ordren har passeret transitterminal',
          ARRIVED_AT_TERMINAL: 'ordren er ankommet til distributionsterminal',
          DAMAGED: 'ordren er blevet beskadiget',
          RETURNED: 'buddet har afleveret godset tilbage til terminalen',
          PICKUP_ETA_SMS_SENT: 'sms med forventet ankomsttid for afhentning er sendt',
          ETA_SMS_SENT: 'sms med forventet ankomsttid for levering er sendt',
          PRE_ADVICE_PULL_SMS_SENT: 'sms med mulige leveringsvinduer er sendt',
          DELIVERY_TIME_ORDERED: 'modtageren har valgt leveringstid',
          PRE_ADVICE_PUSH_SMS_SENT: 'sms med bestilt leveringsvindue er sendt til modtageren',
          PICKUP_SMS_SENT: 'sms om kommende levering er sendt til modtageren',
          APARTMENT_INFORMATION_UPDATED: 'modtageren har opdateret leveringsoplysninger'
        },
        create: 'Klik på knappen for at oprette en Webhook-konfiguration',
        delete: {
          title: 'Slet abonnement',
          description: 'Denne handling kan ikke fortrydes',
          successfullyDeleted: 'Webhook-abonnementet blev slettet'
        },
        newOrEdit: {
          createTitle: 'Opret ny webhook-konfiguration',
          editTitle: 'Rediger webhook-konfiguration',
          created: 'Ny webhook-konfiguration blev oprettet',
          updated: 'Webhook-konfigurationen blev opdateret',
          endpoint: 'Endpoint',
          endpointDescription: 'Angiv den URL, som hændelsesdataene skal sendes til',
          httpAuthentication: 'HTTP Basic Authentication',
          username: 'Brugernavn',
          password: 'Adgangskode', // betterleaks:allow a form label, not a secret
          retryPolicy: 'Genforsøgspolitik',
          retryPolicyDescription: 'Hvis webhooken fejler, kan du konfigurere antal og forsinkelser mellem genforsøg.',
          retry: '{{count}} genforsøg',
          retry_other: '{{count}} genforsøg',
          retryDescription: 'Antal genforsøg',
          delay: {
            description: 'Forsinkelse før nyt forsøg',
            value: 'Forsinkelse {{seconds}} sekunder'
          },
          pause: 'Sæt dette abonnement på pause indtil videre',
          pauseTooltip:
            'Pause sætter udsendelse af hændelser i kø, indtil den ophæves igen. Når den ophæves, sendes hændelserne i køen igen.',
          validation: {
            endpointError: 'Du skal angive en gyldig URL',
            endpointRequired: 'URL er påkrævet',
            usernameRequired: 'Brugernavn er påkrævet',
            passwordRequired: 'Adgangskode er påkrævet',
            passwordNotLongEnoughError: 'Adgangskoden skal være på mindst 8 tegn',
            noEventSelectedError: 'Du skal vælge mindst én hændelse',
            retryDelayRequired: 'Forsinkelse for genforsøg er påkrævet'
          }
        }
      }
    },
    returnLastLegModalHeading: 'Opret returben',
    returnLastLegModalDescription:
      'At vælge "ja" betyder, at vi opdeler ordren i to dele og tilføjer et returskridt. "Nej" betyder, at der ikke skal oprettes noget returskridt. "Ikke angivet" betyder, at returhåndteringsreglen ikke er defineret for en specifik kunde.',
    connectMatrices: 'Tilslut matriser',
    customerMatrices: 'Kundematricer',
    customerMatricesIngress: 'Tilknyt kundenummer til eksisterende matricer.',
    useTerminalAddressUpdated: 'Status for brug af terminaladresse er opdateret',
    brandedTrackingModalHeading: 'Branded tracking fakturering',
    brandedTrackingModalDescription: 'Slå til for at aktivere fakturering for Branded Tracking.',
    addNPSFromDate: 'Tilføj startdato for NPS',
    bookingPage: 'Bookingside',
    bookingPageCustomerPortal: 'Bookingside i Kundeportalen',
    bookingPageIngress:
      'Slå booking fra, hvis kunden ikke skal kunne booke forsendelser på dette kundenummer i Glow-kundeportalen.',
    returnAddressUpdated: 'Returadresse opdateret',
    returnAddressRemoved: 'Returadresse fjernet',
    returnAddressModalHeading: 'Returadresse for varer',
    removeReturnAddressModalHeading: 'Fjern nuværende returadresse',
    removeReturnAddressConfirm: 'Er du sikker på, at du vil fjerne den nuværende returadresse?',
    returnAddressModalDescription: 'Indtast returadressen, der skal bruges, når varer returneres fra terminalen',
    scanToCreatePackages: {
      title: 'Scan for at oprette pakker',
      enabled: 'Aktiveret',
      disabled: 'Deaktiveret',
      label: 'Brug scanning til at oprette pakker',
      details:
        'Når du aktiverer scanning til at oprette pakker, bliver kureren tvunget til at scanne pakker ved afhentning. De scannede pakker bliver automatisk opdateret på forsendelsen',
      success: 'Scanning til oprettelse af pakker er opdateret'
    },
    invoiceSplit: {
      title: 'Fakturadeling',
      legend: 'Forklaring',
      label: 'Angiv fakturadeling',
      NotSet: 'Ikke indstillet',
      Department: 'Afdeling',
      Service: 'Tjeneste',
      Custom: 'Brugerdefineret',
      columLabel: 'Navn',
      addedItems: 'Tilføjede faktureringsregler ({{count}})',
      newItemLabel: 'Indtast fakturadeling',
      existingItem: 'Teksten findes allerede. Prøv at søge efter teksten nedenfor.',
      existingItemShort: 'Teksten findes allerede.',
      emptyItem: 'Teksten må ikke være tom.',
      updated: 'Fakturadeling blev tilføjet'
    },
    activateNPSFromDate: 'Aktiver NPS fra dato',
    activateNPSFromDateIngress:
      'Angiv en startdato for aktivering af NPS (Net Promoter Score) fra Medallia. Funktionen kræver, at kunden også er sat op i Medallia.',
    npsFromDateUpdated: 'Startdatoen for NPS er ændret',
    customer: 'Kunde',
    groups: {
      titleSingular: 'Kundegruppe',
      name: 'Gruppenavn',
      titleWithCount: '{{count}} kundegrupper',
      description: 'Beskrivelse',
      numberOfCustomers: 'Antal kunder',
      none: 'Ingen kundegrupper',
      new: 'Oppræt kundegruppe',
      edit: 'Rediger kundegruppe',
      searchCustomer: 'Søg kunde',
      members: 'Kunder i gruppen',
      save: 'Gem',
      deleteConfirm: 'Slet {{name}}?',
      deleteDescription: 'Du kan ikke fortryde denne handling',
      deleted: 'Kundegruppen er slettet',
      mustProvideName: 'Du skal angive et gruppenavn',
      cannotDelete: 'Kundegruppen kan ikke slettes fordi den bruges i en aviseringsregel.'
    },
    customerTitle: 'Kunder',
    customerNo: 'Kunde Nr.',
    name: 'Navn',
    emailToSender: 'E-mail til afsender',
    emailSubscriptions: 'E-mailabonnementer',
    emailToSenderDescription:
      'Angiv standardnotifikationer for alle ordrer fra dette kundenummer, f.eks. ordreregistrering og leveringer.',
    deviations: 'Afvigelser',
    deviationsDescription: 'Opsæt kundespecifikke afvigelser i bud-appen.',
    add: 'Tilføj',
    noOrders: 'Ingen ordre i Glow',
    noOrdersDescription: 'De kunder, du har adgang til, har ingen ordrer i Glow',
    choose: 'Vælg en kunde',
    findCustomer: 'Find en kunde',
    manageCustomers: 'Administrer kunder',
    searchAndSelect: 'Søg og vælg kunde',
    changeCustomer: 'Skift kunde',
    customerPlaceHolder: 'Søg efter kunder',
    emailRecipients: 'E-mail til modtager',
    smsRecipients: 'Sms til modtager',
    addEditEmails: 'Tilføj/rediger e-mails',
    addEditSms: 'Tilføj/rediger sms',
    addEditDeviations: 'Tilføj/rediger afvigelser',
    live: 'Live',
    search: 'Søg',
    startTypingPlaceHolder: 'Begynd at skrive',
    AddEdit: 'Tilføj/rediger',
    searchHint:
      'Søg efter forsendelse, baseret på forsendelsesnummer, kundereference, pakkenummer, modtagers navn eller adresse',
    customerNumber: 'Kundenummer',
    customerNumberAlreadyExists: 'Kundenummeret findes allerede',
    accountingType: 'Regnskabstype',
    accountingTags: 'Kundetags',
    isDeleted: 'Slettet',
    deletedCannotBeUsed: 'Kunden er slettet og kan ikke bruges. Vælg en anden kunde.',
    scanOnPickup: {
      title: 'Scan pakker ved afhentning',
      ingress: 'Slå til, hvis buddet skal tvinges til at scanne pakker ved afhentning.'
    },
    senderName: 'Afsendernavn',
    senderNameIngress: 'Tilsidesæt kundenavnet, der er angivet i Glow, ved afsendelse af sms-notifikationer.',
    addSenderName: 'Tilføj afsendernavn',
    senderNameAdded: 'Afsendernavn tilføjet',
    addInvoiceHDOrdersFromDate: 'Tilføj start dato for fakturering af HD-ordre i Glow',
    invoiceHDOrdersFromDate: 'Start dato for fakturering af HD-ordre i Glow',
    invoiceHDOrdersFromDateDescription: 'Angiv en dato for, hvornår Glow Pricing Engine aktiveres for HD-kunder.',
    invoiceHDOrdersFromDateAdded: 'Start dato for fakturering af HD-ordre ændret',
    billingCustomerNumber: 'Betalende Kundenummer',
    billingCustomerNumberIngress: 'Tilsidesæt fakturanummeret, hvis faktureringen skal ske på et andet kundenummer.',
    addBillingCustomerNumber: 'Tilføj Betalende Kundenummer',
    billingCustomerNumberAdded: 'Betalende Kundenummer Tilføjet',
    searchPage: {
      fromDate: 'Fra dato',
      toDate: 'Til dato',
      today: 'I dag',
      tomorrow: 'I morgen',
      yesterday: 'I går',
      last30days: 'Seneste 30 dage',
      plusMinus15Days: '+/- 15 dage',
      plusMinus30Days: '+/- 30 dage'
    },
    smsText: {
      title: 'SMS Text',
      ingress: 'Opsæt kundeunikke tekster i SMS til modtagere.',
      addEditSmsText: 'Tilføj/rediger SMS-tekst',
      smsTextUpdated: 'SMS-tekst oprettet/opdateret',
      en: 'ENG',
      se: 'SVE',
      no: 'NOR',
      fi: 'FIN',
      dk: 'DAN',
      fr: 'FRA',
      description: 'Beskrivelse',
      smsType: 'Notifikationstype',
      smsTypeTexts: {
        common: 'SMS',
        preadvice: 'Preavisering',
        pickup: 'Sporings-SMS',
        pre_pickup: 'Forudgående sporings-SMS',
        manual_delay: 'Manuel SMS for forsinkelse',
        eta_pickup: 'ETA SMS afhentning',
        eta_delivery: 'ETA SMS levering',
        flex_delivery_confirmation: 'Flex levering SMS-bekræftelse',
        advise: 'Advis-SMS',
        delivery_confirmation: 'Leveringsbekræftelse SMS',
        pre_advice_push: 'Push-SMS',
        pre_advice_push_for_prebooked: 'Push-SMS for forudbookede kunder',
        pre_advice_push_return: 'Push retur-SMS',
        pre_advice_push_email: 'Push-e-mail',
        pre_advice_push_2nd: 'Push 2. preavisering SMS',
        pre_advice_push_2nd_email: 'Push 2. preavisering e-mail',
        pre_advice_push_return_to_sender_email: 'Push retur til afsender e-mail',
        pre_advice_pull: 'Pull-SMS',
        pre_advice_pull_email: 'Pull-e-mail',
        pre_advice_pull_reminder: 'Pull påmindelse SMS',
        pre_advice_pull_reminder_email: 'Pull påmindelse e-mail',
        pre_advice_pull_reminder_to_sender_email: 'Pull påmindelse til afsender e-mail',
        pre_advice_pull_return_to_sender_email: 'Pull retur til afsender e-mail',
        pre_advice_return: 'Returlevering SMS',
        pre_advice_return_email: 'Returlevering e-mail',
        pre_advice_return_reminder: 'Returlevering påmindelse SMS',
        pre_advice_return_reminder_email: 'Returlevering påmindelse e-mail',
        pre_advice_return_2nd: 'Returlevering 2. preavisering SMS',
        pre_advice_return_2nd_email: 'Returlevering 2. preavisering e-mail',
        pre_advice_return_return_to_sender_email: 'Returlevering retur til afsender e-mail',
        pre_advice_pup: 'PUP SMS',
        pre_advice_pup_email: 'PUP e-mail',
        pre_advice_pup_reminder: 'PUP påmindelse SMS',
        pre_advice_pup_reminder_email: 'PUP påmindelse e-mail',
        pre_advice_pup_reminder_to_sender_email: 'PUP påmindelse til afsender e-mail',
        pre_advice_pup_return_to_sender_email: 'PUP retur til afsender e-mail',
        delivery: 'Levering SMS',
        deviated: 'Leveringsafvigelse SMS',
        pre_advice_push_prebooked_recycle_sms: 'Push prebooked recycle SMS'
      }
    },
    showNotCollected: 'Ikke opsamlet',
    booking: {
      pickupReady: 'Opsamling klar',
      pickup: 'Opsamling',
      delivery: 'Levering',
      deliveryAvailable: 'Levering tilgængelig',
      serviceMessage: 'Husk at tilføje både afhentnings- og leveringsoplysninger for at se tilgængelige tjenester',
      priceComment:
        'Du vil blive faktureret i henhold til din kundeaftale med Bring. Gebyrer er ikke inkluderet i denne pris.',
      serviceUnavailable: 'Den valgte tjeneste er ikke tilgængelig for postnummer {{postalCode}}',
      recipientPrice: 'Modtagerpris:',
      customerContactPlaceholder: 'Bestilt af – Dette felt er synligt på kundefakturaen'
    },
    email: {
      addToList: 'Tilføj e-mail til listen',
      addChangesToList: 'Tilføj e-mailændringer til listen',
      emailTitle: 'E-mail til kunde',
      getNotificationsFor: 'Få notifikationer om',
      emailAddress: 'E-mail adresse',
      emailAddressError: 'Du skal angive en e-mailadresse',
      createdEvent: 'Registreret',
      collectedEvent: 'Afhentning',
      deliveredEvent: 'Levering',
      returnToSender: 'Retur til afsender',
      reminderToSender: 'Påmindelse til afsender',
      save: 'Gem',
      email: 'E-mail',
      edit: 'Rediger',
      delete: 'Slet',
      emailExists: 'E-mail eksisterer allerede',
      invalidEmail: 'Ugyldig e-mail',
      true: 'Ja',
      false: 'Nej',
      claimsReported: 'Reklamationer indberettet af modtager',
      claims: 'Claims',
      notificationType: {
        standard: 'Standardinformation',
        hdPreAdvice: 'HD preavisering',
        reportsFromRecipients: 'Indberetninger fra modtagere',
        error: 'Du skal angive notifikationstype'
      },
      customizedNotifications: 'Tilpassede notifikationer ({{count}})',
      mustAddEmailToList:
        'For at e-mailadresserne gemmes, når du trykker på Tilføj indstilling, skal du tilføje dem til listen',
      informationToCustomer: 'Information til kunde',
      returnToCustomer: 'Retur til kunde',
      addEmailToList: 'Tilføj e-mail til liste',
      registeredEmailSubscription: 'Registreret e-mailabonnement',
      updateEmail: 'Opdater e-mail',
      noRegisteredEmails: 'Ingen registrerede e-mails',
      detailsSavedSuccessfully: 'E-mail til afsender blev gemt med succes'
    },
    customerDeviations: {
      new: 'Tilføj ny afvigelse',
      deviationTitle: 'Afvigelser for kunder',
      addDeviation: 'Tilføj ny afvigelse',
      editDeviation: 'Rediger afvigelse',
      en: 'ENG',
      sv: 'SVE',
      nb: 'NOR',
      fi: 'FIN',
      dk: 'DAN',
      event: 'Hændelse',
      reason: 'Årsag',
      action: 'Handling',
      submit: 'Indsend',
      deviationCode: 'Afvigelseskode',
      deviationCodesLabel: 'Afvigelseskoder',
      deviation: 'Afvigelse',
      deviationType: 'Afvigelsestype',
      description: 'Beskrivelse',
      code: 'Kode',
      edit: 'Rediger',
      delete: 'Slet',
      deviationAdded: 'Afvigelse tilføjet',
      deviationEdited: 'Afvigelse redigeret',
      deviationExists: 'Afvigelsen eksisterer allerede',
      deviationDeleted: 'Afvigelsen blev slettet'
    },
    customerInfo: 'Kunde Info',
    customerInformation: 'Kundeoplysninger',
    customerName: 'Kundenavn',
    invoicingAddress: 'Faktureringsadresse',
    organisationNumber: 'Organisationsnummer',
    visitingAddress: 'Besøgsadresse',
    creditBlocked: 'Kredit spærret',
    creditBlockedFrom: 'Kredit spærret fra dato',
    creditBlockedFromInfo: 'Bloker kredit for denne kunde fra en valgt dato',
    creditBlockedIngress: 'Angiv den sidste dato for oprettelse af ordrer i Glow for denne kunde.',
    from: 'Fra',
    address: 'Adresse',
    zipCode: 'Postnummer',
    zipArea: 'Sted',
    country: 'Land',
    edit: 'Rediger {{name}}',
    selectCountry: 'Vælg land',
    settingsInGlow: 'Indstillinger i Glow',
    addSetting: 'Tilføj indstilling',
    editSetting: 'Rediger indstilling',
    addNewCustomer: 'Tilføj ny kunde',
    bookingPageModalHeading: 'Booking side i Kundeportalen',
    bookingPageModalDescription: 'Kunden skal kunne booke forsendelser på dette kundenummer i Glow kundeportal',
    bookingActive: 'Til',
    bookingInactive: 'Fra',
    brandedTrackingActive: 'Til',
    brandedTrackingInactive: 'Fra',
    bookingPageAvailable: 'Ja',
    bookingPageHidden: 'Nej',
    customerBookingPageAccessUpdated: 'Adgang til bookingsiden er opdateret',
    brandedTrackingAccessUpdated: 'Faktureringsstatus for Branded Tracking er opdateret',
    returnLastLegUpdated: 'Status for sidste returdel er opdateret',
    token: {
      warningDark:
        'Denne kunde er blokeret og kan ikke oprette nogen bookinger. Fjern blokeringen for at aktivere kunden.',
      warningLight: 'Husk at kopiere API-nøglen nu. Du vil ikke kunne se den igen!',
      success: 'Du har allerede genereret en API-nøgle til denne kunde',
      allowApiKey: 'Tillad API-nøgle for kunde',
      allowApiKeyDescription: 'Før du genererer en API-nøgle, skal du først tillade, at denne handling udføres.',
      allowApiKeyButtonText: 'Tillad API-nøgle',
      apiKeyCopied: 'API-nøglen er blevet kopieret',
      generateApiKeyDescription:
        'API-nøglen er en unik nøgle pr. kunde. Nøglen bruges, når din kunde opretter en booking i kundeportalen. Læs mere om vores API <0>her</0>.',
      generateApiKey: 'Generer API-nøgle'
    },
    nonInvoiceable: 'Ikke faktura',
    internalNonInvoiceable: 'Intern / Kunden vil ikke blive faktureret'
  },
  texts: {
    tabTitle: 'Tekster og oversættelser',
    successfullyAdded: 'Teksten blev tilføjet til listen',
    successfullyUpdated: 'Teksten blev opdateret',
    successfullyDeleted: 'Teksten blev slettet',
    allTextsAndVases: 'Liste over alle tekster og oversættelser',
    searchText: 'Søg efter tekst',
    deleteModalTitle: 'Slet tekst',
    deleteModalDescription: 'Denne handling kan ikke fortrydes',
    createNewText: 'Opret ny tekst',
    title: 'Tekst',
    update: 'Opdate tekst',
    name: 'Navn på tekst',
    group: 'Gruppering',
    edit: 'Rediger',
    delete: 'Slet',
    add: 'Tilføj tekst',
    reset: 'Nulstil',
    confirmDelete: 'Er du sikker på, du vil slette teksten?',
    added: 'Tekst tilføjet',
    deleted: 'Tekst slette',
    updated: 'Tekst opdateret',
    nameToolTip: 'Navn vises, når tekst linkes til tjenesten'
  },
  billingType: {
    day: 'dag',
    evening: 'aften',
    weekend: 'weekend',
    weekendEvening: 'aften i weekenden'
  },
  importExport: {
    dropText: 'Dra fil hit for å laste opp',
    export: 'Eksporter',
    exportAddresses: 'Eksporter kundeadresser til Excel',
    importExcel: 'Importer fra Excel',
    imported: 'adresser importeret',
    or: 'eller',
    selectFile: 'Velg fil',
    uploadingFile: 'Uploader...'
  },
  customMeasurements: {
    name: 'Navn',
    weight: 'Vægt',
    height: 'Højde',
    length: 'Længde',
    width: 'Bredde',
    heading: 'Tilpassede godstyper',
    error: 'Fejl ved lagring af godstype: ',
    confirmDelete: 'Er du sikker på du vil slette denne godstype?',
    new: 'Lav ny',
    customGoodsTypes: 'Tilpassede godstyper',
    defaultGoodsTypes: 'Standard godstyper',
    invalidName: 'Navn skal indeholde minimum 1 bogstav'
  },
  unresolved: {
    unresolvedAddresses: 'Uløste adresser',
    allResolved: 'Alle adresser er løst!',
    address: 'Adresse',
    noOfShipments: 'Antal forsendelser',
    shipment: 'forsendelse',
    shipment_other: 'forsendelser',
    shipmentNumber: 'Forsendelsesnummer',
    customerRef: 'Kundereference',
    senderName: 'Afsendernavn',
    senderPhone: 'Afsenders telefonnummer',
    recipientName: 'Modtagers navn',
    recipientPhone: 'Modtagerens telefonnummer',
    searchAndSetLocation: 'Søg og vælg lokation',
    setALocationToContinue: 'Vælg lokation og fortsæt',
    resolveAddress: 'Løs adresse',
    suggestedAddressFound: 'Foreslået adresse fundet',
    thereIsOneUnresolvedAddress: 'Der er {{count}} uløst adresse',
    thereIsOneUnresolvedAddress_other: 'Der er {{count}} uløste adresser'
  },
  optimizing: {
    title: 'Optimering',
    optimizingId: 'Optimerings-ID',
    reqTime: 'Anmodningstid',
    respTime: 'Responstid',
    showOnlyErrors: 'Vis kun fejl',
    department: 'Afdeling',
    userName: 'Bruger',
    graphID: 'ID',
    request: 'Anmodning',
    response: 'Respons',
    error: 'Fejl',
    viewReqResp: 'vis',
    status: 'Status',
    totalTime: 'Tid',
    selectOptimizingObjective: 'Vælg optimeringsmål',
    cancelRequest: 'Annuller anmodning',
    noOptimizations: 'Ingen optimeringer for den valgte søgning',
    viewRaw: 'Vis rådata',
    quality: {
      STANDARD: 'Standard',
      HIGH: 'Høj',
      PREMIUM: 'Premium'
    },
    objectives: {
      completion_time: 'Minimum samlet leveringstid (standard)',
      min_vehicles: 'Minimum samlet antal køretøjer',
      work_time: 'Jævn leveringstid',
      number_of_deliveries: 'Jævnt antal leveringer',
      deliveries_and_work_time: 'Jævn arbejdstid og jævnt antal leveringer'
    },
    kbSize: 'KB anmodning',
    showAll: 'Vis alle',
    numberOfShipments: 'Antal forsendelser',
    numberOfVehicles: 'Antal køretøjer',
    processingTime: 'Behandlingstid',
    stats: 'Statistik',
    addToCompare: 'Tilføj kørsel til sammenligning',
    noRunsToCompare: 'Ingen andre færdige kørsler denne dag',
    removeFromCompare: 'Fjern fra sammenligning',
    noStats: 'Ingen statistik',
    routesUsed: 'Ruter brugt',
    leftOut: 'Ikke planlagt',
    stops: 'Stop',
    distanceKm: 'Distance (km)',
    drivingTime: 'Køretid',
    waitingTime: 'Ventetid',
    routeTime: 'Samlet rutetid',
    longestRoute: 'Længste rute',
    type: 'Type'
  },
  date: {
    date: 'Dato',
    today: 'I dag',
    tomorrow: 'I morgen',
    yesterday: 'I går',
    dateAndTime: 'Dato og tid',
    from: 'Fra',
    fromDate: 'Fra dato',
    rangeOptions: {
      '15d': '+/- 15 dage',
      '30d': '+/- 30 dage',
      custom: 'Tilpassede datoer',
      last30d: 'Seneste 30 dage',
      last7d: 'Seneste 7 dage',
      month: 'Måned',
      months: 'Måneder',
      today: 'I dag',
      tomorrow: 'I morgen',
      yesterday: 'I går',
      thisMonth: 'Denne måned',
      lastMonth: 'Sidste måned'
    },
    to: 'Til',
    toDate: 'Til dato'
  },
  areaSequence: {
    title: 'Sekvensområde',
    description:
      'Tilføj op til {{max}} kortpunkter for at styre leveringsrækkefølgen. Leveringen tættest på hvert punkt prioriteres i den valgte rækkefølge, mens leveringerne mellem punkterne optimeres til den mest effektive rute. Dette styrer rækkefølgen, men gennemtvinger ikke hele områder.',
    order: 'Rækkefølge af områder',
    orderWhileEditing: 'Rækkefølge af områder - træk kortene for at ændre rækkefølgen',
    added: '{{count}} af {{max}} områder tilføjet',
    save: 'Gem område',
    unsaved: 'Gem eller annuller ændringerne i kortområderne, før du gemmer ruten.',
    pin: 'Område {{number}}',
    overlap: 'Område {{number}} overlapper med område {{other}}. Flyt et af dem længere væk.',
    maxReached: 'Du kan tilføje op til {{max}} kortpunkter.',
    tool: {
      add: 'Tilføj område',
      move: 'Flyt områder',
      delete: 'Slet områder'
    },
    hint: {
      add: 'Klik på kortet for at tilføje et område',
      move: 'Træk markøren for at flytte området. Gem for at beholde ændringerne, eller Annuller for at kassere dem.',
      delete: 'Klik på en markør for at slette området'
    }
  },
  routeReceipt: {
    printRouteReceiptList: 'Udskriv kvitteringsliste',
    noRoutesInfoAvailable: 'Ingen ruteinformation tilgængelig endnu'
  },
  homeDeliveryRouteList: {
    receiptList: 'Kvitteringsliste',
    shipments: 'Forsendelser',
    weight: 'Vægt',
    volume: 'Volumen',
    bookedWeight: 'Booked vægt{{unit}}',
    bookedVolume: 'Booked volumen{{unit}}',
    sender: 'Afsender',
    package: 'Kolli',
    shipmentNo: 'Forsendelsesnummer',
    ref: 'Ref.',
    recipient: 'Modtager',
    time: 'Tid',
    mobile: 'Mobil',
    other: 'Øvrigt',
    attemptedDelivery: 'Forgæves kørsel',
    receipt: 'Kvittering',
    dateOfBirth: 'Fødselsdato',
    signature: 'Underskrift',
    nameClarification: 'Navn',
    goodsLine1: 'Husk at kontrollere varerne for synlige skader inden du underskriver.',
    goodsLine2: 'Hvis der er synlige skader, skal chaufførerne notere dem inden du som modtager underskriver.',
    damage: 'Skade',
    missing: 'Mangler',
    packageNumber: 'Kollinummer',
    comments: 'Kommentar'
  },
  columnCategories: {
    aboutTheShipment: 'Om forsendelsen',
    goods: 'Varer',
    timeAndDate: 'Tid og dato',
    planning: 'Planlægning',
    pickupInformation: 'Afhentningsinformation',
    customer: 'Kunde',
    deliveryInformation: 'Leveringsinformation',
    originalSender: 'Oprindelig afsender',
    originalDelivery: 'Oprindelig levering',
    service: 'Service',
    preAdvice: 'Forhåndsråd',
    invoicingInformation: 'Faktureringsoplysninger'
  },
  shipment: {
    offeredOrdersPending: 'Tilbudte ordrer afventer svar',
    shipment: 'Forsendelse',
    multileg: 'multileg',
    pickupLeg: 'Afhentningsben',
    deliveryLeg: 'Leveringsben',
    customer: 'Kunde',
    customerContact: 'Kontaktperson hos kunden',
    customerReference: 'Kundereference',
    customerNumber: 'Kundenummer',
    route: 'Rute',
    service: 'Tjeneste',
    additionalServices: 'Ekstra services',
    quantity: 'Mængde',
    totalWeight: 'Total vægt',
    totalVolume: 'Total volumen',
    totalLoadingMeters: 'Lastmeter totalt',
    totalPalletFootPrints: 'Pallplads totalt',
    goodsInfo: 'Vareoplysninger',
    packages: 'Pakker',
    pickupInfo: 'Afhentningsinformation',
    pickupDate: 'Afhentningsdato',
    pickupTime: 'Afhentningstid',
    pickupInstructions: 'Opsamlingsinstruktioner',
    deliveryInfo: 'Leveringsinformation',
    deliveryDate: 'Leveringsdato',
    deliveryTime: 'Leveringstid',
    eta: 'ETA',
    ata: 'ATA',
    receiverReference: 'Modtagers reference',
    deliveryInstructions: 'Leveringsinstruktioner',
    trackingPage: 'Modtagers sporingsside',
    internalNote: 'Intern note',
    name: 'Navn',
    address: 'Adresse',
    zipCode: 'Postnummer',
    zipArea: 'By',
    phone: 'Telefon',
    secondPhone: 'Telefon 2',
    email: 'E-mailadresse'
  },
  bookingTimeWindow: {
    week: 'Uge',
    bookButton: 'Bestil',
    customButton: ' Tilpasset tidsvindue',
    removeBookingButton: 'Fjern bestilling',
    noBookingYet: 'Ingen booking endnu',
    serverError: 'Der opstod en fejl på serveren. Prøv igen senere.',
    previousButton: 'Forrige',
    nextButton: 'Næste',
    noAvailableDeliveryTimes: 'Ingen tilgængelige tidsvinduer denne måned',
    customTimeTitle: 'Angiv tilpasset tidsvindue for forsendelse',
    customDateLabel: 'Dato',
    errorEarliestNotBeforeLatest: 'Tidligste leveringstid må være før seneste',
    arrivedAtTerminal: 'Ankommet på terminal',
    bookCustomTimeSlot: 'Book tidspunkt',
    shipmentBooked: 'Forsendelse booket',
    shipmentBookedWithCustomTimeWindow: 'Forsendelse booket med tilpasset tidsvindue',
    updateBooking: 'Opdater booking',
    bookingChanged: 'Booking er ændret med succes',
    bookingSuccessful: 'Booking blev udført med succes',
    customTimeWindowAdded: 'Tilpasset tidsvindue for forsendelse blev tilføjet med succes',
    timeFrom: 'Tid fra',
    timeTo: 'Tid til',
    timeFieldError: 'Det tidligste leveringstidspunkt skal være før det seneste',
    availableTimeSlot: 'Tilgængelige tidsvinduer',
    submitNotSelectedError: 'Du skal vælge et tidsvindue'
  },
  manualOverride: {
    manuallyAddEvents: 'Manuelt tilføj begivenheder',
    selectEvent: 'Vælg begivenhed',
    shipmentEvent: 'Forsendelsesbegivenhed',
    terminalEvent: 'Terminalhændelse',
    scannedFormDescription: 'Typen af ​​ankomstscanning udløses af, hvilken afdeling du vælger.',
    suggestPageReload: 'Noget gik galt. Genindlæs siden, og prøv igen.',
    eventType: {
      delivered: 'Leveret',
      collected: 'Opsamlet',
      returned: 'Returneret',
      deviated: 'Afveget',
      scanned: 'Scannet',
      preadvised: 'Preadvice forsøg',
      'order-sorted': 'Sorteret',
      'not-arrived-at-distributing-terminal': 'Ikke ankommet',
      'ready-for-pickup': 'Klar til afhentning (PUP på terminal)'
    },
    selectEventType: 'Vælg en type hændelse',
    noEventSelected: 'Ingen hændelse valgt',
    selectManifest: 'Vælg flight',
    noManifestSelected: 'Ingen flight valgt',
    disabledEventReason: {
      returned: ' - Afvigelse påkrævet',
      collected: ' - Disponering påkrævet',
      default: ' - Ikke tilladt',
      'order-sorted': 'Kun for H2-ordrer',
      'not-arrived-at-distributing-terminal': 'Kun for HD-ordrer'
    },
    fillDeliverOrReturnEventInfo: 'Udfyld navn, dato og tidspunkt',
    fillDeviationEventInfo: 'Vælg afvigelse og udfyld navn, dato og tidspunkt',
    fillGeneralEventInfo: 'Udfyld dato og tidspunkt',
    eventMessage: 'Hændelse skabt',
    allPackagesSelected: 'Alle kolli valgt',
    noActiveDriverError: 'Ingen aktive chauffører på enheden',
    selectPackages: 'Vælg kolli',
    selectDriver: 'Vælg bud',
    selectUnit: 'Vælg enhed',
    selectDepartment: 'Overstyr afdeling'
  },
  zendesk: {
    email: 'Din email:',
    confirmEmail: 'Gentag email:',
    send: 'Gem',
    missingEmail:
      'For at bruge den nye support portal, skal du registrere din Posten eller Bring email. Det skal kun gøres en gang.'
  },
  shipmentFormPage: {
    activeOrders: 'Aktive ordrer',
    deletedOrders: 'Slettede ordrer',
    deletedOrdersDescription: 'Slettede ordrer søges separat og kan indeholde andre oplysninger end aktive ordrer.',
    searchPhraseError: 'Du skal angive mindst 3 tegn',
    selectStateLabel: 'Vælg tilstand fra rullemenuen',
    selectDateLabel: 'Vælg datointerval fra rullemenuen',
    submit: 'Vis resultater',
    inputPlaceholder: 'Søg efter forsendelses-ID, telefonnummer, adresse, område, postnummer ...',
    clearButtonLabel: 'Ryd søgeudtryk-knap',
    allStates: 'Alle tilstande',
    customDate: 'Tilpasset',
    noDate: 'Ingen datobegrænsning',
    withoutDeliveryDate: 'Uden leveringsdato',
    selectFromDate: 'Vælg fra dato',
    selectToDate: 'Vælg til dato',
    include: 'Inkluder',
    exclude: 'Ekskluder',
    tableColumn: 'Tabelkolonne',
    condition: 'Betingelse',
    searchTerm: 'Søgeterm',
    tableDropdown: 'Vælg tabel fra rullemenuen',
    conditionDropdown: 'Vælg betingelse fra rullemenuen',
    typeSearch: 'Indtast søgeterm',
    typeSearchCommaSeparated: 'Indtast søgetermer, adskilt med komma',
    addNewRow: 'Tilføj ny række',
    deleteRow: 'Slet nuværende række',
    service: 'Service',
    goodsDescription: 'Varebeskrivelse',
    unit: 'Enhed',
    deliveryArea: 'Leveringsområde',
    deliveryZipcode: 'Leveringspostnummer',
    state: '{{count}} Tilstand',
    state_other: '{{count}} Tilstande',
    today: 'I dag',
    tomorrow: 'I morgen',
    yesterday: 'I går',
    last30Days: 'Seneste 30 dage',
    plusMinus15Days: '+/- 15 dage',
    plusMinus30Days: '+/- 30 dage',
    shipmentIds: 'Flere forsendelser',
    advancedFilter: 'Udvidet filter',
    advancedSearch: 'Avanceret søgning',
    closeAdvancedSearch: 'Luk avanceret søgning',
    selectTable: 'Vælg tabel',
    selectCondition: 'Vælg betingelse',
    orderId: 'Internt ordrenummer',
    allAnd: 'Alle (og)',
    anyOr: 'Enhver (eller)',
    customers: {
      placeholder: 'Alle kunder',
      label: 'Vælg kunder'
    },
    allOrderSources: 'Alle interne ordrekilder',
    orderSource: '{{count}} intern ordrekilde',
    orderSource_other: '{{count}} interne ordrekilder',
    vasCodes: '{{count}} VAS-kode',
    vasCodes_other: '{{count}} VAS-koder',
    vasCodesPlaceholder: 'Søg på VAS-kode eller navn',
    orderSourceOption: {
      GLOW: 'GLOW',
      GLOW_CUSTOMER_BOOKING: 'GLOW Kundebooking',
      GLOW_EXCEL: 'GLOW Excel'
    }
  },
  shipmentResultPage: {
    deletedOrdersLimitReached: 'Viser de {{limit}} senest slettede ordrer. Overvej at indsnævre din søgning.',
    noResultTitle: 'Ingen resultater fundet',
    batchLimitReached: 'Viser maksimalt 2000 forsendelser, overvej at indskrænke din søgning',
    withoutDateLimitReached:
      'Når der søges uden dato, vises der højst {{limit}} forsendelser. Overvej at indsnævre din søgning.',
    withoutDeliveryDateLimitReached:
      'Når der søges efter forsendelser uden leveringsdato, vises der højst {{limit}} forsendelser. Overvej at indsnævre din søgning.',
    findYourShipments: 'Find dine forsendelser',
    findYourShipmentsDescription:
      'Indtast det du leder efter i søgefeltet ovenfor. Flere muligheder findes under avanceret søgning',
    searchByShipmentIdsLimitReached:
      "Ved søgning efter forsendelses-ID'er viser vi maksimalt {{limit}} forsendelser. Overvej at indsnævre din søgning.",
    searchError: 'Søgningen mislykkedes. Prøv at genindlæse siden eller ændre dine søgekriterier'
  },
  shipmentTable: {
    quantity: 'Antal',
    delEta: 'LEV ETA',
    delDuration: 'LEV varighed',
    delDurationTitle: 'Leveringens varighed',
    delPreparation: 'LEV forb.',
    delPreparationTitle: 'Forberedelse levering',
    delDeliveryFrom: 'LEV fra',
    delDeliveryFromTitle: 'Tidspunkt for levering fra',
    delDeliveryTo: 'LEV til',
    delDeliveryToTitle: 'Tidspunkt for levering til',
    timeOfDelivery: 'Leveringstidspunkt',
    puDuration: 'Afhent. varighed',
    puDurationTitle: 'Afhentningsvarighed',
    puPreparation: 'Afhent. forb.',
    puPreparationTitle: 'Forberedelse afhentning',
    puPickupFrom: 'Afhent fra',
    puPickupFromTitle: 'Tidspunkt for afhentning fra',
    puPickupTo: 'Afhent til',
    puPickupToTitle: 'Tidspunkt for afhentning til',
    timeOfPickup: 'Tidspunkt for afhentning',
    timeFrom: 'Tid fra',
    timeFromTitle: 'Tidspunkt for stop fra',
    timeTo: 'Tid til',
    timeToTitle: 'Tidspunkt for stop til',
    delEtaTitle: 'Estimeret leveringstidspunkt',
    recipientRef: 'Modtagers ref',
    loading: 'Indlæser...',
    pickupName: 'Afhentningsnavn',
    deliveryName: 'Leveringsnavn',
    pickupColumn: 'Afhentning: {{column}}',
    deliveryColumn: 'Levering: {{column}}',
    selectAllOnPage: 'Vælg alle på siden ({{count}})',
    selectAll: 'Vælg alle ({{count}})',
    deselectAll: 'Fravælg alle',
    numSelectedShipments: '{{numSelected}} valgt',
    createLabels: 'Opret etiketter',
    yourSearchResult: 'Dit søgeresultat',
    numberOfShipmentsFound: '{{count}} forsendelser fundet',
    orderedDeliveryDate: 'Bestilt leveringsdato',
    vendorInvoice: 'Leverandørfaktura',
    customerInvoice: 'Kundefaktura'
  },
  shipmentResultActions: {
    confirmDeleteTitle: 'Slette forsendelse?',
    confirmDuplicateTitle: 'Duplikere forsendelse?',
    confirmDuplicateButton: 'Duplikere',
    deleteSuccess: 'Forsendelsen blev slettet med succes',
    manuallyPreAdviceSuccess: 'Preavisering igangsat til forsendelse',
    manuallyPreAdviceSuccess_other: 'Preavisering igangsat til forsendelser',
    confirmDeleteTitle_other: 'Slet valgte forsendelser?',
    deleteSuccess_other: 'Forsendelser blev slettet',
    invoiceActions: 'Fakturahandlinger',
    shipmentActions: 'Forsendelseshandlinger',
    showInvoicePayloadDisableTooltip: 'Forsendelser skal have faktureringsstatus "mislykket" eller "OK"'
  },
  moveDepartmentModal: {
    errorMessage: 'Ordre(r): {{orderIds}}, fejl: {{error}}',
    errorMessage_other: 'Ordre(r): {{orderIds}}, fejl: {{error}}',
    ordersMovedText: 'Ordren er blevet flyttet til afdeling {{department}}',
    ordersMovedText_other: 'Ordrerne er blevet flyttet til afdeling {{department}}',
    partialSuccessMessage: '{{count}} af {{fullCount}} forsendelse blev flyttet',
    title: 'Flyt valgte forsendelse til en anden afdeling'
  },
  updateDeliveryTimeBulk: {
    menuItem: 'Ændre leveringsdato og tid',
    heading: 'Ændre leveringsdato og tid',
    buttonTitle: 'Ændre og advisér',
    smsDescription:
      'Modtagerne får en SMS med en ny leveringsdato og et nyt tidsvindue samt et link, hvor de kan ændre tidspunktet.',
    successMessage: '{{count}} forsendelse blev opdateret',
    successMessage_other: '{{count}} forsendelser blev opdateret',
    notNotified:
      'Der blev ikke sendt SMS for {{shipmentIds}} - modtageren har ikke et gyldigt telefonnummer eller en gyldig e-mailadresse',
    notNotified_other:
      'Der blev ikke sendt SMS for {{shipmentIds}} - modtagerne har ikke et gyldigt telefonnummer eller en gyldig e-mailadresse',
    disabledTooltip: 'Leveringstid kan kun ændres, før forsendelsen er tildelt en rute',
    dateInPast: 'Leveringsdatoen kan ikke være i fortiden',
    invalidDate: 'Ugyldig dato'
  },
  sendManualDelaySmsModal: {
    errorMessage: '{{error}} {{shipmentIds}}',
    partialSuccessMessage: '{{count}} af {{fullCount}} SMS blev sendt',
    successMessage: 'Manuel forsinkelses-SMS blev sendt med succes'
  },
  sendPrePickupSmsModal: {
    successMessage: 'Sporings-SMS før afsendelse blev sendt',
    'return-order': 'Ordrer kan ikke være returordrer',
    'invalid-state': 'Ordrer skal have status Tildelt til rute'
  },
  multistopModal: {
    title: 'Gruppeinformation',
    description: 'Gruppevisning for ordrer, der betales sammen.',
    debitLines: 'Debetlinjer',
    notFound: 'Ingen gruppeinformation fundet',
    shipmentId: 'Forsendelsenummer',
    deliveryDate: 'Leveringsdato',
    stopAddress: 'Stopadresse',
    postalCode: 'Postnummer',
    noPrice: 'Ingen prisoplysninger tilgængelige for gruppe',
    priceUpdated: 'Gruppens priser er blevet opdateret'
  },
  shipmentDetails: {
    notFoundTitle: 'Forsendelsen blev ikke fundet',
    notFoundDescription: 'Den kan være slettet.',
    overview: 'Oversigt',
    details: 'Detaljer',
    orderInformation: 'Ordreinformation',
    volumeAndWeight: 'Volumen og vægt',
    references: 'Referencer',
    goods: 'Gods',
    contactInformation: 'Kontaktinformation',
    pickupContactInformation: 'Kontaktinformation for afhentning',
    deliveryContactInformation: 'Kontaktinformation for levering',
    eventWasAdded: 'Begivenhed blev tilføjet',
    issueSaving: 'Der opstod et problem med at gemme',
    noSelectedPackages: 'Ingen pakker blev valgt',
    pickupAndDelivery: 'Afhentning og levering',
    whereIsTheOrder: 'Hvor er ordren',
    communicationToRecipient: 'Kommunikation til modtager',
    yesPremium: 'Ja, premium',
    alerts: 'Advarsler',
    pickupDeliveryInfo: 'Afhentnings- og leveringsoplysninger',
    quickEdit: 'Hurtig redigering',
    quickEditTitle: 'Rediger afhentnings- og leveringsoplysninger',
    aboutShipment: 'Om forsendelsen',
    mapLinkText: 'Vis kortkoordinater',
    copyShipment: 'Kopiér forsendelse',
    editShipment: 'Rediger forsendelsesoplysninger',
    location: 'Placering',
    time: 'Tid',
    selectDate: 'Vælg dato',
    manualChangeEvent: 'Manuelt ændre begivenhed',
    disabledEventReason: { returned: 'Afvigelse kræves', collected: 'Skal tildeles rute', default: 'Ikke tilladt' },
    selectDeviation: 'Vælg afvigelse',
    required: 'Påkrævet',
    allPackages: 'Alle pakker',
    packages: 'Pakker',
    package: 'Pakke',
    changeDepartment: 'Skift afdeling',
    moveDepartment: 'Flyt afdeling',
    shipmentMoved: 'Forsendelse flyttet',
    shipmentMovedText: 'Forsendelse {{shipmentId}} er blevet flyttet til afdeling {{department}}',
    shipmentMovedGoBack: 'Gå tilbage til søgesiden',
    shipmentCouldNotBeMoved: 'Forsendelsen kunne ikke flyttes',
    moveShipmentDescription:
      'Hvis du ikke har adgang til afdelingen, vil du ikke være i stand til at finde forsendelsen efter flytning.',
    moveShipmentConfirmText: 'Flyt forsendelse til en anden afdeling?',
    addShipmentToSlot: 'Tilføj forsendelse til {{slot}}?',
    changeSlotConfirm: 'Skift rute for forsendelse til {{slot}}?',
    changeSlot: 'Skift rute',
    selectSlot: 'Vælg rute',
    AddToSlot: 'Tilføj til rute',
    optimisationInProgress: 'Optimering i gang. Du kan ikke ændre ruten, mens ruten optimeres.',
    removeFromSlot: 'Fjern fra rute',
    removeShipmentFromSlot: 'Fjern forsendelse fra rute',
    removeShipmentFromSlotHeading: 'Fjern forsendelsen fra denne rute?',
    successRemoveFromSlot: 'Forsendelsen blev fjernet fra ruten',
    successChangeSlot: 'Forsendelsen skiftede rute',
    successAddToSlot: 'Forsendelsen blev tilføjet til ruten',
    changeSlotDescription: 'Skift af rute udføres uden ruteoptimering.',
    addToSlotDescription:
      'Den valgte rute vil blive optimeret, mens de eksisterende forsendelser forbliver i samme rækkefølge',
    pickupOrDeliveryChange: 'Afhentning eller levering er blevet ændret',
    pickupOrDeliveryChangeDescription:
      'Afhentnings- eller leveringsadressen er blevet ændret. Hvis du vil ændre adressen tilbage, skal du trykke på en af knapperne nedenfor.',
    addressWasUnresolved: 'Adressen var uløst',
    eventTimeCannotBeInFuture: 'Hændelsestidspunktet kan ikke være i fremtiden.',
    shipmentSuccessfullyUpdated: 'Forsendelsen blev opdateret',
    connectedShipments: 'Relaterede forsendelser',
    goToShipment: 'Gå til forsendelse',
    currentShipment: 'Nuværende forsendelse',
    duplicate: 'Duplikat'
  },
  terminal: 'Terminal',
  location: 'Placering',
  scannedAtDelegatedDepartment: 'Scannet fra den delegerede afdeling.',
  pickupOrders: {
    acceptOrders: 'Accepter ordrer',
    selected: 'valgt',
    handleOrders: 'Håndter afhentningsordrer',
    found: 'fundet',
    accept: 'Accepter',
    reject: 'Afvis',
    noResultText: 'Vi kunne ikke finde nogen resultater. Prøv at søge med en anden dato.',
    last7d: 'I dag + de sidste 7 dage',
    rejectOptions: {
      notFound: 'Afsender ikke fundet på afhentningsadressen. Ingen flere forsøg. Afhentning lukket.',
      terminatesPickupOrder: 'Afsender afslutter afhentningsordre. Ingen flere forsøg. Afhentning lukkes.',
      handedOver: 'Afsender har overdraget afhentning til en anden transportør. Ingen flere forsøg. Afhentning lukkes.',
      noMoreAttempts: 'Afsender er flyttet. Ingen flere forsøg. Afhentning lukkes.',
      pickupCorrected: 'Afsender er flyttet. Afhentning rettet og sendt tilbage til underleverandør.',
      goodsNotReady: 'Varer ikke klar til afhentning. Ingen flere forsøg. Afhentning lukkes.',
      incorrectBooking: 'Forkert booking. Afhentning afsluttet.',
      senderRefuses: 'Afsender nægter at overdrage varer. Ingen flere forsøg. Afhentning lukkes.',
      addressCorrected: 'Forkert afhentningsadresse. Adresse rettet.',
      incorrectAddressNoMoreAttempts: 'Forkert afhentningsadresse. Ingen flere forsøg. Afhentning lukkes.',
      senderNotified: 'Forkert afhentningsadresse. Ingen flere forsøg. Afhentning lukkes.',
      forbiddenGoods: 'Forbudte varer. Ingen flere forsøg. Afhentning lukkes.',
      timeFrame:
        'Afhentning kan ikke udføres inden for tidsrammen. Afhentningsordre sendt tilbage til reservationskontoret.'
    },
    mustSelectReason: 'Du skal vælge en grund til afvisning',
    selectRejectReason: 'Vælg årsag til afvisning*',
    selectReason: 'Vælg årsag',
    commentPlaceholder: 'Valgfrit - angiv ekstra information til afvisning',
    acceptedSuccessToast: 'blev accepteret med succes',
    rejectedSuccessToast: 'blev afvist med succes',
    errorToast: 'Noget gik galt',
    rejectOrders: 'Afvis ordrer',
    shipment: '{{count}} forsendelse',
    shipment_other: '{{count}} forsendelser'
  },
  editShipments: {
    pickupShouldBeBeforeDeliveryForAllShipments:
      'Forsendelse [{{shipmentIds}}] kunne ikke behandles, fordi kombinationen af nye og eksisterende tider ikke er gyldig. Fravælg den fejlende forsendelse, og prøv igen.',
    pickupShouldBeBeforeDeliveryForAllShipments_other:
      "{{count}} forsendelser kunne ikke behandles, fordi kombinationen af nye og eksisterende tider ikke er gyldig. Fravælg de fejlende forsendelser, og prøv igen. Fejlede forsendelses-ID'er - {{shipmentIds}}",
    useExistingTimes: 'Brug eksisterende tider',
    pickupShouldBeBeforeDelivery: 'Afhentningstidsvindue skal være før leveringstidsvinduet',
    pickupEarliestShouldBeBeforeLatest: 'Den tidligste afhentningstid skal være før den seneste',
    deliveryEarliestShouldBeBeforeLatest: 'Den tidligste leveringstid skal være før den seneste',
    success: 'Forsendelsesoplysninger blev opdateret med succes',
    pickupDateTime: 'Opsamling dato og tid',
    deliveryDateTime: 'Levering dato og tid',
    earliestPickupTime: 'Tidligste opsamlingstidspunk',
    latestPickupTime: 'Seneste opsamlingsstidspunkt',
    earliestDeliveryTime: 'Tidligste leveringstid',
    latestDeliveryTime: 'Seneste leveringstid',
    pickupName: 'Opsamlingsnavn',
    pickupPhoneNumber: 'opsamlingstelefonnummer',
    deliveryName: 'Leveringsnavn',
    deliveryPhoneNumber: 'Leveringstelefonnummer',
    pickupInstructions: 'Opsamlingsinstruktioner',
    deliveryInstructions: 'Leveringsinstruktioner',
    mixedShipmentsSelected:
      'Du har valgt forsendelser med og uden en dato. Afhentnings- og leveringsoplysninger kræves.',
    fieldNotEditable: 'Disse oplysninger kan ikke redigeres for ordrer med status Tildelt til rute eller Opsamlet',
    bulkActionDisabledReason: 'Ordrer i tilstand Afviger, Leveret, Afvist eller Returneret kan ikke redigeres',
    withoutDateDisabledReason:
      'Kombinationen af ordrer med status Tildelt til rute eller Opsamlet og uden dato kan ikke redigeres'
  },
  shipmentSelectColumn: {
    titleDeletedOrders: 'Tilpas datatabellen for slettede ordrer',
    title: 'Tilpas kolonneoverskrifter',
    addColumnHeader: 'Tilføj kolonneoverskrifter',
    addColumnBody:
      'Vælg de overskrifter, du vil have vist i datatabellen. Vores tip er at bruge 10-15 forskellige overskrifter for at undgå, at informationen bliver klippet af. Det nøjagtige antal afhænger af størrelsen på enheden, du arbejder på.',
    orderOfTable: 'Rækkefølge af kolonneoverskrifter'
  },
  bulkActions: {
    routeReceiptList: { disabledTooltip: 'Ordrer kan ikke være i tilstand Resolved eller Unresolved' },
    unassignShipmentFromSlot: 'Fjern tildeling af forsendelser fra spor',
    unassignShipmentFromSlotDisabledReason: 'Ordrer skal have status Tildelt til rute eller Tilbudt',
    forceUnassignShipmentFromSlot: 'Tving fjernelse af tildeling af forsendelser fra spor',
    disabledMoveDepartmentTooltip:
      'Ordrer skal være i tilstand Oprettet, Løst, Uløst eller Afvist for at blive flyttet',
    deleteDisableTooltip:
      'Forsendelsen kan ikke slettes, hvis den er i tilstand Oprettet, Uløst, Løst, Tilbudt eller Tildelt',
    duplicateDisableTooltip:
      'Forsendelser skal være i tilstand Afviget eller Returneret, og afdelingstypen skal være Kurer',
    onlyReleasePausedOrders: 'Du kan kun frigive pausede ordrer.',
    onlyOverrideTheseInvoicingStatuses: 'Du kan kun tilsidesætte ordrer med disse faktureringsstatusser: {{statuses}}',
    shipmentForPauseDisableText:
      'Forsendelser skal have status med ordrekorrektion, til fakturering eller fakturering mislykkedes',
    creditDisableTooltip: 'Forsendelserne skal have Invoicing Status af "Invoiced OK"',
    copyDisableTooltip: 'Kopiér til faktureringsordre er kun tilladt for ordrer med faktureringsstatus Faktureret OK',
    createWaybills: 'Opret fragtbreve',
    createWaybillsTooltip: 'Fragtbreve kan kun oprettes for IKEA-forsendelser',
    createDeliveryNotes: 'Opret følgesedler',
    createDeliveryNotesTooltip: 'Følgesedler kan kun oprettes for IKEA-forsendelser',
    viewGroupDisabledTooltip: 'Ordren skal tildeles, før du kan se og redigere dens gruppe'
  },
  dispatchModal: {
    title: 'Afhentninger og leveringer på rute {{name}}',
    overridePalletRule: {
      question: 'Tilsidesæt palleregel?',
      description:
        'Forsendelsen indeholder paller, men køretøjet på denne rute er ikke markeret som i stand til at transportere paller. Vil du alligevel lægge den på ruten?',
      confirm: 'Læg på ruten alligevel'
    },
    palletRule: 'Palleregel',
    ignorePalletRule: 'Tillad paller på køretøjer, der ikke kan transportere paller',
    partialForcedOrder: 'Valgt rækkefølge',
    partialForcedOrderLabel: 'Definer rækkefølge for områder/ordrer',
    partialForcedOrderInfo:
      'Du har valgt at angive rækkefølgen for udvalgte stop/områder. Øvrige stop optimeres omkring disse.',
    flex: 'Flex',
    force: 'Force',
    optimizingEngine: 'Optimeringsmotor',
    invalidRouteOrder: 'Leveringer kan ikke være før afhentninger. Ændre ruterækkefølgen',
    submitDisabled: 'Omlæg rute for at aktivere knappen',
    replanDisabled: 'Ruterækkefølgen skal være gyldig for at omlægge',
    replan: 'Omlæg rute',
    noShipments: 'Ingen forsendelser på ruten',
    openRowMenu: 'Åbn rækkemenu',
    openPlannedStopMenu: 'Åbn menu for planlagt stop',
    newPositionForStop: 'Vælg ny position for stop',
    noShipmentsDescription:
      'Du har fjernet alle forsendelser fra ruten, tryk på <i>Bekræft rute</i> for at gemme ændringer',
    unassignBreakFromRoute: 'Klik for at fjerne pause fra ruten',
    editBreakOnRoute: 'Klik for at redigere pause på ruten',
    routeEnd: 'Ruteslut',
    routeStart: 'Rutestart',
    earliestStartOfBreak: 'Tidligste start på pause',
    latestStartOfBreak: 'Seneste start på pause',
    overrideOptimizingEngine: 'Tilsidesæt standard optimeringsmotor',
    warning: 'Du har valgt ikke at bruge en optimeringsmotor til denne rute. Dette vil påvirke modtagerens oplevelse.',
    flexDisabled: 'Det er ikke tilladt at <strong>flexe</strong> individuelle forsendelser i en gruppe',
    forceDisabled: 'Det er ikke tilladt at <strong>force</strong> individuelle forsendelser i en gruppe',
    removeDisabled: 'Det er ikke tilladt at <strong>fjerne</strong> individuelle forsendelser i en gruppe',
    orderDisabled: 'Det er ikke tilladt at <strong>ændre rækkefølgen</strong> af individuelle forsendelser i en gruppe',
    plannedStopRowDisabled:
      'Du har ikke tilladelse til at <strong>ændre rækkefølgen</strong> af et planlagt stop, mens du redigerer',
    showStops: 'Vis stop',
    viewStopsOnSameAddress: 'Vis stop på samme adresse grupperet sammen',
    addPlannedStopLocations: 'Tilføj planlagte stopplaceringer',
    selectPlannedStopLocation: 'Vælg planlagt stopplacering',
    plannedStop: 'Planlagt stop',
    visitEarliest: 'Tidligste besøg',
    visitLatest: 'Seneste besøg',
    serviceTime: 'Varighed',
    addPlannedStop: 'Tilføj stop og omplanlæg',
    updatePlannedStop: 'Opdater stop og omplanlæg',
    editPlannedStopOnRoute: 'Rediger planlagt stop på rute',
    unassignPlannedStopFromRoute: 'Fjern planlagt stop fra rute',
    settings: 'Indstillinger',
    multipleRecipients: 'Flere modtagere ({{number}})',
    multiplePickups: 'Flere afhentninger ({{number}})',
    mustProvideStopLocation: 'Du skal angive et stoppsted',
    editingLockBanner: 'Ruten redigeres af {{name}} siden {{time}}.',
    editingLockBannerBody: 'Du skal overtage ruteplanlægningen for at omplanlægge ruten.',
    takeOver: 'Overtag',
    routeChangedByOtherUser: '{{name}} er færdig med at redigere. Genindlæs for at fortsætte.',
    reloadRoute: 'Genindlæs rute',
    noShipmentsRouteUpdated: 'Genindlæs ruten for at se forsendelser',
    duplicateTabBanner: 'Denne rute er åben i en anden fane (siden kl. {{time}}).',
    duplicateTabBannerBody: 'Overtag her for at redigere i denne fane.'
  },
  vehicle: {
    weightCapacity: 'Vægtkapacitet',
    volumeCapacity: 'Volumenkapacitet',
    maxRangeKm: 'Rækkevidde',
    createNewVehicle: 'Opret nyt køretøj',
    vehiclesInDepartment: 'Køretøjer i {{departmentName}}',
    listAllVehicle: 'Vis alle køretøjer i denne afdeling',
    deleteSuccessMessage: 'Køretøjet blev slettet',
    createdSuccessMessage: 'Køretøjet blev oprettet',
    updatedSuccessMessage: 'Køretøjet blev opdateret',
    deleteVehicle: 'Slet køretøj',
    notRecover: 'Denne handling kan ikke fortrydes',
    createVehicle: 'Opret køretøj',
    editVehicle: 'Rediger {{name}}',
    vehicleInformation: 'Køretøjsinformation',
    selectFuelType: 'Vælg brændstoftype',
    selectEuroClass: 'Vælg Euro-klasse',
    settings: 'Indstillinger',
    activeDriver: 'Aktiv chauffør',
    noVehicleControl: 'Ingen køretøjskontrol',
    slower: 'Langsommere',
    slow: 'Langsom',
    normal: 'Normal',
    faster: 'Hurtigere',
    speedFactorVehicle: 'Køretøjets hastighedsfaktor',
    driverSpeed: 'Chaufførhastighed',
    serviceSpeed: 'Servicehastighed',
    defaultStartLocation: 'Standard startplacering er afdelingens adresse',
    specifyEndLocation: 'Angiv slutplacering',
    earliest: 'Tidligst',
    latest: 'Senest'
  },
  lmEvents: {
    heading: 'LM-hændelser',
    event: 'Hændelse',
    lmEventReasonAction: 'LM hændelse-årsag-handling',
    eventTime: 'Hændelsestidspunkt',
    eventSentAt: 'Hændelse sendt',
    lmPayload: 'LM-payload',
    view: 'Vis',
    enterShipmentId: 'Du skal angive et forsendelses-ID',
    searchForShipmentId: 'Søg efter forsendelses-ID'
  },
  cms: {
    scheduleBanner: 'Planlæg banner',
    cms: 'CMS',
    publicationDate: 'Udgivelsesdato',
    lastEdited: 'Sidst redigeret',
    dateForUnpublish: 'Dato for afpublicering',
    createNewBanner: 'Opret ny banner',
    createNewWhatsThisModal: 'Opret nyt "Hvad er dette"-vindue',
    publish: 'Udgiv',
    schedule: 'Planlæg',
    unpublish: 'Afpublicer',
    savePublish: 'Gem og udgiv',
    saveAsDraft: 'Gem som kladde',
    saveAsDraftUnpublish: 'Gem som kladde og afpublicer',
    noBannersFound: 'Ingen bannere fundet',
    noModalsFound: 'Ingen vinduer fundet',
    DRAFT: 'Kladde',
    PUBLISHED: 'Udgivet',
    SCHEDULED: 'Planlagt',
    content: 'Indhold',
    nameOfBanner: 'Bannerens navn',
    placementOfBanner: 'Bannerens placering',
    placementOfBannerDescription:
      'Indsæt Glow-URL\'en, hvor du vil tilføje en banner. Hvis du vil udgive en banner for alle afdelinger eller specifikke, kan du enten trykke på knappen "Tilføj URL" eller ændre linket selv.',
    urlToPageInGlow: 'URL til side i Glow',
    addUrl: 'Tilføj URL',
    typeOfBanner: 'Type banner',
    typeOfBannerDescription: 'Vælg mellem Advarsel(orange), Neutral (grå) eller Fejl (rød).',
    bannerNeutral: 'Neutral (grå)',
    bannerWarning: 'Advarsel (orange)',
    bannerError: 'Fejl (rød)',
    links: 'Links',
    linksDescription:
      'Artikellinket placeres direkte efter brødteksten. Hvis du tilføjer et "Gå tilbage til gammel side"-link, placeres det før brødteksten.',
    goBackToOldPageLink: 'Link til at gå tilbage til gammel side',
    messageInBanner: 'Besked i banner',
    messageInBannerDescription:
      'Engelsk er obligatorisk. Hvis ingen andre sprog vælges, bruges engelsk som reserve på alle sider.',
    addAdditionalLanguages: 'Tilføj flere sprog',
    bannerText: 'Tekst',
    nameOfLink: 'Linkets navn',
    englishText: 'Engelsk tekst',
    englishLinkText: 'Engelsk: linkets navn',
    selectLanguage: 'Vælg sprog',
    addNewLanguage: 'Tilføj nyt sprog',
    deleteBanner: 'Slet {{name}}',
    bannerWasSaved: '{{name}} blev gemt',
    bannerWasPublished: '{{name}} blev udgivet',
    bannerWasScheduled: '{{name}} blev planlagt',
    articleLink: 'Artikellink',
    goBackToOldPage: 'Gå tilbage til gammel side',
    previousPageNote: 'Bemærk: brug jokertegnene *department-id* og *date* i dette felt',
    selectTime: 'Vælg tid',
    setStartDate: 'Angiv startdato for banner',
    setEndDate: 'Angiv slutdato for banner',
    endTimeIsBeforeStartTime: 'Sluttidspunktet kan ikke være før starttidspunktet',
    endDateIsBeforeStartDate: 'Slutdato kan ikke være før startdato',
    oneBannerPerPageError: 'Kun én banner pr. side er tilladt. URL overlapper med eksisterende banner: {{banners}}',
    mustProvideUrl: 'Du skal angive en URL',
    mustProvideNameOfBanner: 'Du skal angive et navn på banner',
    mustProvideNameOfModal: 'Du skal angive et navn på vinduet',
    mustProvideEnglishText: 'Du skal angive engelsk tekst',
    mustProvideArticleLink: 'Du skal angive et artikellink',
    mustProvideNameOfArticleLink: 'Du skal angiveet navn på artikellinket',
    mustProvideDate: 'Du skal angive en dato',
    invalidArticleLink: 'Du skal angive et gyldigtartikellink, f.eks. https://example.com',
    errorDuplicateBanner: 'Bannernavnet skal være unikt. En banner med dette navn findes allerede.',
    draftScheduleTooltip: 'Fjernplanlægning for at gemme som kladde',
    banner: 'Banner',
    listOfBanners: 'Liste over bannere',
    whatsThisModal: '"Hvad er dette"-vindue',
    whatsThis: 'Hvad er dette',
    listOfWhatsThisModals: 'Liste over "Hvad er dette"-vinduer',
    nameOfWhatsThisModal: 'Navn på "Hvad er dette"-vindue',
    descriptionWhatsThisModal:
      'Navnet skal være unikt. Et tip er at navngive "Hvad er dette"-vinduet efter placering, f.eks. "Admin Pre-advice" eller "Planner Live".',
    nameOfModal: 'Vinduesnavn',
    pageLinkOfModal: 'Side hvorvinduet skal vises',
    pageLinkOfModalDescription:
      "Indsæt Glow-URL'en, hvor du vil tilføje vinduet. Husk at ændre afdelings-ID til * for at vinduet skal udgives på alleafdelinger.",
    linkToPageGlow: 'Link til side i Glow',
    modalPreviewEmptyTitle: 'Ingen information endnu',
    modalPreviewEmptyDescription: 'Du skal tilføje information for at få en forhåndsvisning af vinduet',
    addTextForModal: 'Tilføj tekst til vindue',
    addTextForModalDescription:
      'Engelsk er obligatorisk og vil blive brugt som reserve på alle vinduer, hvis du ikke skriver information på de andre sprog. Klik på "Hvad er dette"-linket for tips til, hvordan du udformer linket.',
    searchBannerPlaceholder: 'Søg efter banner',
    searchModalPlaceholder: 'Søg efter vindue',
    cmsNews: 'Nyhed',
    cmsNewsLabel: 'Nyheder',
    listOfCMSNews: 'Liste over nyheder',
    noCMSNewsFound: 'Ingen nyheder fundet',
    searchCMSNewsPlaceholder: 'Søg efter nyhed',
    cMSNewsSettingsTitle: 'Placering af nyhed',
    cMSNewsSettingsDescription: 'Din nyhed vises på forsiden og er synlig for alle brugere, når de logger ind på Glow.',
    nameOfCMSNews: 'Nyhedens navn',
    descriptionOfCMSNewsName: 'Giv din opdatering et navn, så du nemt kan finde den. Navnet skal være unikt.',
    typeOfCMSNews: 'Type nyhed',
    typeOfCMSNewsDescription: 'Vælg mellem Servicestatus, Ny funktion eller Information.',
    selectTypeOfCMSNews: 'Vælgtype nyhed',
    newFeatureCMSNews: 'Ny funktion',
    serviceStatusCMSNews: 'Servicestatus',
    informationCMSNews: 'Information',
    NEW_FEATURE: 'Ny funktion',
    SERVICE_STATUS: 'Servicestatus',
    INFORMATION: 'Information',
    scheduleCMSNews: 'Planlæg nyhed',
    scheduleCMSNewsDescription: 'Når du planlægger en nyhed, kan du ikke gemme den som kladde.',
    setStartDateForCMSNews: 'Angiv startdato for nyhed',
    setEndDateForCMSNews: 'Angiv slutdato for nyhed',
    cMSNewsPreviewEmptyTitle: 'Ingen information endnu',
    cMSNewsPreviewEmptyDescription: 'Du skal tilføje information for at få en forhåndsvisning af nyheden',
    addTextForCMSNews: 'Tilføj tekst til nyhed',
    addTextForCMSNewsDescription:
      'Engelsk er obligatorisk og vil blive brugt som reserve på alle nyheder, hvis du ikke skriver information på de andre sprog. Klik på "Hvader dette"-linket for tips til, hvordan du udformer nyheden.',
    mustProvideNameOfCMSNews: 'Du skal angive et navn på nyheden',
    createNewCMSNews: 'Opret ny nyhed',
    continueToYourPage: 'Fortsæt til din side',
    clearSelection: 'Ryd valg'
  },
  invoicingStatus: {
    TO_BE_INVOICED: 'Ikke faktureret',
    INVOICING_FAILED: 'Fakturering mislykkedes',
    CORRECTION_PENDING: 'Rettelse afventer',
    INVOICING_PAUSED: 'Fakturering sat på pause',
    EXCLUDED_FROM_INVOICING: 'Udelukket',
    NOT_READY_FOR_INVOICING: 'Ikke klar',
    INVOICED_OK: 'Faktureret OK',
    ZERO_PRICE: 'Ufuldstændig pris',
    AWAITING_ACKNOWLEDGEMENT: 'Afventer bekræftelse',
    disallowedStatusLegend:
      'Ordrer med status "Faktureret OK" og "Avventer bekræftelse" kan ikke indstilles til "Ikke faktureret" eller "Udelukket".'
  },
  invoice: {
    articleCode: 'Artikel',
    allOrdersInvoice: 'Alle ordrer faktureres',
    allOrdersInvoiceDescription: 'Vi kunne ikke finde nogen ufakturerede ordrer.',
    handledBy: 'Håndteres af',
    invoicing: 'Fakturering',
    credit: 'Kredit',
    invoiceVerb: 'Fakturere',
    searchShipmentIdOrCustomerRef: 'Søg efter forsendelses-ID eller kundereference',
    state: '{{count}} status',
    state_other: '{{count}} statusser',
    invoiceOrderAction: 'Faktura ordre',
    invoiceOrderAction_other: 'Fakturér ordrer',
    quantity: 'Antal',
    perUnitCustomer: 'Kundepris pr enhed',
    carrierPerUnitPrice: 'Transportørpris pr enhed',
    enableCalculator: 'Aktiver enhedspris til totalpris multiplikator',
    mustBeNegative: 'Skal være < 0',
    mustBePositive: 'Skal være > 0',
    description: 'Beskrivelse',
    customerAmount: 'Kundebeløb',
    carrierAmount: 'Enhedsbeløb',
    failedPriceListLink: 'Prisliste som fejlet i Prismotor',
    failedPriceList: 'Mislykket prisliste',
    priceFailureDetail: 'Fejldetaljer',
    priceFailureReason: 'Fejlårsag',
    priceFailureReasons: {
      missingAttributeValue: 'Attribut mangler',
      matrixLookupMiss: 'Matrisefejl',
      invalidExpression: 'Ugyldigt udtryk',
      scriptError: 'Skriptfejl'
    },
    invoiceFailureDetail: 'Fakturafejl detaljer',
    invoiceDepartment: 'Faktura afdeling',
    invoiceDepartment_other: 'Faktura afdelinger',
    invoiceDepartments: 'Fakturaafdeling(er)',
    dashboard: 'Dashboard',
    invoicingJobsSummary: 'Fakturering joboversigt',
    invoicingStatus: 'Faktureringsstatus',
    invoicingStatusDescription: 'Viser ordrer fra de sidste {{months}} måneder.',
    ordersOnPage: '{{count}} ordrer på siden',
    ordersFoundCount: '{{count}} ordre fundet',
    ordersFoundCount_other: '{{count}} ordrer fundet',
    ordersNotInvoiced: 'Ordrer, der ikke er faktureret endnu',
    invoicingFailedDescription: 'Ordrer kunne ikke behandles',
    text: 'Fakturatekst',
    correctionPendingDescription: 'Ordrer med afventende rettelser',
    ordersPausedFromInvoiced: 'Ordrer, der er sat på pause fra at blive faktureret',
    invoicingZeroPriceDescription: 'Ordrer med ikke-godkendte nul-linjer',
    sendInvoices: 'Send fakturaer',
    sendInvoicesDescription:
      'Du er ved at fakturere {{departments}}. Vælg venligst dato eller datointerval for faktureringsperioden.',
    sendInvoiceDateValidationErrorOneMonth: 'Maksimal datospænding er 1 måned',
    invoicingInProgress: 'Fakturering for {{departmentName}} er i gang, {{count}} faktureringsjob er tilbage',
    invoicingInFinished: 'Fakturering for {{departmentName}} er afsluttet',
    orderEnqueuedForInvoicing: 'Ordren er sat i kø til fakturering.',
    orderEnqueuedForInvoicing_other: 'Ordrer er sat i kø til fakturering.',
    orderSuccessNotInvoiced: 'Ordren blev ændret til ikke faktureret',
    orderSuccessNotInvoiced_other: 'Ordrer blev ændret til ikke faktureret',
    orderSuccessInvoicedOk: 'Ordren blev markeret som faktureret OK',
    orderSuccessInvoicedOk_other: 'Ordrer blev markeret som faktureret OK',
    orderSuccessExcluded: 'Ordren blev udelukket fra fakturering',
    orderSuccessExcluded_other: 'Ordrer blev udelukket fra fakturering',
    howManyInvoices: 'Hvor mange fakturaer vil blive sendt',
    fetchAmount: 'Hent beløb',
    wantToResend: 'Denne ordre er allerede blevet faktureret. Er du sikker på, at du vil sende den igen?',
    adHocInvoiceOrder: 'Du er ved at fakturere denne ordre. Vil du fortsætte?',
    adHocInvoiceOrder_other: 'Du er ved at fakturere disse ordrer. Vil du fortsætte?',
    pauseOrders: 'Sæt ordrer på pause',
    datePeriod: 'Dato periode',
    ordersWereSuccessfullyPaused: '{{count}} ordre blev sat på pause fra fakturering',
    ordersWereSuccessfullyPaused_other: '{{count}} ordrer blev sat på pause fra fakturering',
    releaseOrders: 'Frigiv ordrer',
    recalculatePrices: 'Genberegn priser',
    ordersSentForPriceRecalculation: '{{count}} order er blevet sat i kø til genberegning',
    ordersSentForPriceRecalculation_other: '{{count}} ordrer er blevet sat i kø til genberegning',
    ordersWereSuccessfullyReleased: '{{count}} ordre blev sat i kø til genberegning',
    ordersWereSuccessfullyReleased_other: '{{count}} ordrer blev frigivet til fakturering',
    addUnit: 'Tilføj enhed',
    overrideUnit: 'Tilsidesæt enhed',
    addUnitDescription: 'Tilføj en enhed til dine valgte ordrer. Denne enhed er den, der vil blive selvfaktureret.',
    addUnitToOrders: 'Tilføj enhed til ordrer',
    addUnitToOrder: '{{unit}} blev tilføjet til {{count}} ordre',
    addUnitToOrder_other: '{{unit}} blev tilføjet til {{count}} ordrer',
    addUnitBulkDisabled: 'Enhed kan kun tilføjes til ordrer uden enhed',
    approveIncompletePrices: 'Godkjend med mangelful pris',
    manualOverrideTitle: 'Manuel tilsidesættelse af faktureringsstatus',
    selectStatus: 'Vælg ny faktureringsstatus',
    status: 'Den nuværende status er',
    status_other: 'De nuværende statusser er',
    manualOverrideLegend:
      'Du er ved at overskrive faktureringsstatus for én valgt ordre. Den nuværende status er: {{statuses}}.',
    manualOverrideLegend_other:
      'Du er ved at overskrive faktureringsstatussen for {{count}} valgte ordrer. $t(invoice.status, {"count": {{statusCount}} }): {{statuses}}.',
    manualOverrideLegend2: 'Vælg venligst den ønskede faktureringsstatus for denne ordre nedenfor.',
    manualOverrideLegend2_other: 'Vælg venligst den ønskede faktureringsstatus for disse ordrer nedenfor.',
    unitId: 'Enheds-id',
    bannerOldInvoicePage:
      'Den 26. august vil <0>den nye faktureringsside</0> åbne som standard. Vi opfordrer dig til at begynde at bruge den nye side. Mere info om den nye side <1>her</1>.',
    acceptIncompletePricesTitle: 'Godkend ufuldstændige priser',
    acceptIncompletePricesModalQuestion:
      'Du er ved at godkende {{count}} ordre med ufuldstændige priser. Er du sikker på, at du vil fortsætte?',
    acceptIncompletePricesModalQuestion_other:
      'Du er ved at godkende {{count}} ordrer med ufuldstændige priser. Er du sikker på, at du vil fortsætte?',
    confirmCancelDialog: {
      title: 'Du har ikke-gemte ændringer',
      question: 'Du har ikke-gemte ændringer. Ønsker du at fortsætte?',
      abort: 'Bliv på siden',
      confirm: 'Fortsæt uden at gemme'
    },
    download: 'Download faktura',
    downloadVendor: 'Leverandørfaktura',
    downloadInvoiceTooltip: 'Faktura kan kun vises, når den er udstedt af eksternt system',
    multilegFilter: {
      label: 'Filtrer delvist multileg',
      ALL: 'Vis alle',
      ONLY_PARTIALLY_READY_MULTILEG: 'Vis kun delvist klar',
      EXCLUDE_PARTIALLY_READY_MULTILEG: 'Ekskluder delvist klar'
    },
    invoicingAwaitingAcknowledgementDescription:
      'Fakturerede ordrer, der afventer registreringsbekræftelse fra eksternt system',
    invoicedOn: 'Senest sendt',
    filterStates: 'Filtrer statuser',
    filterDeliveryDate: 'Leveringsdato',
    clearFilters: 'Ryd filtre'
  },
  live: {
    onlyDeviated: 'Vis kun afvigede ruter',
    bannerOldLivePage:
      '<0>Prøv</0> den nye Live-side med forbedrede funktionaliteter og nyt design. Vi opfordrer dig til at bruge den nye live-side, så du kan vænne dig til den, før vi fjerner siden fuldstændigt.',
    shipment: 'Forsendelse',
    shipmentFrom: 'Fra',
    shipmentTo: 'Til',
    confirm: 'Bekræfte',
    unconfirm: 'Fortryd',
    confirmedBy: 'Bekræftet af {{name}} kl. {{time}}',
    theCourier: 'Budet',
    activeRoutes: 'Aktive ruter',
    routeDeviation: 'Ruteafvigelse',
    routeDeviations: 'Ruteafvigelser',
    multipleDeviations: 'Flere afvigelser',
    recentDeviations: 'Seneste afvigelser',
    noRoutesFound: 'Ingen ruter fundet',
    noDeviationsFound: 'Ingen afvigelser fundet',
    consignmentDamage: 'Forsendelsesskader',
    shipmentDeviation: 'Forsendelsesafvigelse',
    outsideServiceTime: 'Udenfor servicetid',
    outsideEstimatedTime: 'Udenfor estimeret tid',
    deliveryLocationDeviation: 'Uventet placering',
    eventTextDeviationOne: '{{name}} har en forsendelsesafvigelse.',
    eventTextDeviationMany: '{{name}} har {{count}} forsendelsesafvigelser.',
    eventTextDamageOne: '{{name}} har skader på {{count}} forsendelser.',
    eventTextDamageMany: '{{name}} har skader på en forsendelse.',
    eventTextServiceTimeWindow: '{{name}} leveret uden for servicetidsvinduet.',
    eventTextEstimatedTimeWindow: '{{name}} leveret uden for det estimerede tidsvindue.',
    eventTextDeviated: '{{name}} har afveget fra deres rute.',
    eventHelpDeviation: '{{name}} har en afvigelse på forsendelsesnummer {{shipmentId}}.',
    eventHelpDamage: '{{name}} har en skade på forsendelsesnummeret {{shipmentId}}.',
    eventHelpDriverDeviated: '{{name}} har leveret forsendelsesnummer {{shipmentId}} i den forkerte rækkefølge.',
    eventHelpDriverDeviatedAtPickup:
      '{{name}} har afhentet forsendelsesnummer {{shipmentId}} i den forkerte rækkefølge.',
    eventHelpDriverDeviatedAtPickupBefore:
      '{{name}} har afhentet forsendelsesnummer {{shipmentId}} i den forkerte rækkefølge ved at afhente #{{actual}} før afhentning #{{expected}}.',
    eventHelpDriverDeviatedAtPickupAfter:
      '{{name}} har afhentet forsendelsesnummer {{shipmentId}} i den forkerte rækkefølge ved at afhente #{{actual}} efter afhentning #{{expected}}.',
    filterOngoing: 'Igangværende',
    filterNotStarted: 'Ikke startet',
    filterFinished: 'Færdig',
    filterOnlyDeviated: 'Viser kun ruter med afvig',
    filterShipmentDeviations: 'Forsendelsesafvigelser',
    filterShipmentDamage: 'Forsendelsesskade',
    filterEstimatedTime: 'Estimeret tid',
    filterServiceTime: 'Servicetid',
    filterRouteDeviations: 'Ruteafvigelser',
    filterDeliveryLocationDeviation: 'Uventet placering',
    filterConfirmed: 'Bekræftet',
    routeProgress: 'Fuldført {{complete}} af {{total}}',
    routeDuration: 'Fra {{from}} til {{to}}',
    routeDelayed: 'Forsinket',
    routeAhead: 'Foran',
    routeOnTime: 'En gang',
    routeUnknown: 'Ukendt',
    routeDeviationsNone: 'Ingen afvigelser',
    routeDeviationCount: '{{unhandledDeviations}} af {{totalDeviations}}',
    routeHasHandleDeviations: 'Rute har {{count}} håndteret afvigelse',
    routeHasHandleDeviations_other: 'Rute har {{count}} håndteret afvigelser',
    openRoute: 'Se rute',
    openShipment: 'Se forsendelse',
    viewRoute: 'Se rute',
    deviated: 'Afviget',
    offRoute: 'Følger ikke ruten',
    onRoute: 'På rute',
    allRoutesStates: 'Alle rutestatusser',
    selectedRouteStates: '{{count}} rutestatus',
    selectedRouteStates_other: '{{count}} rutestatusser',
    noSelectedStates: 'Ingen status valgt',
    allDeviationTypes: 'Alle afvigelsestyper',
    selectedDeviationTypes: '{{count}} afvigelsestype',
    selectedDeviationTypes_other: '{{count}} afvigelsestyper',
    showHandledDeviations: 'Vis håndterede afvigelser ({{count}})',
    noSelectedTypes: 'Ingen valgte typer',
    viewShipment: 'Se forsendelse',
    selectAllRouteStates: 'Vælg alle rutetilstande',
    noRoutesWithDeviations: 'Ingen tilgængelige ruter',
    selectAllDeviationTypes: 'Vælg alle afvigelsestyper',
    noDeviationOnRoute: 'Ingen afvigelser på rute',
    noDeviationAvailable: 'Ingen tilgængelige afvigelser',
    noDeviationsOnFilter: 'Der er ingen tilgængelige afvigelser for det valgte filter. Prøv et andet filter',
    noRoutesOnFilter: 'Der er ingen tilgængelige ruter for det valgte filter. Prøv et andet filter',
    eventHelpServiceTimeWindow:
      '{{name}} har leveret forsendelsesnummer {{shipmentId}} kl. {{actual}}, hvilket er uden for servicetidsvinduet {{earliest}}-{{latest}}.',
    eventHelpDeliveryLocationDeviation: {
      withShipmentId:
        '{{name}} har leveret eller afveget forsendelsesnummer {{shipmentId}} <4>her</4>, {{distance}} meter væk fra den <9>forventede placering</9>.',
      withoutShipmentId:
        '{{name}} har leveret eller afveget <4>her</4>, {{distance}} meter væk fra den <9>forventede placering</9>.'
    },
    eventHelpDriverDeviatedBefore:
      '{{name}} har leveret forsendelsesnummer {{shipmentId}} i den forkerte rækkefølge ved at levere #{{actual}} før levering #{{expected}}.',
    eventHelpDriverDeviatedAfter:
      '{{name}} har leveret forsendelsesnummer {{shipmentId}} i den forkerte rækkefølge ved at levere #{{actual}} efter levering #{{expected}}.',
    search: 'Søg efter rute, enhed eller bude',
    unhandled: 'ubehandlede',
    deviations: 'afvigelser',
    mostDeviations: 'Flest afvigelser',
    latestInTime: 'Senest i tiden',
    earliestInTime: 'Tidligst i tiden',
    sortOn: 'Sorter efter',
    late: 'Forsinket',
    early: 'tidligt',
    stops: 'Stop: {{stops}}',
    deviatedFromRoute: 'Afveget fra ruten',
    totalTimeMajorDeviations: 'Samlet tid for større afvigelser (≥5 min)',
    totalTimeMinorDeviations: 'Samlet tid for mindre afvigelser (<5 min)',
    lateOrEarlyFirstStop: 'For sent eller for tidligt til første levering',
    showAdjusted: 'Vis justeret tid',
    showAdjustedTooltip: 'Justeret tid vises på modtagerens sporingsside',
    showDiff: 'Vis stopforskel',
    diff: 'Stopforskel',
    showDiffTooltip: 'Forskel mellem planlagt (ETD) og faktisk tid mellem stop',
    modalTableSummary: 'Samlet rutetid',
    liveModalActualTooltip1: 'Sammenlignet med ETD:',
    liveModalActualTooltip2: 'Grøn: Op til 15 min',
    liveModalActualTooltip3: 'Orange: 15–30 min',
    liveModalActualTooltip4: 'Rød: Mere end 30 min',
    eventTextDeliveryLocationDeviation: '{{name}} leverede/afveg {{distance}} meter fra den forventede placering.',
    eventHelpEstimatedTimeWindow:
      ';{{name}} har leveret forsendelse nummer {{shipmentId}} kl. {{actual}} hvilket er uden for det estimerede tidsvindue {{earliest}}–{{latest}}.;',
    routeStateFilter: 'Rutetilstand',
    departmentFilter: 'Afdelingsfilter',
    allDepartments: 'Alle afdelinger',
    deviationTypeFilter: 'Afvigelsestypefilter',
    showSummary: 'Vis oversigt'
  },
  userRolesAdmin: {
    price: 'Pris',
    searchPlaceholder: 'Søg efter brugerrolle',
    userRoles: 'Brugerroller',
    successCreateMessage: '{{name}} blev oprettet',
    successUpdateMessage: '{{name}} blev opdateret',
    saveRole: 'Gem rolle',
    editRole: 'Rediger {{name}}',
    createNewRole: 'Opret ny rolle',
    nameOfRole: 'Rollenavn',
    nameRequired: 'Navn er påkrævet',
    descriptionRequired: 'Beskrivelse er påkrævet',
    descriptionLabel: 'Beskrivelse (max 240 tegn)',
    iconLabel: 'Vælg hvilket ikon du ønsker for brugerrollen',
    selectRoleTitle: 'Vælg adgangsrettigheder for rolle',
    emptyState: 'Ingen roller fundet for søgefrasen',
    deleteConfirm: 'Er du sikker på at du vil slette {{name}}?',
    deleteSuccess: 'Rolle {{name}} blev slettet',
    settings: 'Indstillinger',
    accessRights: 'Adgangsrettigheder',
    settingsTitle: 'Indstillinger for rolle',
    settingsDescription: 'Engelsk er påkrævet. Hvis intet andet sprog vælges, vil engelsk være fallback.',
    additionalLanguagesTitle: 'Tilføj yderligere sprog',
    customerPortalAccess: 'Kundeportal adgang',
    defaultForUserRole: 'Brug som standardrolle (valgfrit)',
    event: 'Begivenhed',
    financialAccess: 'Finansielle rettigheder',
    invoiceActions: 'Faktura handlinger',
    orderAttributes: 'Ordreattributter',
    findApiOrder: 'Find API-bestilling',
    optimus: 'Optimus',
    noAccess: 'Ingen adgang',
    noAccessToApiOrder: 'Ingen adgang til Find API-bestilling',
    noAccessToOptimus: 'Ingen adgang til Optimus',
    optimusViewDescription: 'Brugeren kan se tjenester på afdelinger og kunder, men kan ikke foretage ændringer',
    optimusFullDescription: 'Brugeren kan tilføje og redigere tjenester for afdelinger og kunder',
    ordersApiSearchRestrictedDescription:
      'Brugeren kan søge efter ordrer fra de afdelinger eller kunder, de har adgang til',
    ordersApiSearchFullDescription: 'Brugeren kan søge efter ordrer fra alle afdelinger og kunder',
    addRole: 'Tilføj rolle',
    addedRole: 'Rolle tilføjet',
    removeRole: 'Fjern rolle',
    importExport: 'Import / Eksport',
    importExportExtendedDescription: 'Inkluderer adgang til udvidet rapport for kurer.',
    importExportExtendedSaaSDescription: 'Inkluderer adgang til slutrapport for dagen.',
    billingOrdersReadOnlyDescription: 'Begrænset læseadgang til {{billingOrderTypes}}',
    billingOrdersDescription: 'Fuld adgang til {{billingOrderTypes}}'
  },
  webhook: {
    messages: {
      title: 'Webhook-beskeder',
      resendConfirmation: 'Webhook-beskeden blev sendt igen'
    },
    resend: 'Send igen',
    requestedAfter: 'Anmodet efter',
    messageDetails: {
      title: 'Webhook-besked',
      generalHeading: 'Generelle oplysninger',
      requestHeading: 'Anmodningsoplysninger',
      loading: 'Henter webhook-besked...',
      copyTooltip: 'Kopiér payload',
      copied: 'Payload er kopieret'
    },
    messageId: 'Besked-ID',
    messageCreatedAt: 'Besked oprettet',
    eventType: 'Hændelsestype',
    packageId: 'Pakke-ID',
    shipmentId: 'Forsendelses-ID',
    subscriptionUrl: 'Abonnements-URL',
    subscriptionId: 'Abonnements-ID',
    request: {
      at: 'Anmodning kl.',
      after: 'Anmodning kl.',
      retry: 'Nyt forsøg af besked'
    },
    response: {
      heading: 'Svaroplysninger',
      at: 'Svar kl.',
      status: 'Svarstatus'
    },
    responseCategories: {
      Informational: 'Information (100-199)',
      Successful: 'Gennemført (200-299)',
      Redirect: 'Omdirigering (300-399)',
      ClientError: 'Klientfejl (400-499)',
      ServerError: 'Serverfejl (500-599)',
      UnknownError: 'Ukendt fejl',
      Pending: 'Afventer'
    }
  },
  validationError: {
    provideEmail: 'Du skal angive en e-mail',
    provideValidEmail: 'Du skal angive en gyldig e-mail',
    youMustSelectCustomer: 'Du skal vælge en kunde'
  },
  roles: {
    ADMIN_OPTIMIZING: 'Optimering',
    ADMIN_LM_EVENTS: 'LM-hændelser',
    ADMIN_PH: 'ParcelHub',
    ADMIN_INTEGRATIONS: 'Integrationer',
    ADMIN_NUMBER_SERIES: 'Nummerserier',
    ADMIN_TEXTS: 'Tjenester',
    ADMIN_JOBS: 'Jobovervågning',
    ADMIN_PRE_ADVICE: 'Preavisering',
    ADMIN_SETTINGS: 'Indstillinger',
    ADMIN_SHD: 'SHD',
    ADMIN_CUSTOMER: 'Begrænset adgang',
    ADMIN_CUSTOMER_GROUP: 'Kundegrupper',
    ADMIN_HOLIDAYS: 'Helligdage',
    ADMIN_MATRIX: 'Matrix',
    ADMIN_USERS: 'Brugere',
    ADMIN_DEPARTMENT: 'Afdelinger',
    ADMIN_DEPARTMENT_GROUP: 'Afdelingsgrupper',
    ADMIN_CUSTOMER_ALL: 'Fuld adgang',
    ADMIN_VENDORS: 'Leverandører',
    ADMIN_PRICE_ARTICLE: 'Opret og vedligehold artikler',
    ADMIN_PRICE_ACCOUNTING: 'Skift indstillinger for regnskabssystem',
    ADMIN_PRODUCTION_TIME_WINDOW: 'Produktionstidsvindue',
    OPTIMUS_VIEW: 'Læseadgang til Optimus',
    OPTIMUS_EDIT: 'Fuld adgang til Optimus',
    ORDERS_API_SEARCH_RESTRICTED: 'Begrænset søgeadgang til Find API Order',
    ORDERS_API_SEARCH_FULL: 'Fuld søgeadgang til Find API Order',
    CUSTOMER_PORTAL: 'Kundeadgang til kundeportalen',
    CUSTOMER_PORTAL_ADMIN: 'Administratoradgang til kundeportalen',
    CUSTOMER_PORTAL_VIEW_PRICE: 'Kan se priser i kundeportalen',
    VIEW_PRICE: 'Kan se priser',
    VIEW_PRICE_EVENTS: 'Kan se prishændelser',
    FINANCIAL_VIEW_CUSTOMER_AND_UNIT_PRICE: 'Kan se priser på ruter',
    BOOK_SHIPMENT: 'Kan booke forsendelser',
    PLANNER_ADDRESSES: 'Adresser',
    PLANNER_BILLING_ORDERS: 'Faktureringsordrer',
    PLANNER_BILLING_ORDERS_READ: 'Faktureringsordrer (kun læsning)',
    PLANNER_BOOKING: 'Booking',
    PLANNER_CORRECTIONS: 'Rettelser',
    PLANNER_COURIERS: 'Bude',
    PLANNER_DISPATCHING: 'Disponering',
    PLANNER_IMPORT_EXPORT: 'Begrænset adgang til rapporter',
    PLANNER_IMPORT_EXPORT_EXTENDED: 'Adgang til alle rapporter',
    PLANNER_INVOICING: 'Fakturering',
    PLANNER_LIVE: 'Live',
    PLANNER_MANAGE_RETURNS: 'Administrer returneringer',
    PLANNER_PICKUP_ORDERS: 'Afhentningsordrer',
    PLANNER_RECURRING_ORDERS: 'Tilbagevendende',
    PLANNER_ROUTE_PLANNING: 'Ruteplanlægning',
    PLANNER_SHIPMENTS: 'Forsendelser',
    PLANNER_UNITS: 'Enheder',
    PLANNER_UNITS_REMOVE: 'Fjern enheder fra afdeling',
    PLANNER_UNRESOLVED: 'Uløste',
    PLANNER_REPORTS: 'Rapporter',
    PLANNER_VEHICLES: 'Køretøjer',
    PLANNER_PRE_ADVICE: 'Preavisering',
    ADMIN_ALCOHOL_DELIVERY_EDUCATION: 'Kan registrere uddannelse i alkohollevering for bude',
    FINANCIAL_SHOW_INVOICING_PAYLOAD: 'Vis faktura-payload',
    FINANCIAL_DOWNLOAD_INVOICE: 'Download faktura',
    FINANCIAL_CREDIT_NOTE: 'Kreditnota',
    FINANCIAL_COPY_TO_BILLING_ORDER: 'Kopiér til faktureringsordre',
    FINANCIAL_VIEW_GROUP: 'Vis gruppe',
    FINANCIAL_VIEW_MULTILEG: 'Vis multileg',
    FINANCIAL_REINVOICE_INVOICED_ORDERS: 'Fakturér fakturerede ordrer igen',
    FINANCIAL_INVOICE_ACTIONS: 'Fakturahandlinger på forsendelser',
    PRICING_ENGINE: 'Prismotor',
    READ_ANY_SHIPMENT: 'Forsendelse'
  },
  manageReturns: {
    title: 'Administrer returneringer',
    typesOfReturns: 'Typer af returneringer',
    ordersOverAPeriod: 'Viser ordrer fra den sidste måned.',
    ordersOverAPeriod_other: 'Viser ordrer fra de sidste {{count}} måneder.',
    pickedUpByCustomer: 'Afhentet af kunde',
    pickedUpByCustomerDescription: 'Returneringer som skal afhentes af kunden',
    transferToDifferentTerminal: 'Overfør til anden terminal',
    transferToDifferentTerminalDescription: 'Returneringer som skal sendes til en anden terminal',
    environmentalReturns: 'Miljøreturneringer',
    environmentalReturnsDescription: 'Returneringer til genbrug, samlet i en container',
    returnForDelivery: 'Returnering til levering',
    returnForDeliveryDescription: 'Returneringer som skal dirigeres og leveres',
    MANUAL_RETURNS: 'Manuelle returneringer',
    manualReturnsDescription: 'Ordre hvor returforløbet endnu ikke er oprettet',
    returnToSenderTitle: 'Vil du returnere forsendelserne til afsenderen?',
    manuallyMarkAsHandled: 'Manuelt marker som håndteret',
    manuallyMarkAsHandledTooltip: 'Når en forsendelse markeres som håndteret, forsvinder den fra listen',
    ordersFoundCount: '{{count}} ordre fundet',
    ordersFoundCount_other: '{{count}} ordrer fundet',
    PICKED_UP_BY_CUSTOMER: 'Afhentet af kunde',
    TRANSFER_TO_DIFFERENT_TERMINAL: 'Overfør til anden terminal',
    ENVIRONMENTAL_RETURNS: 'Miljøreturneringer',
    RETURN_FOR_DELIVERY: 'Returnering til levering',
    ordersAlreadyHandled: 'Alle ordrer er håndteret',
    ordersAlreadyHandledDescription: 'Vi kunne ikke finde nogen ubehandlede ordrer.',
    manuallyMarkAsHandledModal: {
      title: 'Manuelt marker som håndteret',
      shipmentsCount: '{{count}} forsendelse',
      shipmentsCount_other: '{{count}} forsendelser',
      description:
        'Når forsendelsen(e) markeres som håndteret, vil de forsvinde fra listen. Du kan ikke fortryde denne handling. Forsendelsen(e) kan findes på søgesiden.',
      confirm: 'Marker som håndteret'
    },
    manuallyMarkAsHandledSuccess: '{{count}} forsendelse blev markeret som håndteret',
    manuallyMarkAsHandledSuccess_other: '{{count}} forsendelser blev markeret som håndteret',
    returnToSenderSuccess: '{{count}} forsendelse blev returneret til afsenderen',
    returnToSenderSuccess_other: '{{count}} forsendelser blev returneret til afsenderen',
    selectCustomer: 'Vælg kunde',
    customer: 'Kunde',
    customer_other: 'Kunder',
    allCustomers: 'Alle kunder',
    selectDestination: 'Vælg destination',
    destination: 'Endelig destination',
    destinationDIP: 'Destinations-DIP',
    returnShipmentColumns: 'Returneringsinformation',
    allDestinations: 'Alle destinationer',
    noDate: 'Alle',
    zeroDays: '0 dage',
    oneTo6Days: '1–6 dage',
    moreThan7Days: '> 7 dage',
    moreThan15Days: '> 15 dage',
    moreThan30Days: '> 30 dage',
    customerDate: 'Brugerdefineret',
    daysOnTerminal: 'Dage på terminal',
    months: 'Måneder',
    lastMonths: 'Sidste {{count}} måned',
    lastMonths_other: 'Sidste {{count}} måneder',
    printList: 'Udskriv liste',
    returnToSender: 'Returner til afsender',
    returnToSenderQueued: 'Returnering til afsenderen er sat i kø',
    returnToSenderConfirmation: 'Vil du returnere denne forsendelse til afsenderen?',
    returnToSenderFailed: 'Kunne ikke returnere forsendelsen til afsenderen',
    returnToSenderDisabledTooltip:
      'Du kan ikke returnere forsendelser, der er afveget, leveret eller allerede markeret til returnering',
    senderDIP: 'Afsendende DIP',
    createReturnLabel: 'Opret returlabel'
  },
  parcelHubAdmin: {
    title: 'ParcelHub',
    startTitle: 'Søg efter en forsendelse',
    startDescription: 'Indtast et forsendelsesnummer og klik på søg.',
    noResultsTitle: 'Ingen meddelelser fundet',
    loadFailedTitle: 'Kunne ikke hente meddelelser',
    loadFailedDescription: 'ParcelHub-consumeren svarede ikke. Prøv igen, eller tjek at tjenesten kører.',
    payloadLoadFailed: 'Kunne ikke hente payload for denne meddelelse.',
    shipment: 'Forsendelse',
    topic: 'Topic',
    partition: 'Partition',
    offset: 'Offset',
    operation: 'Operation',
    packageId: 'Kolli-ID',
    timestamp: 'Tidsstempel',
    payload: 'Payload',
    viewPayload: 'Vis payload',
    consignmentEvents: 'Forsendelseshændelse',
    consignmentItemEvents: 'Kollihændelse',
    eventCode: 'Hændelseskode',
    event: 'Hændelse',
    receivedAt: 'Modtaget',
    queuedAt: 'Sat i kø',
    processed: 'Behandlet',
    processedAt: 'Behandlet',
    processingLag: 'Behandlingstid',
    eventsNoResultsTitle: 'Ingen hændelser fundet',
    eventsLoadFailedTitle: 'Kunne ikke hente hændelser',
    eventsLoadFailedDescription: 'Hentning af hændelser mislykkedes. Prøv igen.',
    eventPayloadLoadFailed: 'Kunne ikke hente payload for denne hændelse.'
  },
  apolloAdmin: {
    title: 'Integrationer',
    emptyTitle: 'Ingen requests',
    emptyDescription: 'Vælg den dato du vil se og tryk på søg.',
    reqType: 'Request-type',
    routeId: 'Rute-ID',
    routeName: 'Rutenavn'
  },
  preAdviceFollowup: {
    title: 'Administrer forudanmeldelse',
    toBeHandled: 'Skal håndteres',
    failedOrders: 'Fejlede ordrer',
    failedOrdersDescription: 'Modtageren har ikke modtaget nogen anmeldelse',
    manualPreAdvice: 'Manuel forudanmeldelse',
    manualPreAdviceDescription: 'Ordrer med manuel udløser på admin-siden',
    preAdviceLocked: 'Forudanmeldelse låst',
    preAdviceLockedDescription: 'Ordrer som er låst og venter på handling',
    missingRules: 'Mangler regler',
    missingRulesDescription: 'Ordrer mangler en forudanmeldelsesregel.',
    inProgress: 'I gang',
    inProgressDescription: 'Ordrer med igangværende forudanmeldelse',
    notStarted: 'Ikke startet',
    notStartedDescription: 'Ordrer med en regel hvor forudanmeldelse ikke er startet',
    ordersFoundCount: '{{count}} ordre fundet',
    ordersFoundCount_other: '{{count}} ordrer fundet',
    FAILED_ORDERS: 'Fejlede ordrer',
    MANUAL_PRE_ADVICE: 'Manuel forudanmeldelse',
    PRE_ADVICE_LOCKED: 'Forudanmeldelse låst',
    MISSING_RULES: 'Mangler regler',
    IN_PROGRESS: 'I gang',
    NOT_STARTED: 'Ikke startet',
    ordersAlreadyHandled: 'Alle ordrer er håndteret',
    ordersAlreadyHandledDescription: 'Vi kunne ikke finde nogen uhåndterede ordrer.',
    updatePhoneNumber: 'Skift eller tilføj telefonnummer',
    updateEmailAddress: 'Skift eller tilføj e-mailadresse',
    removeShipmentFromPreAdvice: 'Fjern forsendelse fra forudanmeldelse',
    bookDateAndTime: 'Book dato og tid',
    manuallyPreAdvice: 'Manuel forudanmeldelse',
    unlockPreAdvice: 'Lås op for forudanmeldelse',
    lockPreAdvice: 'Lås forudanmeldelse',
    triggerPreAdvice: 'Udløs forudanmeldelse',
    selectedCustomers: '{{count}} kunde',
    selectedCustomers_other: '{{count}} kunder',
    allCustomers: 'Alle kunder',
    selectRowWithOrderId: 'Vælg række med ordre-id {{id}}',
    updateRecipientPhoneNumber: 'Opdater telefonnummer',
    phoneNumberUpdated: 'Telefonnummeret er opdateret for forsendelse-ID: {{shipmentId}}',
    phoneNumberUpdatedAndPreAdviceSent:
      'Telefonnummer opdateret og forudanmeldelse sendt for forsendelse-ID: {{shipmentId}}',
    samePhoneNumberAlreadySet: 'Samme telefonnummer er allerede sat på forsendelsen.',
    updateRecipientEmailAddress: 'Opdater e-mailadresse',
    emailAddressUpdated: 'E-mailadressen er opdateret for forsendelse-ID: {{shipmentId}}',
    emailAddressUpdatedAndPreAdviceSent:
      'E-mailadressen opdateret og forudanmeldelse sendt for forsendelse-ID: {{shipmentId}}',
    emailAddressUpdatedBulk: 'E-mailadressen er opdateret for {{count}} forsendelse',
    emailAddressUpdatedBulk_other: 'E-mailadressen er opdateret for {{count}} forsendelser',
    emailAddressUpdatedAndPreAdviceSentBulk:
      'E-mailadressen opdateret og forudanmeldelse sendt for {{count}} forsendelse',
    emailAddressUpdatedAndPreAdviceSentBulk_other:
      'E-mailadressen opdateret og forudanmeldelse sendt for {{count}} forsendelser',
    sameEmailAddressAlreadySet: 'Samme e-mailadresse er allerede sat på forsendelsen.',
    manuallyPreAdvicedSuccess: 'Vellykket udløst forudanmeldelse for {{count}} forsendelser',
    nrOfSelected: '{{count}} valgt',
    nrOfSelected_other: '{{count}} valgt',
    sendPreAdvice: 'Send forudanmeldelse',
    unlockPreAdviceSuccess: 'Vellykket låst op for forudanmeldelse for {{count}} forsendelser',
    unlockPreAdviceAndPreAdviceSent: 'Vellykket låst op og sendt forudanmeldelse for {{count}} forsendelser',
    lockPreAdviceSuccess: 'Vellykket låst for forudanmeldelse for {{count}} forsendelser',
    saveAndSendPreAdvice: 'Gem og send forudanmeldelse',
    finishPreAdviceFollowupSuccess: 'Vellykket fjernet {{count}} forsendelser fra forudanmeldelse'
  },
  articles: {
    title: 'Artikler',
    number: 'Artikelnummer',
    name: 'Artikelnavn',
    quantity: 'Antal',
    shipmentArticles: 'Forsendelsens artikler',
    noArticlesPresent: 'Ingen artikler'
  },
  deliveryNote: {
    title: 'Følgeseddel',
    vatNumber: 'Momsnummer',
    orderNumber: 'Ordrenummer',
    sender: 'Afsender',
    receiver: 'Modtager',
    phone: 'Telefon',
    shipmentId: 'Forsendelsesnummer',
    articles: 'Artikler',
    orderDate: 'Bestillingsdato',
    deliveryDate: 'Leveringsdato',
    deliveryTime: 'Leveringstid',
    printedDate: 'Udskriftsdato',
    receiversReference: 'Modtagers reference',
    receiversReferenceNote: 'Brug venligst dette nummer i al kontakt med os',
    articleNumber: 'Nummer',
    articleName: 'Navn',
    articlePrice: 'Enhedspris',
    articleQuantity: 'Antal',
    numberOfPackages: 'Antal pakker',
    totalWeight: 'Samlet vægt',
    totalVolume: 'Samlet volumen',
    print: 'Udskriv følgeseddel'
  },
  coordinates: {
    setCoordinates: 'Indstil koordinater',
    title: 'Indstil koordinater for adresser',
    setCoordinatesCount: 'Indstil koordinater ({{count}})',
    zipCodeRange: 'Postnummerområde',
    goodJob: 'Godt arbejde',
    noUnresolvedShipments: 'Ingen uløste forsendelser fundet for denne afdeling eller afdelingens gruppe',
    coordinateSaved: 'Koordinater blev gemt succesfuldt for {{address}}',
    checkMapProvider: 'Tjek {{name}}',
    noDeliveryDate: 'Ingen leveringsdato',
    created: 'Oprettet',
    withDeliveryDate: 'Med leveringsdato ({{count}})',
    withoutDeliveryDate: 'Uden leveringsdato ({{count}})',
    applyFilter: 'Anvend filter',
    thereAreUnsetCoordinates: 'Du har {{count}} koordinat, der skal indstilles.',
    thereAreUnsetCoordinates_other: 'Du har {{count}} koordinater, der skal indstilles.',
    noCoordinateFound:
      'Vi kunne ikke finde koordinaterne for adressen. Søg efter adressen eller indtast koordinater (f.eks. 59.289976807684084, 18.010318840107406) i søgefeltet.'
  },
  relatedOrders: {
    NONE: 'Ingen relaterede ordrer',
    MULTILEG: 'Multileg',
    PICKUP: 'Afhentning',
    DELIVERY: 'Levering',
    TRANSPORT: 'Transport',
    CUSTOMER: 'Kundeordre'
  },
  vendors: {
    title: 'Leverandører',
    viewDetails: 'Vis detaljer',
    searchLabel: 'Søg efter leverandørnavn, leverandør-ID eller enheds-ID',
    searchVendorPlaceholder: 'Søg efter leverandørnavn eller leverandør-ID',
    searchUnitPlaceholder: 'Søg efter enheds-ID',
    vendorOption: 'Leverandørnavn/ID',
    unitOption: 'Enheds-ID',
    notFound: 'Kunne ikke finde leverandør med valgte søgekriterier',
    initialSearch: 'Søg for at finde leverandører',
    informationAboutTheVendor: 'Information om leverandøren',
    connectUnit: 'Forbind enhed',
    connectUnits: 'Forbind enheder',
    connectedUnits: 'Forbundet enhed ({{count}})',
    connectedUnits_other: 'Forbundne enheder ({{count}})',
    unitsConnected: '{{count}} Forbundet enhed',
    unitsConnected_other: '{{count}} Forbundne enheder',
    unitsConnected_zero: 'Ingen forbundne enheder',
    paymentTerms: 'Betalingsbetingelser',
    connected: 'Forbundet',
    searchForUnitDescription: 'Afdelingen for den valgte enhed vil blive påført omkostningerne.',
    searchForUnitTitle: '{{vendorSite}} for {{operatingUnitName}}',
    successToast: 'Opdaterede forbundne enheder til leverandør {{name}}',
    showConnectedUnits: 'Vis forbundne enheder',
    editConnectedUnits: 'Rediger forbundne enheder',
    searchForUnit: 'Søg efter enhed',
    searchPage: 'Søgeside',
    currencyCode: 'Valutakode',
    connectedToCompany: 'Forbundet til denne virksomhed',
    noConnection: 'Ingen forbindelse',
    connectedTo: 'Tilsluttet til',
    nothingHereYet: 'Intet her endnu',
    emptyStateSelectedVendor: 'Vælg en stedkode for at forbinde enheder eller se eksisterende forbindelser.',
    selfBilling: 'Aflønning',
    setUnitSettingsTitle: 'Opdater enhedsindstillinger for {{name}}',
    setUnitSettingsSelfBillingInternalTrade: 'Aflønning og intern handelstransaktion er aktiv.',
    setUnitSettingsNone: 'Aflønning og intern handelstransaktion er ikke aktiv.',
    setUnitSettingsInternalTrade: 'Aflønning er ikke aktiv, mens intern handelstransaktion er aktiv.',
    state: {
      COMPLETE: 'Komplet',
      INCOMPLETE: 'Ufuldstændig',
      ALL: 'Alle',
      label: 'Vælg leverandørstatus'
    }
  },
  shdAdmin: {
    successfullyDeleted: 'Tidsmatrixen blev slettet',
    successfullyUploaded: 'Tidsmatrixen blev uploadet',
    timeWindowForHomeDelivery: 'Tidsvindue for hjemmelevering',
    filterByCustomerData: 'Søg efter kundens navn, underkunde eller kundenummer',
    uploadTimeMatrixFile: 'Upload tidsmatrixfil',
    downloadExcelTemplate: 'Download Excel-skabelon',
    clickHereOrDragAndDrop: 'Klik her eller træk og slip',
    allowedFormats: 'Tilladte formater er XLS og XLSX',
    existingCustomers: 'Eksisterende kunder med SHD',
    customerPriceTooltip: "Hvis slutkundens pris skal vises, sæt skyderen til 'tændt'",
    deleteModalTitle: 'Slet tidsvinduer',
    deleteModalDescription:
      'Hvis du sletter dette tidsvindue, vil alle SHD-tidsvinduer for denne kunde blive fjernet. Du vil ikke kunne fortryde denne handling.',
    exportToExcel: 'Eksporter til Excel',
    toggleLabel: 'Skift kundens pris',
    customerNumber: 'Kundenummer',
    subCustomer: 'Underkunde',
    customerName: 'Kunde',
    amountOfPostalCodes: 'Antal postnumre',
    lastUpdatedAt: 'Sidst opdateret',
    showCustomerPrice: 'Vis kundens pris',
    uploadMaximumFileSizeLimit: 'Filstørrelsen må ikke være større end {{size}} KB'
  },
  matrix: {
    title: 'Matrix',
    id: 'ID',
    pageTitle: 'Matrixadministration',
    name: 'Navn',
    filename: 'Filnavn',
    uploaded: 'Uploadet',
    uploadedBy: 'Uploadet af',
    downloadTemplate: 'Download skabelon',
    byUser: 'Af bruger',
    country: 'Land',
    ROUTING: 'Routing',
    LINEHAUL: 'Linehaul',
    HUB: 'Hub',
    DELIVERY: 'Levering',
    VAS: 'VAS',
    DEPARTMENT: 'Afdeling',
    CUTOFF: 'Cutoff',
    PARCEL_DELIVERY: 'Pakkelevering',
    parcelDelivery: {
      searchLabel: 'Søg efter postnummer, afdeling eller hub',
      noRouting: 'Ingen routing-rækker i denne matrix endnu'
    },
    terminals: 'Terminaler',
    searchLabel: 'Søg efter navn eller kundenummer',
    bookingLimitsSearchLabel: 'Søg efter terminalnavn',
    'baggage-delivery': 'Bagage',
    baggage: {
      title: 'Bagagematriser',
      name: 'Bagage {{country}}',
      legend: "Hvis du vil opdatere eksisterende bagagematriser, gør du dette ved at vælge 'upload matrixdata'.",
      uploadTitle: 'for {{country}}',
      custom: 'Brugerdefineret DS-kodematris',
      uploadCustomTitle: 'for brugerdefinerede DS-koder',
      status: 'Status',
      uploadFail:
        '{{label}} blev ikke accepteret på grund af forkert information. Ændre oplysningerne og upload matrisen igen.',
      statuses: { accepted: 'Accepteret', pending: 'Afventer', rejected: 'Afvist' }
    },
    cutoff: {
      departments: 'Pakkeafdelinger ({{count}})',
      searchDepartment: 'Søg efter afdeling eller hub',
      hubCount: '{{count}} hub',
      hubCount_other: '{{count}} hubs',
      department: 'Pakkeafdeling',
      selectDepartment: 'Vælg en pakkeafdeling',
      noDepartments: 'Ingen pakkeafdelinger fundet',
      hubName: 'Hubnavn',
      hubId: 'Hub-ID',
      addHub: 'Tilføj hub',
      sameDay: 'Levering samme dag',
      noHubs: 'Der er endnu ingen hubs registreret for denne afdeling',
      saved: 'Cutoff-tiderne blev gemt',
      deleted: 'Hubben blev slettet',
      delete: {
        question: 'Slet {{hubName}}?',
        description: 'Hubben og dens cutoff-tid fjernes fra denne afdeling.'
      },
      unsaved: {
        question: 'Kassér ikke-gemte cutoff-tider?',
        description: 'Dine ændringer i denne afdeling er ikke gemt. Hvis du skifter afdeling, kasseres de.',
        discard: 'Kassér ændringer'
      }
    },
    terminalDetails: {
      details: 'Detaljer',
      alystraDepartmentId: 'Alystra afdelings-ID',
      matrices: 'Matriser',
      type: 'Type',
      noMatrices: 'Denne terminal refereres ikke i nogen matriser',
      aliases: 'Aliasser',
      departmentId: 'Afdelings-ID',
      createdAt: 'Oprettet',
      noAliases: 'Denne terminal har ingen aliasser'
    },
    bookingLimits: {
      title: 'Booking grænser',
      header: '{{name}} - Rediger bookinggrænser',
      rules: '#Regler',
      total: 'Total',
      rank: 'Prioritet',
      customer: 'Kunde',
      customerNo: 'Kundenr.',
      serviceCode: 'Service',
      timeWindow: 'Tidsvindue',
      selectTimeWindow: 'Vælg tidsvindue',
      noTimeWindow: 'Intet tidsvindue',
      noCustomer: 'Ingen kunde',
      bookingLimit: 'Bookinggrænse',
      removeLimit: 'Fjern grænse',
      addMoreLimits: 'Tilføj flere grænser',
      delete: 'Slet bookinggrænser',
      deleteModalDescription: 'Du vil ikke kunne gendanne denne handling',
      deleted: 'Bookinggrænser blev succesfuldt slettet',
      updated: 'Bookinggrænser blev succesfuldt ændret'
    },
    master: 'Master',
    select: 'Vælg {{matrix}} matrix...',
    overflow: '+{{overflow}} mere..',
    vasCodes: 'VAS-koder',
    connectedCustomers: {
      title: 'Forbundne kunder',
      button: 'Se {{connectedCustomers}} forbundne kunder',
      search: 'Søg efter kundens navn eller nummer',
      subcustomer: 'Underkunde'
    },
    upload: {
      success: 'Matrixdata blev succesfuldt uploadet',
      question: 'Upload matrixdata',
      text: 'Upload Excel',
      description: 'Upload Excel-regneark med data for denne matrix',
      error: 'Fejl ved upload af data til {{name}}. {{error}}',
      invalidformat: 'Ugyldigt filformat'
    },
    delete: {
      question: 'Slet matrix {{name}}',
      description: 'Dette kan ikke fortrydes',
      success: 'Matrix {{name}} blev succesfuldt slettet',
      error: 'Fejl ved sletning af {{name}}. {{error}}'
    },
    new: {
      question: 'Opret ny matrix',
      description: 'Opretter en ny matrix',
      success: 'Matrix {{name}} blev succesfuldt oprettet',
      error: 'Fejl ved oprettelse af matrix. {{error}}'
    },
    edit: {
      question: 'Rediger matrix {{name}}',
      error: 'Fejl ved opdatering af {{name}}. {{error}}',
      success: 'Matrix {{name}} blev succesfuldt gemt'
    },
    type: 'Vælg type',
    day: {
      monday: 'Man',
      tuesday: 'Tir',
      wednesday: 'Ons',
      thursday: 'Tor',
      friday: 'Fre',
      saturday: 'Lør',
      sunday: 'Søn'
    },
    leadTime: 'Ledetid',
    terminal: 'Terminal',
    terminalFrom: 'Terminal fra',
    terminalTo: 'Terminal til',
    postalCode: 'Postnummer',
    postalCodeFrom: 'Fra postnummer',
    postalCodeTo: 'Til postnummer',
    offsetDays: 'offsetdage',
    cutoffTime: 'Cutoff-tid',
    city: 'By',
    error: {
      duplicateName: 'Duplikeret navn',
      duplicateServiceCode: 'Bookingbegrænsninger er allerede defineret for denne kombination af kunde og servicekode',
      duplicateTimeWindow: 'Duplikeret tidsvindue'
    }
  },
  serviceMapping: {
    title: 'Tjenester',
    serviceName: 'Tjenestens navn',
    pickupTime: 'Hentetid',
    pickupDuration: 'Afhentningsvarighed',
    pickupPreparation: 'Forberedelse afhentning',
    deliveryTime: 'Leveringstid',
    deliveryDuration: 'Leveringsvarighed',
    deliveryPreparation: 'Forberedelse levering',
    internalName: 'Internt navn',
    internalDescription: 'Intern beskrivelse',
    externalName: 'Eksternt navn',
    externalDescription: 'Ekstern beskrivelse',
    allowFlexDelivery: 'Tillad fleksibel levering',
    timeWindow: 'Tidsvindue',
    serviceMappingType: 'Type',
    serviceLevel: 'Serviceniveau',
    service: 'Tjeneste',
    vas: 'VAS',
    stopsBeforeShowEta: 'ETA Stop',
    minutesUntilDelivery: 'ETA Minutter',
    sendAutomaticEtaSmsHeading: 'ETA SMS',
    createNew: 'Opret ny',
    serviceAndVasCodes: 'Tjenester og VAS-koder',
    successfullyAdded: 'Tjenestekortlægning blev tilføjet til listen',
    successfullyUpdated: 'Tjenestekortlægning blev opdateret',
    successfullyDeleted: 'Tjenestekortlægning blev slettet',
    editService: 'Rediger tjeneste',
    createNewService: 'Opret ny tjeneste',
    settingsHeading: 'Indstillinger for tjeneste eller VAS',
    selectLevel: 'Vælg niveau',
    standardLevel: 'Standard',
    customerLevel: 'Kunde',
    customerSpecific: 'Kunde specifik',
    selectServiceType: 'Vælg tjenestetype',
    vasToolTip: 'Værditilføjet service f.eks. ID-kontrol',
    customerNumber: 'Kundenummer',
    pickupTimeInSeconds: 'Servicetid for afhentning (sekunder)',
    pickupPreparationTime: 'Forberedelsestid for afhentning (sekunder)',
    deliveryTimeInSeconds: 'Servicetid for levering (sekunder)',
    deliveryPreparationTime: 'Forberedelsestid for levering (sekunder)',
    pickupDurationSecondsApartment: 'Hentetid for lejligheder (sekunder)',
    deliveryDurationSecondsApartment: 'Leveringstid for lejligheder (sekunder)',
    deliveryDurationApartmentHeading: 'Leveringstid for lejligheder (pt. kun for H2)',
    timeWindowInMinutes: 'Tidsvindue (minutter)',
    stopsLeftHeading: 'Hvornår vil du have den præcise ETA vist til kunden?',
    stopsLeftDescription: 'Hvis dette felt er tomt, vil tidsvinduet blive vist',
    amountOfStops: 'Antal stop',
    flexibleDelivery: 'Fleksibel levering',
    flexibleDeliveryDescription: 'Tillad modtageren at vælge at pakken bliver leveret udenfor døren',
    flexibleDeliveryCheckboxText: 'Ja, modtageren skal have lov',
    flexOptions: 'Flex-muligheder',
    flexOptionsDescription:
      'Vi tilbyder kunderne to forskellige Flex-leveringsmuligheder. Den første mulighed, Udvidet Flex, giver chaufføren lov til at efterlade varerne på forskellige aftalte steder på leveringsadressen. Den anden mulighed, Flex, er et enklere alternativ, hvor varerne kun placeres ved ejendomsgrænsen. Udvidet Flex er standardindstillingen, men kunderne kan vælge at skifte til den enklere Flex-mulighed, hvis de foretrækker det.',
    unattendedFlex: 'Flex (Uovervåget)',
    extendedFlex: 'Udvidet Flex (Flex)',
    linkTextToService: 'Link tekst til tjeneste',
    linkTextToServiceDescription: 'Hvis der ikke er valgt tekst, vil standardteksten blive brugt',
    defaultText: 'Standard tekst',
    listOfServicesAndVases: 'Liste over tjenester og VAS-koder',
    searchService: 'Søg efter tjeneste, VAS eller kundenummer',
    customizedText: 'Tilpasset tekst',
    deleteModalTitle: 'Slet tjenestekortlægning',
    deleteModalDescription: 'Denne handling kan ikke fortrydes',
    infoModal: {
      title: 'Hvad vises hvor i Glow',
      subHeading1: 'Planlæggere og chauffører',
      description1: 'Internt navn: Navnet på tjenesten, f.eks. "Hjemmelevering"',
      description2:
        'Intern beskrivelse: Udvidet information om tjenesten, f.eks. "Denne skal bæres ind i modtagerens valgte rum."',
      subHeading2: 'Kunder og modtagere',
      description3: 'Eksternt navn: Navnet på tjenesten, f.eks. "Hjemmelevering"',
      description4:
        'Ekstern beskrivelse: Udvidet information om tjenesten, f.eks. "Dine varer vil blive leveret til et værelse, du vælger".'
    },
    routeOptimizing: 'Ruteplanlægning',
    routeOptimizingDescription:
      'De oplysninger, du angiver her, vil tilsidesætte standardtiden og påvirke ruteoptimeringen. Forberedelsestid kan bruges til tjenester, hvor mange forsendelser leveres til samme modtager. Den første forsendelse vil da have en leveringstid, der svarer til forberedelsestiden plus leveringstiden, mens yderligere forsendelser til samme modtager kun vil have en leveringstid svarende til leveringstiden. <br><br>Standardopsætning for afhentninger er 15 sekunders forberedelsestid og 1 sekund pr. forsendelse.<br>Standardopsætning for leveringer er 180 sekunders forberedelsestid og 10 sekunder pr. forsendelse.<br><strong>Bemærk venligst, at der kan gå op til 10 minutter, før eventuelle ændringer vises i systemet.</strong>',
    settingsRecipientTrackingPage: 'Modtager sporingsside',
    etaComponentHeading: 'Vis præcis ETA på modtagers side',
    etaComponentDescription:
      'Ved at aktivere dette vil du have mulighed for at vælge, hvornår den præcise ETA skal vises for modtageren i stedet for tidsvinduet.',
    displayExactEta: 'Ja, vis præcis ETA',
    stopsLeftSelected: 'Antal stop tilbage til levering',
    minutesLeftSelected: 'Antal minutter tilbage til levering',
    numberOfMinutes: 'Antal minutter',
    numberOfStops: 'Antal stop',
    sendAutomaticEtaSmsTitle: 'Send automatisk SMS til modtageren',
    sendAutomaticEtaSmsDescription:
      'Ved at aktivere dette vil funktionen for chaufføren at sende SMS fra chaufførappen også blive deaktiveret.',
    sendAutomaticEtaSms: 'Send SMS automatisk',
    missingNumberOfStops: 'Angiv venligst et gyldigt antal stop, når "Send SMS automatisk" er valgt',
    missingNumberOfMinutes: 'Angiv venligst et gyldigt antal minutter, når "Send SMS automatisk" er valgt',
    minutesNotInRange: 'Angiv venligst et antal minutter mellem {{from}} og {{to}}',
    serviceDeliveryType: 'Tjeneste leverings type',
    noServiceDeliveryTypeSelected: 'Ikke valgt',
    serviceDeliveryTypes: { Delivery: 'Levering', Return: 'Retur', PickupPoint: 'Hentepunkt' },
    Delivery: 'Levering',
    Pickup: 'Opsamling',
    Return: 'Retur',
    PickupPoint: 'Hentepunkt',
    courierApp: 'Kurerapp',
    allowCourierDescription: 'Tillad kurer at acceptere eller afvise forsendelser med denne tjenestekode',
    allowCourierCheckbox: 'Ja, kurer skal have lov',
    none: 'Ingen'
  },
  shipmentDetailsBilling: {
    finanicalStakeholder: 'Finansielle interessenter',
    item: 'Vareart',
    customerTotal: 'Kundens total',
    unitTotal: 'Enhedstotal',
    orderTotal: 'Ordretotal',
    disconnectToOrginalOrder: 'Afbryd fra oprindeligt forsendelsesnummer'
  },
  upsalesRulesAdmin: {
    title: 'Mersalgsregler',
    titleSingular: 'Opsalgsregel',
    name: 'Navn',
    type: 'Type',
    searchPlaceholder: 'Søg i opsalgsregler',
    settings: 'Indstillinger',
    successfullyAdded: '{{name}} blev tilføjet til listen',
    successfullyUpdated: '{{name}} blev opdateret',
    createNewRule: 'Opret ny regel for mersalg',
    edit: 'Rediger',
    serviceUpgrade: 'Serviceopgradering',
    SERVICE_UPGRADE: '$t(upsalesRulesAdmin.serviceUpgrade)',
    shorterTimeWindow: 'Kortere tidsvindue',
    SHORTER_TIME_WINDOW: '$t(upsalesRulesAdmin.shorterTimeWindow)',
    ruleName: 'Navn på mersalgsregel',
    serviceUpgradeDescription1: 'Servicen opgraderes fra 3123 til 2870.',
    serviceUpgradeDescription2:
      'VAS 1381 vil automatisk blive tilføjet for at sikre, at chaufføren får korrekt betaling.',
    zipCodeRangeTitle: 'Postnummer',
    zipCodeRangeDescription:
      'Vælg de postnumre, du vil inkludere eller ekskludere i reglen. Hvis du skal fjerne et specifikt postnummer eller et område fra et inkluderet område, skal du bruge eksklusionsmuligheden til at finjustere dit valg.',
    fromZipCode: 'Postnummer fra',
    toZipCode: 'Postnummer til',
    addRange: 'Tilføj postnummerrækkevidde',
    addZipCode: 'Tilføj postnummer',
    noZipCodeRangesAdded: 'Du skal angive et postnummerrækkevidde',
    zipCodeRangeError: '"Postnummer fra" må ikke være større end "Postnummer til"',
    deleteModalTitle: 'Slet mersalgsregel',
    deleteModalDescription: 'Du vil ikke kunne fortryde denne handling',
    successfullyDeleted: 'Mersalgsregel blev slettet',
    shorterTimeWindowDescription1: 'Kortere tidsvindue er tilgængeligt for 3332',
    windowOnlyInEvening: 'Kortere tidsvindue skal kun være tilgængeligt om aftenen',
    timeWindowOffer: 'Hvilket tidsvindue skal tilbydes modtageren?',
    oneHour: '1 time',
    twoHours: '2 timer',
    threeHours: '3 timer',
    mustSelectTimeWindow: 'Du skal angive det tidsvindue, der tilbydes modtageren',
    include: 'Inkluder',
    exclude: 'Ekskluder',
    zipCodeRangeType: 'Type',
    exactZipCode: 'Præcis',
    zipCodeRange: 'Rækkevidde',
    zipCode: 'Postnummer',
    mustSelectCountry: 'Du skal vælge et land først',
    includedZipCodes: 'Inkluderede postnumre ({{count}})',
    excludedZipCodes: 'Ekskluderede postnumre ({{count}})',
    noZipCodesAddedYet: 'Ingen postnumre tilføjet endnu',
    noMatchOnZipCodeSearch: 'Intet postnummer fundet. Prøv at filtrere med et andet postnummerområde.',
    zipCodesFound: '{{count}} postnummer fundet',
    zipCodesFound_other: '{{count}} postnumre fundet',
    filterOnDepartments: 'Filtrér på afdelinger',
    UPSALES_RULE_COLLISION_OCCURRED:
      'Reglen eksisterer allerede! Fjern venligst enten følgende afdelinger: {{departments}} eller følgende kunder: {{customers}}',
    status: 'Status',
    active: 'Aktiv',
    paused: 'Sat på pause',
    pauseRule: 'Pause regel',
    activateRule: 'Aktiver regel',
    activateRuleModalDescription:
      'Du er ved at aktivere reglen. Dette betyder, at opsalg vil være tilgængeligt for modtagerne. Ønsker du at fortsætte?',
    pauseRuleModalDescription:
      'Du er ved at sætte reglen på pause. Dette betyder, at opsalg ikke vil være tilgængeligt for modtagerne. Ønsker du at fortsætte?',
    successfullyActivated: 'Opsalgsreglen blev aktiveret',
    successfullyPaused: 'Opsalgsreglen blev sat på pause'
  },
  billingOrder: {
    create: 'Opret faktureringsordre',
    copyTo: 'Kopier til faktureringsordre',
    copyToBillingOrder: 'Kopier til faktureringsordre',
    keepConnection: 'Behold forbindelse',
    disconnect: 'Afbryd forbindelse',
    creditMode: 'Kredit',
    debitMode: 'Debet',
    createCredit: 'Opret kreditnota',
    credit: 'Kreditnota',
    done: 'Faktureringsordre blev oprettet. Forsendelse-ID: {{shipmentId}}',
    invalidOrderForEdit:
      'Denne ordre kan ikke redigeres. Kun fakturerings- eller kreditordrer, der ikke er faktureret, kan redigeres.',
    cannotBeCredited: 'Du kan ikke kreditere en ordre, der er faktureret i {{systemId}}.',
    invalidOrderForCopy: 'Kan ikke kopiere kreditnota.',
    standaloneInvoice: 'Separat faktura',
    standaloneInvoiceLabel:
      'Jeg vil have, at denne ordre behandles individuelt og ikke grupperes med andre ordrer til fakturering.',
    noUnitNotSelfBilled: 'Ordrer uden enhed vil ikke blive afregnet.',
    manualInvoiceInformation: {
      label: 'Manuel fakturahåndtering',
      descriptionText: 'Hvis dette felt er udfyldt med faktureringsinstruktioner, faktureres ordren ikke automatisk'
    },
    expensive: 'Den indtastede pris ser ud til at være usædvanligt høj',
    creditInvoiceText: 'Kreditering for forsendelse {{shipmentId}}',
    creditInvoiceLegText: {
      CUSTOMER_ORDER: 'Kundekreditering for forsendelse {{shipmentId}}',
      PICKUP_LEG: 'Kreditering for afhentning af forsendelse {{shipmentId}}',
      DELIVERY_LEG: 'Kreditering for levering af forsendelse {{shipmentId}}'
    },
    legSelectionLabel: 'Vælg transportben',
    legSelectionError: 'Vælg hvilket transportben der skal krediteres',
    legSelection: {
      NONE: 'Ingen',
      CUSTOMER_ORDER: 'Kundeordre',
      PICKUP_LEG: 'Afhentning',
      DELIVERY_LEG: 'Levering'
    },
    wrongPageWarning: 'Faktureringsordrer kan ikke tilgås fra denne side',
    wrongPageLink: 'Gå til siden med faktureringsordre-detaljer',
    type: {
      Invoice: 'Fakturaordre',
      Invoice_other: 'Fakturaordrer',
      Credit: 'Kreditnota',
      Credit_other: 'Kreditnotaer',
      InternalTrade: 'Intern handelsordre',
      InternalTrade_other: 'Interne handelsordrer'
    }
  },
  welcomeToGlowWithName: 'Velkommen til Glow, {{name}}!',
  welcomeToGlowDescription: 'Brug navigeringen til venstre for at starte dit arbejde!',
  glowGlobeImage: 'Glow globusbillede',
  latestUpdatesHere: 'Her er de seneste opdateringer',
  formValidation: {
    mustProvideName: 'Du skal angive et navn',
    mustProvideDescription: 'Du skal angive en beskrivelse',
    mustProvideServiceCode: 'Du skal angive en servicekode',
    mustProvideCalendarDays: 'Du skal angive kalenderdage',
    mustProvideCutOffTime: 'Du skal angive en fristtid',
    mustProvideCutOffMinutes: 'Du skal angive fristminutter',
    mustProvideDeliveryAttempts: 'Du skal angive antal leveringsforsøg',
    mustProvideCustomer: 'Du skal angive en kunde',
    mustProvideQuantity: 'Du skal angive en mængde',
    mustProvideArticle: 'Du skal angive en artikel',
    mustProvideDate: 'Du skal angive en dato',
    mustProvideTime: 'Du skal angive et tidspunkt',
    mustProvideDuration: 'Du skal angive en varighed',
    mustProvideCustomerOrUnitAmount: 'Du skal angive kunde- eller enhedsmængde',
    allowedRangeIs: 'Tilladt interval er {{min}} - {{max}}'
  },
  units: {
    title: 'Enheder',
    new: 'Opret ny enhed',
    connectFromOtherDepartments: 'Forbind fra andre afdelinger',
    connect: {
      title: 'Forbind enheder til den nuværende afdeling',
      description: 'Du kan kun søge efter enheder i afdelinger, du har adgang til',
      selected: 'Valgte enheder',
      noneSelected: 'Ingen enheder',
      submit: 'Forbind'
    },
    assigned: 'Enhed(er) blev forbundet'
  },
  productionTimeWindow: {
    addNew: 'Tilføj nyt produktionstidsvindue',
    search: 'Søg efter produktionstidsvinduer',
    description:
      'Her kan du oprette et produktionstidsvindue for ordrer, der har et modtager-ID. Du kan søge på modtager-ID eller postnummerinterval - ved søgning på postnummerinterval skal du også vælge land. For at tilføje et produktionstidsvindue, klik på "Tilføj nyt" eller søg et eksisterende op for at redigere.',
    addNewDescription:
      'Tilføj et tidsvindue for, hvornår vi kan levere pakker til et modtager-ID. Hvis produktionstidsvinduet er tilføjet, vil disse oplysninger blive brugt ved rutelægning i stedet for servicetidsvinduet.',
    recipientId: 'Modtager-ID',
    searchForRecipientId: 'Søg efter modtager-ID',
    recipientName: 'Modtagernavn',
    address: 'Adresse',
    postalCode: 'Postnummer',
    country: 'Land',
    selectCountry: 'Vælg land',
    addedSuccess: 'Produktionstidsvindue for {{recipientId}} blev tilføjet.',
    recipientIdValidation: 'Du skal angive modtager ID',
    timeWindowValidation: 'Du skal angive et tidsrum',
    invalidRecipientId: 'Ugyldigt modtager-ID',
    postalCodeRangeRequiredTogether: 'Postnummer fra og til skal begge udfyldes',
    postalCodeRangeRequiresCountry: 'Vælg et land for at søge på postnummerinterval',
    createdAt: 'Oprettet den',
    from: 'Fra',
    to: 'Til',
    editSuccess: 'Tidsvinduet for {{recipientId}} blev opdateret',
    delete: 'Slette produktionstidsvindu for {{recipientId}}?',
    deleteDescription:
      'Hvis du sletter dette produktionstidsvindue, vil servicetidsvinduet blive brugt ved rutelægning for dette modtager-ID. Ønsker du at fortsætte?',
    deleteSuccess: 'Produktionstidsvindue for {{recipientId}} blev slettet med succes.',
    noResults: 'Intet produktionstidsvindue fundet',
    noResultsDescription:
      'Prøv at søge med et andet modtager-ID, eller søg på postnummerinterval i stedet. Du kan også oprette et nyt produktionstidsvindue ved at trykke på knappen i øverste højre hjørne.',
    noResultsPostalCodeDescription:
      'Intet produktionstidsvindue matcher dette postnummerinterval. Prøv at søge på modtager-ID uden postnummerinterval i stedet.',
    fromTimeAfterToTime: "'Fra'-tidspunktet skal være før 'til'-tidspunktet"
  },
  loadCarrierModal: {
    title: 'Lastbærergruppe: {{loadCarrierId}}',
    description: 'Forsendelser i gruppen'
  },
  routesOverview: {
    palletRuleOverridden: 'Palleregel tilsidesat',
    routeNotFoundTitle: 'Ruten blev ikke fundet',
    routeNotFoundDescription: 'Den kan være slettet.',
    shipmentStatus: {
      CREATED: 'Oprettet',
      ASSIGNED: 'Tildelt',
      UNASSIGNED: 'Ikke tildelt',
      COLLECTED: 'Opsamlet',
      DELIVERED: 'Leveret',
      DEVIATED: 'Afveget',
      COMMENT: 'Kommentar',
      RESOLVED: 'Løst',
      UNRESOLVED: 'Uløst',
      OFFERED: 'Tilbudt',
      REJECTED: 'Afvist',
      ACCEPTED: 'Accepteret',
      RETURNED: 'Returneret',
      DELETED: 'Slettet',
      UNCONFIRMED: 'Ubekræftet',
      REFUSED: 'Afvist'
    },
    offeredAtTime: 'Ordre tilbudt kl. {{time}}',
    plannedRoute: 'Planlagt rute',
    routes: 'Ruter',
    routesCount: '{{filtered}} af {{total}} ruter',
    searchRouteOrDriver: 'Søg efter rutens navn eller chaufførens navn',
    manuallyAdjustRoute: 'Juster ruten manuelt',
    changeRoute: 'Skift rute',
    plannedRouteTime: 'Planlagt rutetid',
    notOptimized: {
      title: 'Ruten er ikke optimeret',
      optimizationFailed:
        'Ruteoptimeringen fejlede, så ruten bruger en ikke-optimeret fallback. ETA og ETD er ikke tilgængelige.',
      manuallyPlanned: 'Ruten blev planlagt manuelt uden optimering, så ETA og ETD er ikke tilgængelige.'
    },
    statusOfRoute: 'Rutestatus',
    incorrectETA: 'Modtagerens sporingsside viser forkerte ETA‑tider',
    adjustedFinishTime: 'Justeret tid for sidste levering: {{time}}',
    driverIsDelayed: 'Chaufføren er {{delayed}} min {{suffix}}.',
    deviations: '{{count}} afvigelse',
    deviations_other: '{{count}} afvigelser',
    successfullyDeleted: '{{name}} blev slettet med succes',
    successfullyReversedDeliveryOrder: 'Leveringsrækkefølgen blev vendt med succes',
    colorPicker: 'Farvevælger',
    deleteAllRoutesConfirmDialogText: 'Er du sikker på, at du vil slette alle ruter?',
    stops: 'Stop',
    stop: 'Stop',
    waitingTime: 'Ventetid',
    totalWaitingTime: 'Samlet ventetid',
    stopsAfterPlannedEndTime: '{{count}} levering efter planlagt rutetid ({{time}}).',
    stopsAfterPlannedEndTime_other: '{{count}} leveringer efter planlagt rutetid ({{time}}).',
    unassignShipmentFromRoute: 'Fjern forsendelse fra ruten',
    unassign: 'Fjern',
    priceInformation: 'Prisoplysninger',
    billingOrderShipment: 'Faktureringsordre',
    trips: 'Ture',
    routeSettings: 'Ruteindstillinger',
    driverPhoneNumber: 'Chaufførens telefonnummer',
    selectVehicle: 'Vælg køretøj',
    nameOfRoute: 'Rutenavn',
    setStartTime: 'Angiv starttid',
    setEndDate: 'Slutdato',
    setEndTime: 'Angiv sluttid',
    endDateValidationError: 'Slutdato skal være rutedatoen eller dagen efter',
    endTimeValidationError: 'Sluttid skal være efter starttid',
    addMapArea: 'Tilføj kortområde',
    editMapArea: 'Rediger kortområde',
    areaWasUpdated: 'Kortområde på {{name}} blev opdateret med succes',
    areaWasCreated: 'Kortområde tilføjet til {{name}} med succes',
    areaWasDeleted: 'Kortområde slettet fra {{name}} med succes',
    addAreaRoute: 'Tilføj område til rute',
    updateAreaRoute: 'Opdater område for rute',
    deleteMapArea: 'Slet kortområde',
    templates: 'Skabeloner',
    loadTemplate: 'Indlæs skabelon',
    deleteTemplate: 'Slet skabelon',
    saveAsTemplate: 'Gem som skabelon',
    saveTemplate: 'Gem skabelon',
    templateWasCreated: '{{name}} blev oprettet med succes',
    templateWasLoaded: '{{name}} blev indlæst med succes',
    templateWasDeleted: '{{name}} blev slettet med succes',
    loadTemplateSubHeading: 'Vælg den skabelon du vil tilføje.',
    createANew: 'Opret ny',
    orUpdateExisting: 'eller opdatér eksisterende',
    saveTemplateRulesNote:
      'Kun postnumre, der er tilknyttet en ruteregel, tages med i skabelonen. Selvstændige postnumre gemmes ikke.',
    saveTemplateDepartmentGroupNote:
      'Denne visning omfatter flere afdelinger. Ruteregler fra andre afdelinger tages ikke med i denne skabelon.',
    deleteTemplateSubHeading: 'Vælg den skabelon du vil slette.',
    defaultTemplate: 'Standard skabelon',
    defaultTemplateSubHeading:
      'Vælg den skabelon, du vil bruge som standard. Denne skabelon kan derefter bruges til automatisk oprettelse af ruter, som aktiveres i sektionen Afdelinger under Administration.',
    setDefaultTemplates: 'Indstil standard skabelon',
    selectDefaultTemplate: 'Vælg standard skabelon for {{department}}',
    defaultTemplates: 'Standard skabeloner',
    normalTemplates: 'Normale skabeloner',
    templateDefaultsSet: 'Standard skabeloner sat',
    selectTemplate: 'Vælg skabelon',
    selectTemplateToOverride: 'Vælg skabelon der skal tilsidesættes',
    nameOfTemplate: 'Navn på skabelon',
    templateIsRequired: 'Skabelon skal vælges',
    templateOrNameIsRequired: 'Skabelon eller navn skal vælges',
    areYouDonePlanning: 'Er du færdig med ruteplanlægningen',
    noBackPage: 'Nej, tilbage til siden',
    yesDone: 'Ja, jeg er færdig',
    manageRouteRules: 'Administrer ruteregler',
    eligibleForAutoDispatch: 'Kvalificeret til auto-dispatch af afhentningsordrer',
    postalCodeRangesSet: 'Postnummerområder er sat',
    unsavedPostalCodeRule: 'Tilføj postnummerreglen før du gemmer',
    applyToConnectedRule: 'Anvend disse ændringer på den tilknyttede ruteregel "{{name}}"',
    serviceExclusionDescription: 'Ordrer med en af disse servicekoder tildeles aldrig denne rute af auto-dispatch.',
    postalCodeRulesSaved: 'Postnummerreglerne blev opdateret med succes',
    postalCodeRulesSavedAndApplied: 'Postnummerreglerne blev opdateret med succes og også anvendt på reglen "{{name}}"',
    postalCodesTab: 'Postnumre',
    routeRuleTab: 'Ruteregel',
    connectRouteRuleSubHeading:
      'Tilknyt en ruteregel til denne rute. Postnummerreglerne på ruten overskrives med reglerne fra den valgte ruteregel.',
    selectRouteRule: 'Vælg ruteregel',
    routeRuleIsRequired: 'Ruteregel skal vælges',
    routeRuleConnected: 'Postnummerreglerne blev overskrevet fra ruteregelen "{{name}}"',
    postalCodeRuleType: 'Regeltype',
    includePostalCodes: 'Inkluder',
    excludePostalCodes: 'Ekskluder',
    postalCodeRange: 'Interval',
    exactPostalCode: 'Eksakt postnummer',
    postalCodeFrom: 'Fra postnummer',
    postalCodeTo: 'Til postnummer',
    addPostalCodeRule: 'Tilføj postnummerregel',
    noPostalCodeRules: 'Ingen tilføjet endnu',
    savedPostalCodeRules: 'Gemte postnummerregler',
    postalCodeRuleRequired: 'Postnummer er påkrævet',
    postalCodeRuleConflict: {
      duplicate: 'Denne postnummerregel findes allerede',
      overlap: 'Reglen overlapper den eksisterende regel "{{rule}}"',
      excludeNotContained: 'Ekskluderingsreglen "{{rule}}" skal være inden for et inkluderingsinterval',
      excludeCoversInclude: 'En ekskluderingsregel kan ikke dække hele inkluderingsintervallet "{{rule}}"'
    },
    skipAutoDispatch: 'Deaktivér auto-dispatch',
    enableAutoDispatch: 'Aktivér auto-dispatch',
    skipAutoDispatchSuccess: '{{name}} blev deaktiveret for auto-dispatch med succes',
    enableAutoDispatchSuccess: '{{name}} blev aktiveret til auto-dispatch med succes',
    completedRoute: '{{name}} er fuldført',
    routeCreatedMessage: 'Ruten blev gemt og tilføjet til ruteoversigten',
    createRoute: 'Opret rute',
    saveAndCreateRoute: 'Gem og opret ny rute',
    routeWasDeleted: 'Ruten blev slettet med succes',
    routeWasUpdated: 'Ruten blev opdateret med succes',
    routeWasUpdated_other: 'Ruterne blev opdateret med succes',
    routeWasDeleted_other: 'Ruterne blev slettet med succes',
    sendPrePickupSms: 'Send forudgående sporings‑SMS',
    deleteAllRoutes: 'Slet alle ruter',
    routesNotStarted: 'Ruter ikke startet',
    noRoutes: 'Ingen ruter oprettet endnu',
    viewStopsGrouped: 'Gruppér stop',
    showCompletedDeliveries: 'Vis fuldførte',
    showRemainingDeliveries: 'Vis resterende',
    orders: 'Ordrer',
    onlyUnaccepted: 'kun ikke-accepterede',
    onlyRoutesWithUnacceptedOrders: 'Vis kun ruter med ikke-accepterede ordrer',
    activeFilters: 'Aktive filtre',
    clearFilters: 'Ryd filter',
    clearSearch: 'Ryd søgning',
    removeFilter: 'Fjern filteret {{name}}',
    selectedCount: '{{count}} valgt',
    selectedCount_other: '{{count}} valgt',
    selectedCount_zero: 'ingen valgt',
    routeState: 'Rutetilstand',
    routeLabels: 'Ruteetiketter',
    state: 'Tilstand',
    routeNameAZ: 'Rutenavn A–Å',
    routeNameZA: 'Rutenavn Å–A',
    routeStartedAZ: 'Rute startet A-Å',
    routeNotStartedAZ: 'Rute ikke startet A-Å',
    deletePlannedStopFromSlot: 'Slet planlagt stop fra slot',
    deleteBreakFromSlot: 'Slet pausetid fra slot',
    plannedStopDeletedFromSlot: 'Planlagt stop blev slettet fra slot',
    movedOrderToRouteSuccess: 'Ordre blev flyttet til rute {{routeName}}',
    movedOrderToRouteSuccess_other: '{{count}} ordrer blev flyttet til rute {{routeName}}',
    moveOrderToRouteQuestion: 'Flyt ordre til rute {{routeName}}?',
    moveOrderToRouteQuestion_other: 'Flyt {{count}} ordrer til rute {{routeName}}?',
    couldNotMoveOrderToRoute: 'Kunne ikke flytte ordre til rute {{routeName}}',
    failedToOptimizeSlotAfterDeletingPlannedStop: 'Kunne ikke optimere ruten efter sletning af planlagt stop',
    actionsForAllShipments: 'Handlinger for alle forsendelser',
    removePlannedStopFromRouteAndReoptimize:
      'Det planlagte stop vil blive fjernet fra ruten, og ruten vil automatisk blive re-optimeret.',
    unassignShipmentFromRouteAndReoptimize:
      'Forsendelsen vil blive fjernet fra ruten og ruten vil automatisk blive re-optimeret.',
    unassignShipmentFromRouteAndReoptimize_other:
      'Forsendelserne vil blive fjernet fra ruten og ruten vil automatisk blive re-optimeret.',
    quickEditDisabledTooltip: 'Du mangler adgang til afdelingen for denne ordre.',
    routeLabel: 'Ruteetiket',
    selectRouteLabel: 'Vælg ruteetiket',
    labelFilter: {
      title: 'Filtrer ruter efter etiket',
      description:
        'Denne afdeling har ruteetiketter. Vælg en eller flere etiketter for at begrænse hvilke ruter der vises.',
      selectLabels: 'Vælg etiketter',
      apply: 'Anvend filter',
      showAll: 'Vis alle ruter',
      or: 'ELLER',
      and: 'OG'
    },
    mustSelectVehicle: 'Du skal vælge et køretøj'
  },
  reports: {
    serviceTimeWindow: 'Leveret inden for servicetidsvindue',
    estimatedTimeWindow: 'Leveret inden for estimeret tid',
    correctLocation: 'Leveret på korrekt lokation',
    withinSTW: 'Inden for STW',
    withinETD: 'Inden for ETD',
    withinPAW: 'Inden for PAW',
    followedRoutes: 'Fulgte ruter',
    departmentTitle: 'Rapporter for {{name}}',
    serviceWindow: 'Servicevindue',
    estimatedWindow: 'Estimeret vindue',
    quality: 'Kvalitet',
    scrollToStop: 'Rul til stop',
    stopGraphLabel: 'Stopdata',
    hiddenStopsTooltip: 'Denne graf indeholder skjulte stop. Klik for at se hvilke stop',
    graphContainsHiddenStops: 'Denne graf indeholder skjulte stop',
    stopWasHiddenDueToDeliveryDateSetTo: 'Stop {{stopNumber}} blev skjult fordi leveringsdato var {{date}}',
    stopWasHiddenDueToDeliveryDateNotSet: 'Stop {{stopNumber}} blev skjult fordi det ikke blev afsluttet',
    productionAccuracy: 'Produktionsvindue',
    productionAccuracyTimeWindow: 'Leveret inden for produktionsvinduet',
    actualStop: 'Faktisk stoprækkefølge',
    plannedStop: 'Planlagt stoprækkefølge',
    serviceTimeWindowTooltip: '{{number}} stop blev leveret inden for servicetidsvinduet.',
    estimatedTimeWindowTooltip: '{{number}} stop blev leveret inden for det estimerede tidsvindue.',
    correctLocationTooltip: '{{number}} stop blev leveret til den korrekte lokation.',
    followedRoutesTooltipStops: '{{number}} stop blev gennemført i den korrekte rækkefølge.',
    followedRoutesTooltipOrders: '{{number}} ordrer blev leveret i den korrekte rækkefølge.',
    productionAccuracyTooltip: '{{number}} stop der blev leveret inden for produktionsvinduet.'
  },
  settings: {
    profile: 'Profil',
    departmentsSaved: 'Dine afdelinger blev gemt'
  },
  iamOnboarding: {
    description:
      'Det ser ud til, at du ikke har nogen afdelinger tilknyttet din konto endnu. Du kan tilføje de afdelinger, du har brug for adgang til, via Indstillinger i menuen til venstre.',
    goToSettings: 'Gå til Indstillinger'
  },
  iamMigrationModal: {
    title: 'Handling påkrævet: ansøg om Glow One Identity-rollen',
    body: 'Som Posten & Bring-medarbejder skal du nu have rollen nedenfor for at logge ind i Glow. Ansøg om denne rolle i One Identity.',
    instructions:
      'Gå til <a>{{iamUrl}}</a> og ansøg om rollen. Når din ansøgning er godkendt, kan du logge ind i Glow med din Posten-konto.',
    roleLabel: 'Rolle der skal ansøges om',
    copyRole: 'Kopiér rollenavn',
    copied: 'Kopieret',
    applyForRole: 'Ansøg om rollen',
    confirmCheckbox: 'Jeg bekræfter, at jeg har ansøgt om rollen F_APP_S55475-GLOW_USR',
    confirm: 'Fortsæt'
  }
}
export default dk
